(function () {
  let previousState = history.state;
  let previousUrl = window.location.pathname;

  const overrideMethod = (methodName) => {
    const originalMethod = history[methodName];
    history[methodName] = function (state, title, url) {
      originalMethod.call(this, state, title, url);
      window.dispatchEvent(
        new CustomEvent('pageChanged', {
          detail: {
            state,
            previousState,
            previousUrl,
            url,
          },
        })
      );
      previousState = state;
      previousUrl = url;
    };
  };

  overrideMethod('pushState');
  // overrideMethod('replaceState');

  const EXCLUSIVE_OFFERS_TYPES = [1000, 500];
  let idCounter = 0;
  const urlParams = new URLSearchParams(window.location.search);
  const getAndSetParam = (name) => {
    const param = urlParams.get(name);
    if (param) {
      setLocalStorage(name, param);
      return param;
    }
    return getLocalStorage(name);
  };

  function ExclusiveOffers() {
    this.types = EXCLUSIVE_OFFERS_TYPES;
    this.cache = null;
    this.loading = false;
    this.selected = this.types[0];
    this.outOfSurveys = new Map();
    this.isLoading = () => {
      return this.loading;
    };
    this.startedLoading = () => {
      this.loading = true;
    };
    this.finishedLoading = () => {
      this.loading = false;
    };
    this.getCache = () => {
      return this.cache;
    };
    this.resetCache = () => {
      this.cache = null;
    };
    this.setCache = (data) => {
      this.cache = data;
    };
    this.isOutOfSurveys = (type) => {
      return this.outOfSurveys.get(type);
    };
    this.isAllOutOfSurveys = () => {
      for (let type of this.types) {
        if (!this.isOutOfSurveys(type)) return false;
      }
      return true;
    };
    this.resetOutOfSurveys = () => {
      this.types.forEach((type) => this.outOfSurveys.set(type, false));
    };
    this.setOutOfSurveys = (type, bool) => {
      this.outOfSurveys.set(type, bool);
    };
    this.getSelected = () => {
      return this.selected;
    };
    this.setSelected = (type) => {
      this.selected = type;
    };
    this.setInitialized = () => {
      this.initialized = true;
    };
    this.isInitialized = () => {
      return this.initialized ? true : false;
    };

    this.resetOutOfSurveys();
  }

  function getUTM() {
    const source = getAndSetParam('utm_source');
    const medium = getAndSetParam('utm_medium');
    const campaign = getAndSetParam('utm_campaign');
    const content = getAndSetParam('utm_content');
    const term = getAndSetParam('utm_term');

    return {
      source,
      medium,
      campaign,
      content,
      term,
    };
  }

  const cacheAppSource = (source) => {
    // TODO: (PG-595): Temporary solution - Remove after ios_v2 is re-enabled
    // This mapping ensures compatibility while ios_v2 feature is disabled
    const updatedSource = source === 'ios_v2' ? 'ios' : source;

    document.cookie = `app_source=${updatedSource};path=/;max-age=604800`; // 7 days
    setSessionStorage('app_source', updatedSource);
    return updatedSource;
  };

  const getCatchedAppSource = () => {
    return getSessionStorage('app_source');
  };

  function getAppSource() {
    const source = urlParams.get('app');
    if (source) {
      return cacheAppSource(source);
    }
    // backwards compability
    const utmSource = urlParams.get('utm_source');
    if (utmSource === 'pwa') {
      return cacheAppSource('web');
    }
    if (utmSource === 'twa') {
      return cacheAppSource('android');
    }
    return getCatchedAppSource();
  }

  const App = {
    exclusiveOffers: new ExclusiveOffers(),
    utils: {
      capitalizeFirst(word) {
        if (!word) return;
        return word.charAt(0).toUpperCase() + word.slice(1);
      },
      isoToLocalTime(iso) {
        function checkTime(i) {
          if (i < 10) {
            i = '0' + i;
          }
          return i;
        }

        let d = new Date(iso);
        let h = checkTime(d.getHours());
        let m = checkTime(d.getMinutes());
        return `${h}:${m}`;
      },
      timeSince(dateOrIso) {
        const msgTimestamp = new Date(dateOrIso);
        const msgTimestampDate = new Date(dateOrIso).setHours(0, 0, 0, 0);
        const now = new Date().setHours(0, 0, 0, 0);

        if (msgTimestampDate < now) {
          const formattedTime = msgTimestamp.toLocaleString('en-US', {
            dateStyle: 'medium',
            timeStyle: 'short',
          });
          return formattedTime;
        } else {
          const formattedTime = msgTimestamp.toLocaleString('en-US', { timeStyle: 'short' });
          return formattedTime;
        }
      },
      formatNumber(num, numOfDigits = 2) {
        return num.toFixed(numOfDigits).replace(/\B(?=(\d{3})+(?!\d))/g, ',');
      },
      isEmailValid(email) {
        if (!email) {
          return false;
        }

        const re =
          /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;

        return re.test(String(email).toLowerCase());
      },
      // Detects if device is on iOS
      isIos() {
        const userAgent = window.navigator.userAgent.toLowerCase();
        return /iphone|ipad|ipod/.test(userAgent);
      },
      isAndroid() {
        const userAgent = window.navigator.userAgent.toLowerCase();
        return /android/.test(userAgent);
      },
      // Detects if device is in standalone mode
      isInStandaloneMode() {
        const iosStandaloneMode = 'standalone' in window.navigator && window.navigator.standalone;
        const chromeStandaloneMode = window.matchMedia('(display-mode: standalone)').matches;
        return iosStandaloneMode || chromeStandaloneMode;
      },
      isAppOrWebApp() {
        return ['android', 'ios', 'web'].includes(App.appSource);
      },
      hasPassedGhostRegister() {
        return getLocalStorage('hasPassedGhostRegister') === 'true';
      },
      isAndroidApp() {
        return App.appSource === 'android';
      },
      isIosApp() {
        return App.appSource === 'ios';
      },
      revertMap(hashMap) {
        let newMap = {};
        Object.keys(hashMap).forEach(function (key) {
          newMap[hashMap[key]] = key;
        });
        return newMap;
      },
      setCustomCookie(cookieName, cookieValue, cookieExpiry) {
        document.cookie = `${cookieName}=${cookieValue};expires=${cookieExpiry};path=/`;
      },
      getFullURL(relativeUrl) {
        if (relativeUrl.startsWith('/')) {
          return `${window.location.origin}${relativeUrl}`;
        }

        return relativeUrl;
      },
      isLoggedIn() {
        return Boolean(window.gainid);
      },
      /**
       * @typedef {Object} GTagApiResult
       * @property {googleClientId} googleClientId - The google user client id
       * @property {googleSessionId} googleSessionId - The google user session id
       * @returns {GTagApiResult}
       */
      getGTagApiResult() {
        if (Array.isArray(dataLayer)) {
          for (data of dataLayer) {
            for (i in data) {
              if (data[i] && data[i].hasOwnProperty('gtagApiResult') && data[i].gtagApiResult) {
                return {
                  googleClientId: data[i].gtagApiResult.client_id,
                  googleSessionId: data[i].gtagApiResult.session_id,
                };
              }
            }
          }
        }
        return null;
      },
      translate(text, params) {
        /*
          Eg: `this is a string with {foo} binding`
          params = { foo: 'bar' }

          ==> `this is a string with bar binding`
        */
        let result = String(text);

        for (const key in params) {
          result = result.replace(new RegExp(`{${key}}`, 'g'), String(params[key]));
        }

        return result;
      },
      getWindowDimensions() {
        const { innerWidth: width, innerHeight: height } = window;
        return {
          width,
          height,
        };
      },
      debounce(fn, wait) {
        let timeout;
        return function (...args) {
          const later = () => {
            clearTimeout(timeout);
            fn(...args);
          };
          clearTimeout(timeout);
          timeout = setTimeout(later, wait);
        };
      },
      generateUniqueId(prefix) {
        // Similar to lodash _.uniqueId
        if (prefix) {
          return `${prefix}_${idCounter++}`;
        }

        return `${idCounter++}`;
      },
      makeGraphQLQuery: function (query, variables) {
        return new Promise((res, rej) => {
          fetch('/fc-api/graphql', {
            method: 'POST',
            headers: {
              'Content-Type': 'application/json',
              Accept: 'application/json',
            },
            body: JSON.stringify({
              query,
              variables,
            }),
          })
            .then((r) => r.json())
            .then((r) => res(r))
            .catch((e) => rej(e));
        });
      },
      getDollarsFromCoins: function (coinAmount, digits = 2, hasPrefixed = true) {
        const numOfDigits = Number.isSafeInteger(+digits) ? +digits : 2;
        const prefix = hasPrefixed ? '$' : '';
        return (
          prefix + (coinAmount / 1000).toFixed(numOfDigits).replace(/\B(?=(\d{3})+(?!\d))/g, ',')
        );
      },
      getCoinsFromDollars: function (usdAmount, digits = 0) {
        const numOfDigits = Number.isSafeInteger(+digits) ? +digits : 0;
        return (usdAmount * 1000).toFixed(numOfDigits).replace(/\B(?=(\d{3})+(?!\d))/g, ',');
      },
      getChatOpenMode() {
        if (window.innerWidth < 1200) {
          return 'new-page';
        }

        return 'on-page';
      },
      isMobile() {
        return window.innerWidth < 500;
      },
      scrollToElement(selector) {
        const target = document.querySelector(selector);

        if (target) {
          target.scrollIntoView({ behavior: 'smooth', block: 'start', inline: 'nearest' });
        }
      },
      openUrl(url) {
        window.location.assign(url);
      },
      onFrameRatesStablized(callback) {
        let start = Date.now();
        let times = 0;
        const maxTimes = 7;
        setTimeout(function measureLag() {
          let lag = Date.now() - start;
          start = Date.now();

          if (times >= maxTimes || lag < 1050) {
            callback();
            return;
          }

          times++;
          setTimeout(measureLag, 1000);
        }, 1000);
      },
    },
    utm: getUTM(),
    appSource: getAppSource(),
    misc: {
      getWithdrawIcon(type) {
        switch (type) {
          case 'BTC':
          case 'Coinbase':
            return '/public/img/homepage/withdraws/Bitcoin.png';
          case 'ETH':
            return '/public/img/homepage/withdraws/Ethereum.png';
          case 'DOGE':
            return '/public/img/logos/small/withdraws/Dogecoin.svg';
          case 'LTC':
            return '/public/img/homepage/withdraws/Litecoin.png';
          case 'Stake':
            return '/public/img/logos/small/withdraws/Stake.svg';
          case 'PayPal':
            return '/public/img/logos/small/withdraws/Paypal.svg';
          case 'Visa':
            return '/public/img/homepage/withdraws/Visa.png';
          case 'CSGO':
            return '/public/img/logos/small/withdraws/CSGO.svg';
          case 'Google-Play':
            return '/public/img/homepage/withdraws/Google-Play.png';
          case 'iTunes':
            return '/public/img/homepage/withdraws/AppleApple.png';
          case 'Amazon':
            return '/public/img/homepage/withdraws/Amazon.png';
          case 'Spotify':
            return '/public/img/homepage/withdraws/Spotify.png';
          case 'Netflix':
            return '/public/img/homepage/withdraws/Netflix.png';
          case 'UberEats':
            return '/public/img/homepage/withdraws/UberEats.png';
          default: {
            return `/public/img/logos/small/withdraws/${type}.svg`;
          }
        }
      },
    },
  };

  window.app = Object.assign(window.app, App);
})();

var reactScriptInitialized = $.Deferred();

document.addEventListener('alpine:init', () => {
  // Can be accessed anywhere
  // - in handlebar as $store.fcMain.currentPage
  // - in normal js as Alpine.store('fcMain').currentPage
  Alpine.store('fcMain', {
    currentPage: null,
    isLiteMode: false,
    currency: (() => {
      // IMPORTANT: Currency is forced for ALL users - always show currency mode
      setLocalStorage('showCurrency', 'true');
      return 'currency';
    })(),
    chatOpened: getLocalStorage('chatOpened') === 'true',
    hasVisitedJackpotPage: Boolean(getLocalStorage('hasVisitedJackpot')),
    fiatCurrency: 'USD',
    fiatExchangeRate: 1,
    ghostVariant: 'off',

    init() {
      window.addEventListener('currencyModeChanged', (e) => {
        this.setCurrencyMode(e.detail);
      });
    },

    getHomeStatValue(value) {
      if (['JPY', 'KRW'].includes(this.fiatCurrency)) {
        return value * this.fiatExchangeRate;
      }

      return value;
    },

    getFiatCurrencySymbol() {
      switch (this.fiatCurrency) {
        case 'EUR':
          return `€`;
        case 'GBP':
          return `£`;
        case 'CAD':
          return `CAD `; // has one space
        case 'PLN':
          return `zł `; // has one space
        case 'AUD':
          return `AUD `; // has one space
        case 'CHF':
          return `CHF `;
        case 'KRW':
          return `₩ `; // has one space
        case 'JPY':
          return `¥ `; // has one space
        case 'SEK':
          return ` SEK`;
        case 'PLN':
          return ` zł`;
        default:
          return `$`;
      }
    },

    shouldShowSymbolAsSuffix() {
      if (this.currency === 'currency') {
        return ['EUR', 'SEK', 'PLN'].includes(this.fiatCurrency);
      }

      return false;
    },

    isLoggedIn() {
      return typeof window.gainid === 'number';
    },

    setFiatCurrency({ fiatCurrency, fiatExchangeRate }) {
      this.fiatCurrency = fiatCurrency;
      this.fiatExchangeRate = fiatExchangeRate;
    },

    setLiteMode(isLiteMode) {
      this.isLiteMode = isLiteMode;
    },

    setChatOpened(isOpen) {
      this.chatOpened = isOpen;
    },

    setGhostVariant(variant) {
      this.ghostVariant = variant;
    },

    setPage(page) {
      this.currentPage = page;

      if (page === 'jackpot') {
        setLocalStorage('hasVisitedJackpot', 1);
        this.hasVisitedJackpotPage = true;
      }
    },

    /*
     * @param {string} mode - 'currency' or 'coins'
     */
    setCurrencyMode(mode) {
      this.currency = mode;
    },

    /*
     * @param {number} value - the value to be converted
     * @param {string} originalMode - 'usd' | 'coins'. This means the original value is in which mode
     */
    getDisplayedCurrencyValue(value, originalMode) {
      const coinRate = 1000;
      if (Number.isNaN(value)) {
        return '';
      }

      let valueAsNumber = Number(value);

      if (this.currency === 'currency') {
        if (valueAsNumber > 1000) valueAsNumber = Math.floor(valueAsNumber / 10) * 10; // round down 3rd decimal
        valueAsNumber = valueAsNumber * this.fiatExchangeRate;
      }

      if (this.currency === 'currency') {
        if (originalMode === 'usd') {
          return app.utils.formatNumber(valueAsNumber, 2);
        } else if (originalMode === 'coins') {
          return app.utils.formatNumber(valueAsNumber / coinRate, 2);
        }
      } else if (this.currency === 'coins') {
        if (originalMode === 'usd') {
          return app.utils.formatNumber(valueAsNumber * coinRate, 0);
        } else if (originalMode === 'coins') {
          return app.utils.formatNumber(valueAsNumber, 0);
        }
      }
    },

    addCurrencySymbol(value) {
      const symbol = this.getFiatCurrencySymbol();
      if (this.shouldShowSymbolAsSuffix()) {
        return `${value}${symbol}`;
      }

      return `${symbol}${value}`;
    },

    pluralize(count, noun, suffix) {
      return `${count} ${noun}${count !== 1 ? suffix : ''}`;
    },
  });

  Alpine.magic('getNumberIntegerPart', () => (value) => {
    const rawValue = parseFloat((value || 0).toString().replace(/,/g, '')) || 0;
    return Math.floor(rawValue).toLocaleString();
  });

  Alpine.magic('getNumberDecimalPart', () => (value) => {
    const rawValue = parseFloat((value || 0).toString().replace(/,/g, '')) || 0;
    const numericValue = rawValue - Math.floor(rawValue);

    return numericValue.toFixed(2).substring(2);
  });

  /*
    Add classes/styles if media query matches
    <div x-screen-tablet-down="hidden foobar">...</div>

    -> add classes "hidden foobar" if screen width is <= 1199px

    or

    <div x-screen-tablet-down.style="display: none;">...</div>

    -> add style "display: none" if screen width is <= 1199px
  */
  Alpine.directive('screen-tablet-down', (el, { expression, modifiers }, { cleanup }) => {
    const mediaQuery = window.matchMedia('(max-width: 1199px)');

    function assess() {
      if (modifiers.includes('style')) {
        if (mediaQuery.matches) {
          el.style = expression;
        } else {
          el.style = '';
        }
      } else {
        if (mediaQuery.matches) {
          $(el).addClass(expression);
        } else {
          $(el).removeClass(expression);
        }
      }
    }

    assess();

    // listen to media query changes
    if (typeof mediaQuery.addEventListener === 'function') {
      mediaQuery.addEventListener('change', assess);
    } else if (typeof mediaQuery.addListener === 'function') {
      mediaQuery.addListener(assess);
    }

    cleanup(() => {
      mediaQuery.removeEventListener('change', assess);
    });
  });

  /*
    This Alpine directive will evaluate the media query expression
    If the expression evaluates to true, it will render inner HTML.
    It also listens to changes in the data-media query and re-evaluates

    Usage:
      <div x-responsive-condition="(max-width: 768px)">
        <template>
          <div>Mobile</div>
        </template>
      </div>

    Note: The template tag is required if we don't want <div>Mobile</div> to be rendered
  */
  Alpine.directive(
    'responsive-condition',
    (el, { expression }, { evaluateLater, effect, cleanup }) => {
      const mediaQuery = window.matchMedia(expression);
      const template = el.querySelector('template');

      function evaluateMQ() {
        if (mediaQuery.matches) {
          el.innerHTML = template.innerHTML;
        } else {
          el.innerHTML = '';
        }
      }

      evaluateMQ();

      // listen to media query changes
      if (typeof mediaQuery.addEventListener === 'function') {
        mediaQuery.addEventListener('change', evaluateMQ);
      } else if (typeof mediaQuery.addListener === 'function') {
        mediaQuery.addListener(evaluateMQ);
      }

      cleanup(() => {
        mediaQuery.removeEventListener('change', evaluateMQ);
      });
    }
  );

  Alpine.data('formValidator', () => ({
    allErrors: {},

    init() {
      $(this.$el).on('reportError', (e, fieldName, listOfErrors) => {
        this.setError(fieldName, listOfErrors);
      });
    },

    setError(fieldName, listOfErrors) {
      if (listOfErrors.length) {
        this.allErrors[fieldName] = listOfErrors;
      } else {
        delete this.allErrors[fieldName];
      }
    },

    hasErrors() {
      for (const key in this.allErrors) {
        if (this.allErrors[key].length) {
          return true;
        }
      }

      return false;
    },

    validateAll(callback) {
      $(this.$root).find('[x-data]').trigger('forceValidate');

      this.$nextTick(() => {
        if (typeof callback === 'function') {
          callback(this.hasErrors(), this.allErrors);
        }
      });
    },

    setError(fieldName, listOfErrors, mode = 'replace') {
      if (mode === 'replace') {
        this.allErrors[fieldName] = listOfErrors;
      } else if (mode === 'append') {
        this.allErrors[fieldName] = this.allErrors[fieldName].concat(listOfErrors);
      } else if (mode === 'prepend') {
        this.allErrors[fieldName] = listOfErrors.concat(this.allErrors[fieldName]);
      }
    },

    reset() {
      this.allErrors = {};
      $(this.$root).find('[x-data]').trigger('resetField');
    },
  }));

  Alpine.data('formField', (name) => ({
    originalValue: null,
    fieldValue: null,
    fieldName: name || `field-${app.utils.generateUniqueId()}`,
    errors: [],
    customValidations: [],
    defaultMessages: {
      required: 'This field is required',
      email: 'Please enter a valid email address',
    },
    isDirty: false,

    init() {
      const validateAndReport = async (force = false) => {
        this.errors = await this.validate();

        if (force) {
          this.isDirty = true;
          $(this.$root)
            .closest('[x-data="formValidator"]')
            .trigger('reportError', [this.fieldName, this.errors]);
        }

        this.$nextTick(() => {
          if (this.isDirty && this.errors.length) {
            $(this.$root)
              .closest('[x-data="formValidator"]')
              .trigger('reportError', [this.fieldName, this.errors]);
          }
        });
      };

      Alpine.effect(validateAndReport);

      const actualInputEl = $(this.$el).find('input,select,textarea');
      actualInputEl.attr('data-field-name', this.fieldName);

      actualInputEl.one('input', () => {
        this.isDirty = true;
      });

      $(this.$el).on('forceValidate', () => {
        validateAndReport(true);
      });

      $(this.$el).on('resetField', () => {
        this.fieldValue = this.originalValue;
        this.isDirty = false;
      });
    },

    async validate() {
      const allErrors = [];

      if (this.$root.getAttribute('data-error-required')) {
        if (!this.fieldValue) {
          allErrors.push(
            this.$root.getAttribute('data-error-required') || this.defaultMessages.required
          );
        }
      }

      if (this.$root.getAttribute('data-error-email')) {
        if (!validateEmail(this.fieldValue || '')) {
          allErrors.push(this.$root.getAttribute('data-error-email')) || this.defaultMessages.email;
        }
      }

      if (this.customValidations.length) {
        for (const validation of this.customValidations) {
          const [isValid, message] = await validation();

          if (!isValid) {
            allErrors.push(message);
          }
        }
      }

      return allErrors;
    },

    getFirstError() {
      return this.errors[0];
    },

    hasError() {
      return this.errors.length > 0;
    },

    isDirtyAndHasError() {
      return this.isDirty && this.hasError();
    },

    setup(fieldValue) {
      this.fieldValue = fieldValue;
      this.originalValue = fieldValue;
    },

    setupCustomValidator(customValidatorFn) {
      this.customValidations.push(customValidatorFn);
    },
  }));

  /*
    Init a react app at a DOM node (must have an id attribute)
    Usage:
      <div x-react-app.appname="{ foo: 'bar' }" id="any-unique-id"></div>

    appname is defined in web/front/react-app/src/index.tsx
  */
  Alpine.directive('react-app', (el, { expression, modifiers }, { evaluate, cleanup }) => {
    const id = el.getAttribute('id');

    if (!id) {
      throw new Error('react-app directive requires an id attribute');
    }

    const appName = modifiers[0];
    const props = evaluate(expression);

    if (typeof props === 'undefined') {
      if (window.Sentry && typeof window.Sentry.captureException === 'function') {
        const message = 'Failed to evaluate expression';
        const error = new Error(message);
        window.Sentry.captureException(error, {
          fingerprint: [message],
          extra: {
            faultyExpression: expression,
            selectors: id,
          },
        });
      }
    }

    reactScriptInitialized.then(() => {
      const event = new CustomEvent('fc:reactapp:mount', {
        detail: {
          domId: id,
          appName,
          props,
        },
      });

      window.dispatchEvent(event);
    });

    cleanup(() => {
      const event = new CustomEvent('fc:reactapp:unmount', {
        detail: {
          domId: id,
          appName,
        },
      });

      window.dispatchEvent(event);
    });
  });

  Alpine.directive('parallax-container', (el, { modifiers }, { evaluate }) => {
    if (!('IntersectionObserver' in window)) {
      return;
    }

    if (modifiers.includes('desktop')) {
      if (isTabletOrSmaller()) {
        return;
      }
    } else if (modifiers.includes('mobile')) {
      if (!isTabletOrSmaller()) {
        return;
      }
    }

    const viewportObserver = Alpine.reactive(0);
    const observer = new IntersectionObserver((entries) => {
      entries.forEach((entry) => {
        if (entry.isIntersecting) {
          window.addEventListener('scroll', onScroll);
          viewportObserver.value = 1;
        } else {
          window.removeEventListener('scroll', onScroll);

          if (window.scrollY > el.offsetTop + el.clientHeight) {
            viewportObserver.value = 2;
          } else {
            viewportObserver.value = 0;
          }
        }
      });
    });

    el.addEventListener('parallax:dispose', () => {
      observer.disconnect();
      window.removeEventListener('scroll', onScroll);
    });

    Alpine.effect(() => {
      if (viewportObserver.value === 0) {
        el.style.setProperty('--fc-parallax-value-full', 0);
        window.removeEventListener('scroll', onScroll);
      } else if (viewportObserver.value === 2) {
        el.style.setProperty('--fc-parallax-value-full', 100);
        window.removeEventListener('scroll', onScroll);
      } else {
        window.addEventListener('scroll', onScroll);
      }
    });

    const headerEl = document.querySelector('.site-header');
    const headerHeight = headerEl ? headerEl.clientHeight : 0;

    function onScroll() {
      const scrollY = window.scrollY;
      const elOffsetTop = el.offsetTop;
      const elClientHeight = el.clientHeight;

      // This is the scroll percentage of the element from top to bottom
      const parallaxValueFull =
        (scrollY - elOffsetTop + elClientHeight + headerHeight) / window.innerHeight;
      el.style.setProperty('--fc-parallax-value-full', parallaxValueFull * 100);

      // This is the scroll percentage of the element from top to middle of the screen
      const parallaxValueHalf = Math.min(
        0.25,
        (scrollY - elOffsetTop + elClientHeight / 2 + headerHeight) / window.innerHeight / 2
      );
      el.style.setProperty('--fc-parallax-value-half', parallaxValueHalf * 100);

      const elementTopDistanceFromViewportTop = elOffsetTop - scrollY;
      const windowHeight = window.innerHeight;
      const elementVisiblityPercentage = Math.min(
        1,
        Math.max(
          0,
          (windowHeight - elementTopDistanceFromViewportTop) / (windowHeight + elClientHeight)
        )
      );

      const event = new CustomEvent('viewport-onenter', {
        detail: {
          scrollY,
          parallaxValueHalf,
          parallaxValueFull,
          elementTopDistanceFromViewportTop,
          elementVisiblityPercentage,
          windowHeight,
        },
      });
      el.dispatchEvent(event);
    }

    observer.observe(el);

    return () => {
      observer.disconnect();
    };
  });

  Alpine.magic('almaRedirect', () => (page, route) => {
    openPage(page, route);
  });
});

function isTabletOrSmaller() {
  let breakpoint = window.app.computedStyles.getPropertyValue('--screen-tablet-max');
  return window.matchMedia(`(max-width: ${breakpoint})`).matches;
}

function isPhone() {
  let breakpoint = window.app.computedStyles.getPropertyValue('--screen-phone-max');
  return window.matchMedia(`(max-width: ${breakpoint})`).matches;
}

function getPlatform() {
  if (window.app.utils.isIos()) {
    return 'ios';
  }

  if (window.app.utils.isAndroid()) {
    return 'android';
  }

  return 'desktop';
}

function getPage() {
  let path = window.location.pathname;
  let pathArr = path.split('/');
  return pathArr[1];
}

function throttleFunc(fn, threshhold, scope) {
  threshhold || (threshhold = 250);
  var last, deferTimer;
  return function () {
    var context = scope || this;

    var now = +new Date(),
      args = arguments;
    if (last && now < last + threshhold) {
      // hold on to it
      clearTimeout(deferTimer);
      deferTimer = setTimeout(function () {
        last = now;
        fn.apply(context, args);
      }, threshhold);
    } else {
      last = now;
      fn.apply(context, args);
    }
  };
}

function leadingDebounce(fn, threshhold = 250, scope) {
  let last, deferTimer;
  return function () {
    let context = scope || this;

    let now = +new Date(),
      args = arguments;
    if (last && now < last + threshhold) {
      // hold on to it
      clearTimeout(deferTimer);
      deferTimer = setTimeout(function () {
        last = now;
        fn.apply(context, args);
      }, threshhold);
    } else {
      last = now;
      fn.apply(context, args);
    }
  };
}

//Source: https://github.com/component/escape-html
function escapeHtml(string) {
  var matchHtmlRegExp = /["'&<>]/;
  var str = '' + string;
  var match = matchHtmlRegExp.exec(str);

  if (!match) {
    return str;
  }

  var escape;
  var html = '';
  var index = 0;
  var lastIndex = 0;

  for (index = match.index; index < str.length; index++) {
    switch (str.charCodeAt(index)) {
      case 34: // "
        escape = '&quot;';
        break;
      case 38: // &
        escape = '&amp;';
        break;
      case 39: // '
        escape = '&#39;';
        break;
      case 60: // <
        escape = '&lt;';
        break;
      case 62: // >
        escape = '&gt;';
        break;
      default:
        continue;
    }

    if (lastIndex !== index) {
      html += str.substring(lastIndex, index);
    }

    lastIndex = index + 1;
    html += escape;
  }

  return lastIndex !== index ? html + str.substring(lastIndex, index) : html;
}

function isSessionStorageSupported() {
  // Safari Private Mode will throw error on sessionStorage.setItem
  const randomKey = `fs_test_session_storage_${new Date().getTime()}`;

  try {
    window.sessionStorage.setItem(randomKey, randomKey);
    const item = window.sessionStorage.getItem(randomKey);

    if (item === randomKey) {
      window.sessionStorage.removeItem(randomKey);

      return true;
    }
  } catch (e) {}

  return false;
}

// This fixes the width of the element to the width of the text inside it
// There's an issue with the text width being wider than the text content
// https://stackoverflow.com/a/37413580/6744320
// Fix from: https://stackoverflow.com/a/73279917/6744320
function fixElementWidth(el) {
  const range = document.createRange();
  const text = el.childNodes[0];
  range.setStartBefore(text);
  range.setEndAfter(text);

  const clientRect = range.getBoundingClientRect();
  el.style.width = `${clientRect.width + 1}px`;
}

window.__isSessionStorageSupported = isSessionStorageSupported();

/**
 * Custom emit function to retry socket emit if it fails
 * @param action
 * @param payload
 * @param callback
 * @param config {{  maxRetries?: number, retryDelay?: number }}
 */
function socketEmit(action, payload, callback, config = {}) {
  const { maxRetries = 1, retryDelay = 0 } = config;
  let retryCount = 0;
  let timeoutId;
  let callbackCalled = false;

  function emit() {
    if (retryCount < maxRetries && retryDelay) {
      retryCount++;
      timeoutId = setTimeout(emit, retryDelay);
    }

    socket.emit(action, payload, (...args) => {
      clearTimeout(timeoutId);
      if (callback && !callbackCalled) {
        callback(...args);
      }

      callbackCalled = true;
    });
  }

  emit();
}

$(document).on('click', '.adminNavBtn', function () {
  $('.rootAdmin').html(loaderHtml);
  socket.emit('renderRootAdmin', {
    page: $(this).attr('data-page'),
    paginatePage: $(this).attr('data-paginate') || 1,
  });
});

$(document).on('click', '.adminModUserBtn', function () {
  let newModGainId = $('#adminAddRemoveModInput').val();
  socket.emit('adminModUser', {
    gainid: newModGainId,
  });
});

$(document).on('click', '.adminSupportModUserBtn', function () {
  let newModGainId = $('#adminAddRemoveModInput').val();
  socket.emit('adminSupportModUser', {
    gainid: newModGainId,
  });
});

$(document).on('click', '.adminUnmodUserBtn', function () {
  let modGainId = $('#adminAddRemoveModInput').val();
  socket.emit('adminUnmodUser', {
    gainid: modGainId,
  });
});

$(document).on('click', '.removeModBtn', function () {
  let modGainId = $(this).attr('data-mod');
  socket.emit('adminUnmodUser', {
    gainid: modGainId,
  });
});

socket.on('renderRootAdmin', function (html) {
  $('.rootAdmin').html(html);
  $('time.timeago').timeago();
  M.updateTextFields();
});

$(document).on('click', '.adminOfferClickSearchBtn', function (_event, data) {
  const query = {};

  const searchByUserId = $('#adminOfferClickSearchByUserId').val();
  const searchByOfferName = $('#adminOfferClickSearchByOfferName').val();
  const searchByProvider = $('select[name="wall"]').val();

  if (searchByUserId) {
    query['gainid'] = searchByUserId;
  }

  if (searchByOfferName) {
    query['offername'] = searchByOfferName;
  }

  if (searchByProvider) {
    query['provider'] = searchByProvider;
  }

  if (Object.keys(query).length === 0) {
    return toastAlert('No input provided');
  }

  socket.emit(
    'adminOfferClickSearch',
    {
      query,
      page: data?.adminOfferClickPage || 0,
    },
    function (htmls) {
      $('.adminOfferClickSearchResults').html(htmls.tableHtml);
      $('.adminOfferClickPagination').html(htmls.paginationHtml);
    }
  );
});

$(document).on('click', '.adminOfferClickSearchPagination', function () {
  adminOfferClickPage = Number($(this).attr('data-value')) - 1;
  $('.adminOfferClickSearchBtn').trigger('click', { adminOfferClickPage });
});

$(document).on('click', '.creditBtn', function () {
  $.ajax({
    method: 'POST',
    url: '/fc-api/user-credits/',
    data: {
      gainId: $('#creditGainId').val(),
      coins: $('#creditCoins').val(),
      description: $('#creditDescription').val(),
      category: $('#creditCategory').val(),
    },
    success: (data) => {
      M.toast({
        html: getToastHtml({
          type: 'success',
          title: 'Crediting Succeed',
          text: `Crediting ${data.coins} to ${data.gainId} is completed.`,
        }),
        classes: 'stdToastNotification',
        displayLength: 7000,
      });
      socket.emit('renderRootAdmin', {
        page: 'credituser',
        paginatePage: $(this).attr('data-value'),
      });
    },
    error: (err) => {
      M.toast({
        html: getToastHtml({
          type: 'error',
          title: 'Crediting Failed',
          text: err.responseJSON?.message || err.responseText,
        }),
        classes: 'stdToastNotification',
        displayLength: 7000,
      });
    },
  });
});

$(document).on('click', '.adminBanPaginate', function () {
  socket.emit('renderRootAdmin', {
    page: 'importantbans',
    paginatePage: $(this).attr('data-value'),
    filter: $(this).attr('data-filter'),
    search: $(this).attr('data-search'),
  });
});

$(document).on('click', '.adminBanFilterBtn', function () {
  var obj = {
    page: 'importantbans',
    paginatePage: 1,
    filter: $(this).attr('data-tag'),
    search: '',
  };
  $('.rootAdmin').html(loaderHtml);

  socket.emit('renderRootAdmin', obj);
});

$(document).on('click', '#adminBannedSearchBtn', function () {
  var obj = {
    page: 'importantbans',
    paginatePage: 1,
    filter: $(this).attr('data-filter'),
    search: $('.adminBannedSearchInput').val(),
  };
  $('.rootAdmin').html(loaderHtml);

  socket.emit('renderRootAdmin', obj);
});

$(document).on('click', '#adminBannedSearchSuggestion', function () {
  var obj = {
    page: 'importantbans',
    paginatePage: 1,
    filter: $('#adminBannedSearchBtn').attr('data-filter'),
    search: $(this).attr('data-search'),
  };
  $('.rootAdmin').html(loaderHtml);

  socket.emit('renderRootAdmin', obj);
});

$(document).on('click', '.deletePersonalInfo', function () {
  const gainId = $('#deletePersonalInfoGainID').val();
  DeleteRequest(`fc-api/users/${gainId}`, {})
    .then((response) => {
      toastAlert(response.message);
    })
    .catch((reason) => {
      console.log(reason);
      const message = reason.responseJSON.errors?.[0] || reason.responseJSON.message;
      toastAlert('Error: ' + message);
    });
});

//*********** START ADMIN - SKIPPED CREDITS PAGE ************/

// Filtering
$(document).on('click', '#adminSkippedCreditBtn', function () {
  const props = {
    page: 'skippedcredits',
    paginatePage: 1,
    filters: {
      wall: $('select[name="wall"]').val(),
      skippedReason: $('#admin-skippedreason').val(),
    },
  };
  $('.rootAdmin').html(loaderHtml);
  socket.emit('renderRootAdmin', props);
});

//Pagination
$(document).on('click', '.adminSkippedCreditPaginateBtn', function () {
  socket.emit('renderRootAdmin', {
    page: 'skippedcredits',
    paginatePage: $(this).attr('data-value'),
    filters: {
      wall: $('select[name="wall"]').val(),
      skippedReason: $('#admin-skippedreason').val(),
    },
  });
  $('.rootAdmin').html(loaderHtml);
});

$(document).on('click', '.adminUserCreditBtn', function () {
  socket.emit('renderRootAdmin', {
    page: 'credituser',
    paginatePage: $(this).attr('data-value'),
  });
  $('.rootAdmin').html(loaderHtml);
});

//Crediting
$(document).on('click', '#adminSkippedCreditSkippedOffer', function () {
  const surveyId = $(this).attr('data-surveyid');
  toastAlert('Crediting offer...');
  PostRequest(`fc-api/user-offers/credit-skipped-offer`, { surveyId })
    .then((response) => {
      toastAlert(response.message);

      //Remove row
      $(this).css('background-color', 'orange');
      $(this).text('Credited');
      $(this).prop('disabled', true);
      $($(this).closest('tr')).fadeOut(1500, function () {
        $(this).closest('tr').remove();
      });
    })
    .catch((error) => {
      toastAlert(error.responseJSON.errors[0] || error.responseJSON.message);
    });
});

//*********** END ADMIN - SKIPPED CREDITS PAGE ************/

$(function () {
  let $page;
  function drawTable(filter) {
    $page = $('.verif-action-required-approved-page');
    $.ajax({
      method: 'GET',
      url: '/fc-api/id-verifications',
      data: {
        ...filter,
        username: $page.find('input[name=search]').val() || undefined,
        sort: $page.find('.order-field').val(),
        order: $page.find('.order-dir').val(),
        statuses: ['completed', 'approved'],
        bannedOrFrozen: true,
        notMuted: 1,
      },
      success: (data) => {
        $page.find('tbody').html(drawRows(data.items));
        $page.find('.pagination-block').html(drawPagination(data.meta));
        $page.find('.total-items span').html(data.meta.totalItemsCount);
        $('time.timeago').timeago();
      },
      error: (error) => {
        console.log(error);
      },
    });
  }

  function drawRows(items) {
    let html = '';
    items.forEach((item) => {
      const { count, actionBtns } = genActionBtns(item);
      const userStatus = item.banned ? 'Banned' : item.frozen ? 'Frozen' : 'No';
      const userStatusClass = item.banned
        ? 'banned-text'
        : item.frozen
        ? 'frozen-text'
        : 'unbanned-text';
      html += `<tr>
            <td><a href="/user/${item.gainId}" class="gainProfileLink" data-gainid="${
        item.gainId
      }">${item.username}</a></td>
            <td class="id-req-type">${genReqTypeIcon(item)}</td>           
            <td class="${userStatusClass}">${userStatus}</td>
            <td>${item.reason}</td>
            <td class="id-attempts">${item.attempts}</td>
            <td>${genFlags(item)}</td>
            <td>${item.addressCountryCode || '-'}</td>
            <td>${formatMoneyDisplay(item.spentInApp)}</td>
            <td><time class="timeago" datetime="${item.updatedAt}"></time></td>
            <td class="inquiry-status"><a href="https://hub.veriff.com/verifications/${
              item.inquiryId
            }" target="_blank">${item.status}</a></td>
            <td colspan="${count}"><div class="td-actions">${actionBtns}</div></td>
          </tr>`;
    });
    if (!html) html = '<tr class="empty"><td colspan="7">Empty...</td></tr>';
    return html;
  }

  function formatMoneyDisplay(value) {
    if (!value) return '$0.00';
    return '$' + app.utils.formatNumber(value, 2);
  }

  function genReqTypeIcon(item) {
    return `<i class="${
      item.reqType == 'freeze' ? 'frozen-text' : 'banned-text'
    } fas fa-ban"></i> ${item.reqType}`;
  }

  function genFlags(item) {
    if (!item.flags) return 'N/A';
    let flagsHtml = '';
    const flags = item.flags.split(',');
    flags.forEach((flag) => {
      switch (flag) {
        case 'last name match':
          flagsHtml += `<a class="id-flag-modal" data-id="${item.id}" data-flag-match="${item.lastname}" data-flag="${flag}">${flag}</a>, `;
          break;
        case 'address match':
          flagsHtml += `<a class="id-flag-modal" data-id="${item.id}" data-flag-match="${item.addressStreet1}" data-flag="${flag}">${flag}</a>, `;
          break;
        case 'country mismatch':
          flagsHtml += `<span>${flag} (${item.addressCountryCode})</span>, `;
          break;
        default:
          flagsHtml += `<span>${flag}</span>, `;
      }
    });
    return flagsHtml.slice(0, -2);
  }

  function genActionBtns(item) {
    let count = 2;
    let actionBtns = '';
    let unbanOrUnfreezeBtn = `<a class="waves-effect waves-light btn smallBtn orange change-user-status-btn" data-type="unban" data-status="${item.status}" data-gainid="${item.gainId}">Unban</a>`;
    let stayBannedOrBanBtn = `<a class="btn smallBtn red waves-effect stay-banned-btn" data-status="${item.status}" data-gainid="${item.gainId}">Stay Banned</a>`;
    if (item.reqType === 'freeze' && !item.banned) {
      unbanOrUnfreezeBtn = `<a class="waves-effect waves-light btn smallBtn blue change-user-status-btn" data-status="${item.status}" data-type="unfreeze" data-gainid="${item.gainId}">Unfreeze</a>`;
      stayBannedOrBanBtn = `<a class="btn smallBtn red waves-effect ban-btn change-user-status-btn" data-type="ban" data-status="${item.status}" data-gainid="${item.gainId}">Ban</a>`;
    }

    if (['completed', 'approved'].includes(item.status)) {
      count++;
      actionBtns += unbanOrUnfreezeBtn;
    }
    actionBtns += stayBannedOrBanBtn;

    if (['failed', 'expired', 'declined'].includes(item.status) && item.attempts < 5) {
      let reqType = item.banned ? 'review' : item.reqType;
      count++;
      actionBtns += `<a class="btn smallBtn waves-effect request-verification-btn" data-req-type="${reqType}" data-reason="${item.reason}" data-gainid="${item.gainId}">Request again</a>`;
    }
    return { count, actionBtns };
  }

  // copied from web/server/paginate.js
  function drawPagination(meta) {
    var i, len, prelink;
    var html = '<div><ul class="pagination unselectable">';
    if (meta.totalPages < 2) {
      html += '</ul></div>';
      return html;
    }
    if (meta.currentPage - 1 > 0) {
      html += `<li><a class="waves-effect" data-value="${
        meta.currentPage - 1
      }" style="color: white"><i class="material-icons">chevron_left</i></a></li>`;
    } else {
      html +=
        '<li class="disabled"><a style="color: white"><i class="material-icons">chevron_left</i></a></li>';
    }
    for (i = 1; i <= meta.totalPages; i++) {
      if (i === meta.currentPage) {
        html += `<li class="active waves-effect z-depth-1" style="background-color: #34365c;"><a class="" data-value="${i}">${i}</a></li>`;
      } else {
        html += `<li><a class="waves-effect" style="color: white" data-value="${i}">${i}</a></li>`;
      }
    }
    if (meta.currentPage + 1 <= meta.totalPages) {
      html += `<li><a data-value="${
        meta.currentPage + 1
      }" class="paginator-next waves-effect"><i class="material-icons" style="color: white">chevron_right</i></a></li>`;
    } else {
      html += `<li class="disabled"><a style="color: white"><i class="material-icons">chevron_right</i></a></li>`;
    }
    html += '</ul></div>';
    return html;
  }

  $(document).on('click', '.verif-action-required-approved-page .search-btn', function () {
    drawTable({});
  });

  $(document).on(
    'click',
    '.verif-action-required-approved-page .pagination li:not(.disabled) a',
    function () {
      drawTable({
        page: $(this).data('value'),
      });
    }
  );

  $(document).on('change', '.verif-action-required-approved-page select', function () {
    drawTable({});
  });

  $(document).on(
    'click',
    '.verif-action-required-approved-page .change-user-status-btn:not(.disabled)',
    function () {
      $(this).parent().find(':not(.modViewSupportChatBtn)').addClass('disabled');
      socket.emit('modBan', {
        gainid: $(this).data('gainid'),
        reason: `ID verification ${$(this).data('status')}.`,
        publicReason: 'id-verification',
        type: $(this).data('type'),
      });
    }
  );

  $(document).on(
    'click',
    '.verif-action-required-approved-page .stay-banned-btn:not(.disabled)',
    function () {
      const $tr = $(this).parents('tr');
      socket.emit(
        'alterBannedSupportTicket',
        {
          usergainid: $(this).data('gainid'),
          action: 'mute',
        },
        function (err, _data) {
          if (err) return;
          $tr.fadeOut();
          const $total = $page.find('.total-items span');
          $total.text(parseInt($total.text()) - 1);
        }
      );
    }
  );

  $(document).on(
    'click',
    '.verif-action-required-approved-page .request-verification-btn:not(.disabled)',
    function () {
      console.log('dasd');
      const $this = $(this);
      $this.addClass('disabled');
      PostRequest('fc-api/id-verifications/request', {
        reason: $this.data('reason'),
        gainId: $this.data('gainid'),
        reqType: $this.data('req-type'),
        trigger: 'manual',
      })
        .then(({ message, verification }) => {
          toastAlert(message);
          const $tr = $this.parents('tr');
          $tr.find('td.inquiry-status')
            .html(`<a href="https://hub.veriff.com/verifications/${verification.inquiryId}"
            target="_blank">${verification.status}</a>`);
          $tr.find('.id-attempts').html(verification.attempts);
          $tr.find('.id-req-type').html(genReqTypeIcon(verification));
        })
        .catch((error) => {
          $this.removeClass('disabled');
          console.log(error);
          toastAlert(error.responseJSON.message);
        });
    }
  );

  let request;
  $(document).on('click', '.id-flag-modal', function () {
    const $this = $(this);
    const $modal = $('#idVerificationFlagsModal');
    const $loader = $modal.find('.datLoader');
    const $usersList = $modal.find('.verification-flags-users');
    $loader.show();
    $usersList.html('');
    $modal.find('.modal-header').html(`${$this.data('flag')} (${$this.data('flag-match')})`);
    openModal('#idVerificationFlagsModal');
    if (request) request.abort();
    request = $.ajax({
      method: 'GET',
      url: '/fc-api/id-verifications/flag-users',
      data: {
        id: $this.data('id'),
        flag: $this.data('flag'),
      },
      success: (users) => {
        $loader.hide();
        let usersHtml = '';
        users.forEach((user) => {
          usersHtml += `<a href="/user/${user.gainId}" class="gainProfileLink" data-gainid="${user.gainId}">${user.username}</a>, `;
        });
        $usersList.html(usersHtml.slice(0, -2));
      },
      error: (error) => {
        console.log(error);
      },
    });
  });
});

$(function () {
  let $page;
  function drawTable(filter) {
    $page = $('.verif-action-required-failed-page');
    $.ajax({
      method: 'GET',
      url: '/fc-api/id-verifications',
      data: {
        ...filter,
        username: $page.find('input[name=search]').val() || undefined,
        sort: $page.find('.order-field').val(),
        order: $page.find('.order-dir').val(),
        statuses: ['failed', 'declined'],
        bannedOrFrozen: true,
        notMuted: 1,
      },
      success: (data) => {
        $page.find('tbody').html(drawRows(data.items));
        $page.find('.pagination-block').html(drawPagination(data.meta));
        $page.find('.total-items span').html(data.meta.totalItemsCount);
        $('time.timeago').timeago();
      },
      error: (error) => {
        console.log(error);
      },
    });
  }

  function drawRows(items) {
    let html = '';
    items.forEach((item) => {
      const { count, actionBtns } = genActionBtns(item);
      const userStatus = item.banned ? 'Banned' : item.frozen ? 'Frozen' : 'No';
      const userStatusClass = item.banned
        ? 'banned-text'
        : item.frozen
        ? 'frozen-text'
        : 'unbanned-text';
      html += `<tr>
            <td><a href="/user/${item.gainId}" class="gainProfileLink" data-gainid="${
        item.gainId
      }">${item.username}</a></td>
            <td class="id-req-type">${genReqTypeIcon(item)}</td>           
            <td class="${userStatusClass}">${userStatus}</td>
            <td>${item.reason}</td>
            <td class="id-attempts">${item.attempts}</td>
            <td>${genFlags(item)}</td>
            <td>${item.addressCountryCode || '-'}</td>
            <td>${formatMoneyDisplay(item.spentInApp)}</td>
            <td><time class="timeago" datetime="${item.updatedAt}"></time></td>
            <td class="inquiry-status"><a href="https://hub.veriff.com/verifications/${
              item.inquiryId
            }" target="_blank">${item.status}</a></td>
            <td colspan="${count}"><div class="td-actions">${actionBtns}</div></td>
          </tr>`;
    });
    if (!html) html = '<tr class="empty"><td colspan="7">Empty...</td></tr>';
    return html;
  }

  function formatMoneyDisplay(value) {
    if (!value) return '$0.00';
    return '$' + app.utils.formatNumber(value, 2);
  }

  function genReqTypeIcon(item) {
    return `<i class="${
      item.reqType == 'freeze' ? 'frozen-text' : 'banned-text'
    } fas fa-ban"></i> ${item.reqType}`;
  }

  function genFlags(item) {
    if (!item.flags) return 'N/A';
    let flagsHtml = '';
    const flags = item.flags.split(',');
    flags.forEach((flag) => {
      switch (flag) {
        case 'last name match':
          flagsHtml += `<a class="id-flag-modal" data-id="${item.id}" data-flag-match="${item.lastname}" data-flag="${flag}">${flag}</a>, `;
          break;
        case 'address match':
          flagsHtml += `<a class="id-flag-modal" data-id="${item.id}" data-flag-match="${item.addressStreet1}" data-flag="${flag}">${flag}</a>, `;
          break;
        case 'country mismatch':
          flagsHtml += `<span>${flag} (${item.addressCountryCode})</span>, `;
          break;
        default:
          flagsHtml += `<span>${flag}</span>, `;
      }
    });
    return flagsHtml.slice(0, -2);
  }

  function genActionBtns(item) {
    let count = 2;
    let actionBtns = '';
    let unbanOrUnfreezeBtn = `<a class="waves-effect waves-light btn smallBtn orange change-user-status-btn" data-type="unban" data-status="${item.status}" data-gainid="${item.gainId}">Unban</a>`;
    let stayBannedOrBanBtn = `<a class="btn smallBtn red waves-effect stay-banned-btn" data-status="${item.status}" data-gainid="${item.gainId}">Stay Banned</a>`;
    if (item.reqType === 'freeze' && !item.banned) {
      unbanOrUnfreezeBtn = `<a class="waves-effect waves-light btn smallBtn blue change-user-status-btn" data-status="${item.status}" data-type="unfreeze" data-gainid="${item.gainId}">Unfreeze</a>`;
      stayBannedOrBanBtn = `<a class="btn smallBtn red waves-effect ban-btn change-user-status-btn" data-type="ban" data-status="${item.status}" data-gainid="${item.gainId}">Ban</a>`;
    }

    if (['completed', 'approved'].includes(item.status)) {
      count++;
      actionBtns += unbanOrUnfreezeBtn;
    }
    actionBtns += stayBannedOrBanBtn;

    if (['failed', 'expired', 'declined'].includes(item.status) && item.attempts < 5) {
      let reqType = item.banned ? 'review' : item.reqType;
      count++;
      actionBtns += `<a class="btn smallBtn waves-effect request-verification-btn" data-req-type="${reqType}" data-reason="${item.reason}" data-gainid="${item.gainId}">Request again</a>`;
    }
    return { count, actionBtns };
  }

  // copied from web/server/paginate.js
  function drawPagination(meta) {
    var i, len, prelink;
    var html = '<div><ul class="pagination unselectable">';
    if (meta.totalPages < 2) {
      html += '</ul></div>';
      return html;
    }
    if (meta.currentPage - 1 > 0) {
      html += `<li><a class="waves-effect" data-value="${
        meta.currentPage - 1
      }" style="color: white"><i class="material-icons">chevron_left</i></a></li>`;
    } else {
      html +=
        '<li class="disabled"><a style="color: white"><i class="material-icons">chevron_left</i></a></li>';
    }
    for (i = 1; i <= meta.totalPages; i++) {
      if (i === meta.currentPage) {
        html += `<li class="active waves-effect z-depth-1" style="background-color: #34365c;"><a class="" data-value="${i}">${i}</a></li>`;
      } else {
        html += `<li><a class="waves-effect" style="color: white" data-value="${i}">${i}</a></li>`;
      }
    }
    if (meta.currentPage + 1 <= meta.totalPages) {
      html += `<li><a data-value="${
        meta.currentPage + 1
      }" class="paginator-next waves-effect"><i class="material-icons" style="color: white">chevron_right</i></a></li>`;
    } else {
      html += `<li class="disabled"><a style="color: white"><i class="material-icons">chevron_right</i></a></li>`;
    }
    html += '</ul></div>';
    return html;
  }

  $(document).on('click', '.verif-action-required-failed-page .search-btn', function () {
    drawTable({});
  });

  $(document).on(
    'click',
    '.verif-action-required-failed-page .pagination li:not(.disabled) a',
    function () {
      drawTable({
        page: $(this).data('value'),
      });
    }
  );

  $(document).on('change', '.verif-action-required-failed-page select', function () {
    drawTable({});
  });

  $(document).on(
    'click',
    '.verif-action-required-failed-page .change-user-status-btn:not(.disabled)',
    function () {
      $(this).parent().find(':not(.modViewSupportChatBtn)').addClass('disabled');
      socket.emit('modBan', {
        gainid: $(this).data('gainid'),
        reason: `ID verification ${$(this).data('status')}.`,
        publicReason: 'id-verification',
        type: $(this).data('type'),
      });
    }
  );

  $(document).on(
    'click',
    '.verif-action-required-failed-page .stay-banned-btn:not(.disabled)',
    function () {
      const $tr = $(this).parents('tr');
      socket.emit(
        'alterBannedSupportTicket',
        {
          usergainid: $(this).data('gainid'),
          action: 'mute',
        },
        function (err, _data) {
          if (err) return;
          $tr.fadeOut();
          const $total = $page.find('.total-items span');
          $total.text(parseInt($total.text()) - 1);
        }
      );
    }
  );

  $(document).on(
    'click',
    '.verif-action-required-failed-page .request-verification-btn:not(.disabled)',
    function () {
      console.log('dasd');
      const $this = $(this);
      $this.addClass('disabled');
      PostRequest('fc-api/id-verifications/request', {
        reason: $this.data('reason'),
        gainId: $this.data('gainid'),
        reqType: $this.data('req-type'),
        trigger: 'manual',
      })
        .then(({ message, verification }) => {
          toastAlert(message);
          const $tr = $this.parents('tr');
          $tr.find('td.inquiry-status')
            .html(`<a href="https://hub.veriff.com/verifications/${verification.inquiryId}"
            target="_blank">${verification.status}</a>`);
          $tr.find('.id-attempts').html(verification.attempts);
          $tr.find('.id-req-type').html(genReqTypeIcon(verification));
        })
        .catch((error) => {
          $this.removeClass('disabled');
          console.log(error);
          toastAlert(error.responseJSON.message);
        });
    }
  );

  let request;
  $(document).on('click', '.id-flag-modal', function () {
    const $this = $(this);
    const $modal = $('#idVerificationFlagsModal');
    const $loader = $modal.find('.datLoader');
    const $usersList = $modal.find('.verification-flags-users');
    $loader.show();
    $usersList.html('');
    $modal.find('.modal-header').html(`${$this.data('flag')} (${$this.data('flag-match')})`);
    openModal('#idVerificationFlagsModal');
    if (request) request.abort();
    request = $.ajax({
      method: 'GET',
      url: '/fc-api/id-verifications/flag-users',
      data: {
        id: $this.data('id'),
        flag: $this.data('flag'),
      },
      success: (users) => {
        $loader.hide();
        let usersHtml = '';
        users.forEach((user) => {
          usersHtml += `<a href="/user/${user.gainId}" class="gainProfileLink" data-gainid="${user.gainId}">${user.username}</a>, `;
        });
        $usersList.html(usersHtml.slice(0, -2));
      },
      error: (error) => {
        console.log(error);
      },
    });
  });
});

$(function () {
  function drawTable(filter) {
    const $page = $('.verif-completed-page');
    $.ajax({
      method: 'GET',
      url: '/fc-api/id-verifications',
      data: {
        ...filter,
        username: $page.find('input[name=search]').val() || undefined,
        sort: $page.find('.order-field').val(),
        order: $page.find('.order-dir').val(),
        reviewed: true,
      },
      success: (data) => {
        $page.find('tbody').html(drawRows(data.items));
        $page.find('.pagination-block').html(drawPagination(data.meta));
        $page.find('.total-items span').html(data.meta.totalItemsCount);
        $('time.timeago').timeago();
      },
      error: (error) => {
        console.log(error);
      },
    });
  }

  function drawRows(items) {
    let html = '';
    items.forEach((item) => {
      let userStatus = 'No';
      if (item.frozen) userStatus = 'Frozen';
      if (item.banned) userStatus = 'Banned';
      if (item.muted) userStatus = 'Muted';
      const userStatusClass = item.banned
        ? 'banned-text'
        : item.frozen
        ? 'frozen-text'
        : 'unbanned-text';
      html += `<tr>
            <td><a href="/user/${item.gainId}" class="gainProfileLink" data-gainid="${
        item.gainId
      }">${item.username}</a></td>
            <td><i class="${
              item.reqType == 'freeze' ? 'frozen-text' : 'banned-text'
            } fas fa-ban"></i> ${item.reqType}</td>           
            <td>${item.reason}</td>
            <td>${item.attempts}</td>
            <td><a href="https://hub.veriff.com/verifications/${item.inquiryId}" target="_blank">${
        item.status
      }</a></td>
            <td>${item.addressCountryCode || '-'}</td>
            <td>${formatMoneyDisplay(item.spentInApp)}</td>
            <td><time class="timeago" datetime="${item.requestedAt}"></time></td>
            <td><time class="timeago" datetime="${item.updatedAt}"></time></td>
            <td class="${userStatusClass}">${userStatus}</td>
          </tr > `;
    });
    if (!html) html = '<tr class="empty"><td colspan="7">Empty...</td></tr>';
    return html;
  }

  function formatMoneyDisplay(value) {
    if (!value) return '$0.00';
    return '$' + app.utils.formatNumber(value, 2);
  }

  // copied from web/server/paginate.js
  function drawPagination(meta) {
    var i, len, prelink;
    var html = '<div><ul class="pagination unselectable">';
    if (meta.totalPages < 2) {
      html += '</ul></div>';
      return html;
    }
    if (meta.currentPage - 1 > 0) {
      html += `<li> <a class="waves-effect" data-value="${
        meta.currentPage - 1
      }" style="color: white"><i class="material-icons">chevron_left</i></a></li> `;
    } else {
      html +=
        '<li class="disabled"><a style="color: white"><i class="material-icons">chevron_left</i></a></li>';
    }
    for (i = 1; i <= meta.totalPages; i++) {
      if (i === meta.currentPage) {
        html += `<li class= "active waves-effect z-depth-1" style = "background-color: #34365c;" > <a class="" data-value="${i}">${i}</a></li> `;
      } else {
        html += `<li> <a class="waves-effect" style="color: white" data-value="${i}">${i}</a></li> `;
      }
    }
    if (meta.currentPage + 1 <= meta.totalPages) {
      html += `<li> <a data-value="${
        meta.currentPage + 1
      }" class="paginator-next waves-effect"><i class="material-icons" style="color: white">chevron_right</i></a></li> `;
    } else {
      html += `<li class= "disabled" > <a style="color: white"><i class="material-icons">chevron_right</i></a></li>`;
    }
    html += '</ul></div>';
    return html;
  }

  $(document).on('click', '.verif-completed-page .search-btn', function () {
    drawTable({});
  });

  $(document).on('click', '.verif-completed-page .pagination li:not(.disabled) a', function () {
    drawTable({
      page: $(this).data('value'),
    });
  });

  $(document).on('change', '.verif-completed-page select', function () {
    drawTable({});
  });
});

$(function () {
  let $page;
  function drawTable(filter) {
    $page = $('.verif-expired-page');
    $.ajax({
      method: 'GET',
      url: '/fc-api/id-verifications',
      data: {
        ...filter,
        username: $page.find('input[name=search]').val() || undefined,
        sort: $page.find('.order-field').val(),
        order: $page.find('.order-dir').val(),
        statuses: ['expired'],
        bannedOrFrozen: true,
        notMuted: 1,
      },
      success: (data) => {
        $page.find('tbody').html(drawRows(data.items));
        $page.find('.pagination-block').html(drawPagination(data.meta));
        $page.find('.total-items span').html(data.meta.totalItemsCount);
        $('time.timeago').timeago();
      },
      error: (error) => {
        console.log(error);
      },
    });
  }

  function drawRows(items) {
    let html = '';
    items.forEach((item) => {
      const { count, actionBtns } = genActionBtns(item);
      const userStatus = item.banned ? 'Banned' : item.frozen ? 'Frozen' : 'No';
      const userStatusClass = item.banned
        ? 'banned-text'
        : item.frozen
        ? 'frozen-text'
        : 'unbanned-text';
      html += `<tr>
            <td><a href="/user/${item.gainId}" class="gainProfileLink" data-gainid="${
        item.gainId
      }">${item.username}</a></td>
            <td class="id-req-type">${genReqTypeIcon(item)}</td>           
            <td class="${userStatusClass}">${userStatus}</td>
            <td>${item.reason}</td>
            <td class="id-attempts">${item.attempts}</td>
            <td>${genFlags(item)}</td>
            <td>${item.addressCountryCode || '-'}</td>
            <td>${formatMoneyDisplay(item.spentInApp)}</td>
            <td><time class="timeago" datetime="${item.updatedAt}"></time></td>
            <td class="inquiry-status"><a href="https://hub.veriff.com/verifications/${
              item.inquiryId
            }" target="_blank">${item.status}</a></td>
            <td colspan="${count}"><div class="td-actions">${actionBtns}</div></td>
          </tr>`;
    });
    if (!html) html = '<tr class="empty"><td colspan="7">Empty...</td></tr>';
    return html;
  }

  function formatMoneyDisplay(value) {
    if (!value) return '$0.00';
    return '$' + app.utils.formatNumber(value, 2);
  }

  function genReqTypeIcon(item) {
    return `<i class="${
      item.reqType == 'freeze' ? 'frozen-text' : 'banned-text'
    } fas fa-ban"></i> ${item.reqType}`;
  }

  function genFlags(item) {
    if (!item.flags) return 'N/A';
    let flagsHtml = '';
    const flags = item.flags.split(',');
    flags.forEach((flag) => {
      switch (flag) {
        case 'last name match':
          flagsHtml += `<a class="id-flag-modal" data-id="${item.id}" data-flag-match="${item.lastname}" data-flag="${flag}">${flag}</a>, `;
          break;
        case 'address match':
          flagsHtml += `<a class="id-flag-modal" data-id="${item.id}" data-flag-match="${item.addressStreet1}" data-flag="${flag}">${flag}</a>, `;
          break;
        case 'country mismatch':
          flagsHtml += `<span>${flag} (${item.addressCountryCode})</span>, `;
          break;
        default:
          flagsHtml += `<span>${flag}</span>, `;
      }
    });
    return flagsHtml.slice(0, -2);
  }

  function genActionBtns(item) {
    let count = 2;
    let actionBtns = ``;

    let unbanOrUnfreezeBtn = `<a class="waves-effect waves-light btn smallBtn orange change-user-status-btn" data-type="unban" data-status="${item.status}" data-gainid="${item.gainId}">Unban</a>`;
    let stayBannedOrBanBtn = `<a class="btn smallBtn red waves-effect stay-banned-btn" data-status="${item.status}" data-gainid="${item.gainId}">Stay Banned</a>`;
    if (item.reqType === 'freeze' && !item.banned) {
      unbanOrUnfreezeBtn = `<a class="waves-effect waves-light btn smallBtn blue change-user-status-btn" data-status="${item.status}" data-type="unfreeze" data-gainid="${item.gainId}">Unfreeze</a>`;
      stayBannedOrBanBtn = `<a class="btn smallBtn red waves-effect ban-btn change-user-status-btn" data-type="ban" data-status="${item.status}" data-gainid="${item.gainId}">Ban</a>`;
    }

    if (['completed', 'approved'].includes(item.status)) {
      count++;
      actionBtns += unbanOrUnfreezeBtn;
    }
    actionBtns += stayBannedOrBanBtn;

    if (['failed', 'expired'].includes(item.status) && item.attempts < 2) {
      let reqType = item.banned ? 'review' : item.reqType;
      count++;
      actionBtns += `<a class="btn smallBtn waves-effect request-verification-btn" data-req-type="${reqType}" data-reason="${item.reason}" data-gainid="${item.gainId}">Request again</a>`;
    }
    return { count, actionBtns };
  }

  // copied from web/server/paginate.js
  function drawPagination(meta) {
    var i, len, prelink;
    var html = '<div><ul class="pagination unselectable">';
    if (meta.totalPages < 2) {
      html += '</ul></div>';
      return html;
    }
    if (meta.currentPage - 1 > 0) {
      html += `<li><a class="waves-effect" data-value="${
        meta.currentPage - 1
      }" style="color: white"><i class="material-icons">chevron_left</i></a></li>`;
    } else {
      html +=
        '<li class="disabled"><a style="color: white"><i class="material-icons">chevron_left</i></a></li>';
    }
    for (i = 1; i <= meta.totalPages; i++) {
      if (i === meta.currentPage) {
        html += `<li class="active waves-effect z-depth-1" style="background-color: #34365c;"><a class="" data-value="${i}">${i}</a></li>`;
      } else {
        html += `<li><a class="waves-effect" style="color: white" data-value="${i}">${i}</a></li>`;
      }
    }
    if (meta.currentPage + 1 <= meta.totalPages) {
      html += `<li><a data-value="${
        meta.currentPage + 1
      }" class="paginator-next waves-effect"><i class="material-icons" style="color: white">chevron_right</i></a></li>`;
    } else {
      html += `<li class="disabled"><a style="color: white"><i class="material-icons">chevron_right</i></a></li>`;
    }
    html += '</ul></div>';
    return html;
  }

  $(document).on('click', '.verif-expired-page .search-btn', function () {
    drawTable({});
  });

  $(document).on('click', '.verif-expired-page .pagination li:not(.disabled) a', function () {
    drawTable({
      page: $(this).data('value'),
    });
  });

  $(document).on('change', '.verif-expired-page select', function () {
    drawTable({});
  });

  $(document).on(
    'click',
    '.verif-expired-page .change-user-status-btn:not(.disabled)',
    function () {
      $(this).parent().find(':not(.modViewSupportChatBtn)').addClass('disabled');
      socket.emit('modBan', {
        gainid: $(this).data('gainid'),
        reason: `ID verification ${$(this).data('status')}.`,
        publicReason: 'id-verification',
        type: $(this).data('type'),
      });
    }
  );

  $(document).on('click', '.verif-expired-page .stay-banned-btn:not(.disabled)', function () {
    const $tr = $(this).parents('tr');
    socket.emit(
      'alterBannedSupportTicket',
      {
        usergainid: $(this).data('gainid'),
        action: 'mute',
      },
      function (err, _data) {
        if (err) return;
        $tr.fadeOut();
        const $total = $page.find('.total-items span');
        $total.text(parseInt($total.text()) - 1);
      }
    );
  });

  $(document).on(
    'click',
    '.verif-expired-page .request-verification-btn:not(.disabled)',
    function () {
      console.log('dasd');
      const $this = $(this);
      $this.addClass('disabled');
      PostRequest('fc-api/id-verifications/request', {
        reason: $this.data('reason'),
        gainId: $this.data('gainid'),
        reqType: $this.data('req-type'),
        trigger: 'manual',
      })
        .then(({ message, verification }) => {
          toastAlert(message);
          const $tr = $this.parents('tr');
          $tr.find('td.inquiry-status')
            .html(`<a href="https://hub.veriff.com/verifications/${verification.inquiryId}"
            target="_blank">${verification.status}</a>`);
          $tr.find('.id-attempts').html(verification.attempts);
          $tr.find('.id-req-type').html(genReqTypeIcon(verification));
        })
        .catch((error) => {
          $this.removeClass('disabled');
          console.log(error);
          toastAlert(error.responseJSON.message);
        });
    }
  );

  let request;
  $(document).on('click', '.id-flag-modal', function () {
    const $this = $(this);
    const $modal = $('#idVerificationFlagsModal');
    const $loader = $modal.find('.datLoader');
    const $usersList = $modal.find('.verification-flags-users');
    $loader.show();
    $usersList.html('');
    $modal.find('.modal-header').html(`${$this.data('flag')} (${$this.data('flag-match')})`);
    openModal('#idVerificationFlagsModal');
    if (request) request.abort();
    request = $.ajax({
      method: 'GET',
      url: '/fc-api/id-verifications/flag-users',
      data: {
        id: $this.data('id'),
        flag: $this.data('flag'),
      },
      success: (users) => {
        $loader.hide();
        let usersHtml = '';
        users.forEach((user) => {
          usersHtml += `<a href="/user/${user.gainId}" class="gainProfileLink" data-gainid="${user.gainId}">${user.username}</a>, `;
        });
        $usersList.html(usersHtml.slice(0, -2));
      },
      error: (error) => {
        console.log(error);
      },
    });
  });
});

$(function () {
  let $page;
  function drawTable(filter) {
    $page = $('.kyc-verification-review-page');
    $.ajax({
      method: 'GET',
      url: '/fc-api/kyc-verifications',
      data: {
        ...filter,
        username: $page.find('input[name=search]').val() || undefined,
        sort: $page.find('.order-field').val(),
        order: $page.find('.order-dir').val(),
        statuses: ['requested', 'approved', 'declined'],
        bannedOrFrozen: true,
        notMuted: 1,
      },
      success: (data) => {
        $page.find('tbody').html(drawRows(data.items));
        $page.find('.pagination-block').html(drawPagination(data.meta));
        $page.find('.total-items span').html(data.meta.totalItemsCount);
        $('time.timeago').timeago();
      },
      error: (error) => {
        console.log(error);
      },
    });
  }

  function drawRows(items) {
    let html = '';
    items.forEach((item) => {
      const userStatus = item.banned ? 'Banned' : item.frozen ? 'Frozen' : 'No';
      const userStatusClass = item.banned
        ? 'banned-text'
        : item.frozen
        ? 'frozen-text'
        : 'unbanned-text';
      const kycStatusClass =
        item.status === 'approved'
          ? 'unbanned-text'
          : item.status === 'failed'
          ? 'banned-text'
          : 'frozen-text';
      html += `<tr>
            <td><a href="/user/${item.gainId}" class="gainProfileLink" data-gainid="${
        item.gainId
      }">${item.username}</a></td>
            <td class="${userStatusClass}">${userStatus}</td>
            <td>${item.reason}</td>
            <td class="id-attempts">${item.attempts}</td>
            <td>${item.failedReasons?.join(' , ') || ''}</td>
            <td><time class="timeago" datetime="${item.updatedAt}"></time></td>
            <td class="kyc-status ${kycStatusClass}">${item.status}</td>
          </tr>`;
    });
    if (!html) html = '<tr class="empty"><td colspan="7">Empty...</td></tr>';
    return html;
  }

  // copied from web/server/paginate.js
  function drawPagination(meta) {
    var i, len, prelink;
    var html = '<div><ul class="pagination unselectable">';
    if (meta.totalPages < 2) {
      html += '</ul></div>';
      return html;
    }
    if (meta.currentPage - 1 > 0) {
      html += `<li><a class="waves-effect" data-value="${
        meta.currentPage - 1
      }" style="color: white"><i class="material-icons">chevron_left</i></a></li>`;
    } else {
      html +=
        '<li class="disabled"><a style="color: white"><i class="material-icons">chevron_left</i></a></li>';
    }
    for (i = 1; i <= meta.totalPages; i++) {
      if (i === meta.currentPage) {
        html += `<li class="active waves-effect z-depth-1" style="background-color: #34365c;"><a class="" data-value="${i}">${i}</a></li>`;
      } else {
        html += `<li><a class="waves-effect" style="color: white" data-value="${i}">${i}</a></li>`;
      }
    }
    if (meta.currentPage + 1 <= meta.totalPages) {
      html += `<li><a data-value="${
        meta.currentPage + 1
      }" class="paginator-next waves-effect"><i class="material-icons" style="color: white">chevron_right</i></a></li>`;
    } else {
      html += `<li class="disabled"><a style="color: white"><i class="material-icons">chevron_right</i></a></li>`;
    }
    html += '</ul></div>';
    return html;
  }

  $(document).on('click', '.kyc-verification-review-page .search-btn', function () {
    drawTable({});
  });

  $(document).on(
    'click',
    '.kyc-verification-review-page .pagination li:not(.disabled) a',
    function () {
      drawTable({
        page: $(this).data('value'),
      });
    }
  );

  $(document).on('change', '.kyc-verification-review-page select', function () {
    drawTable({});
  });
});

$(function () {
  $(document).on('click', '.verif-review-page-btn', function () {
    const $page = $(`.${$(this).data('page')}`);
    if (!$page.hasClass('active')) {
      $('.verification-review-subpage.active').removeClass('active');
      $page.addClass('active');
    }
    $page.find('.search-btn').trigger('click');
  });
});

$(function () {
  function drawTable(filter) {
    const $page = $('.verif-waiting-page');
    $.ajax({
      method: 'GET',
      url: '/fc-api/id-verifications',
      data: {
        ...filter,
        username: $page.find('input[name=search]').val() || undefined,
        sort: $page.find('.order-field').val(),
        order: $page.find('.order-dir').val(),
        statuses: ['requested', 'pending'],
      },
      success: (data) => {
        $page.find('tbody').html(drawRows(data.items));
        $page.find('.pagination-block').html(drawPagination(data.meta));
        $page.find('.total-items span').html(data.meta.totalItemsCount);
        $('time.timeago').timeago();
      },
      error: (error) => {
        console.log(error);
      },
    });
  }

  function drawRows(items) {
    let html = '';
    items.forEach((item) => {
      html += `<tr>
            <td><a href="/user/${item.gainId}" class="gainProfileLink" data-gainid="${
        item.gainId
      }">${item.username}</a></td>
            <td><i class="${
              item.reqType == 'freeze' ? 'frozen-text' : 'banned-text'
            } fas fa-ban"></i> ${item.reqType}</td>
            <td>${item.reason}</td>
            <td>${item.attempts}</td>
            <td><a href="https://hub.veriff.com/verifications/${item.inquiryId}" target="_blank">${
        item.status
      }</a></td>
            <td>${item.addressCountryCode || '-'}</td>
            <td>${formatMoneyDisplay(item.spentInApp)}</td>
            <td><time class="timeago" datetime="${item.requestedAt}"></time></td>
            <td><time class="timeago" datetime="${item.updatedAt}"></time></td>
          </tr>`;
    });
    if (!html) html = '<tr class="empty"><td colspan="7">Empty...</td></tr>';
    return html;
  }

  function formatMoneyDisplay(value) {
    if (!value) return '$0.00';
    return '$' + app.utils.formatNumber(value, 2);
  }

  // copied from web/server/paginate.js
  function drawPagination(meta) {
    var i, len, prelink;
    var html = '<div><ul class="pagination unselectable">';
    if (meta.totalPages < 2) {
      html += '</ul></div>';
      return html;
    }
    if (meta.currentPage - 1 > 0) {
      html += `<li><a class="waves-effect" data-value="${
        meta.currentPage - 1
      }" style="color: white"><i class="material-icons">chevron_left</i></a></li>`;
    } else {
      html +=
        '<li class="disabled"><a style="color: white"><i class="material-icons">chevron_left</i></a></li>';
    }
    for (i = 1; i <= meta.totalPages; i++) {
      if (i === meta.currentPage) {
        html += `<li class="active waves-effect z-depth-1" style="background-color: #34365c;"><a class="" data-value="${i}">${i}</a></li>`;
      } else {
        html += `<li><a class="waves-effect" style="color: white" data-value="${i}">${i}</a></li>`;
      }
    }
    if (meta.currentPage + 1 <= meta.totalPages) {
      html += `<li><a data-value="${
        meta.currentPage + 1
      }" class="paginator-next waves-effect"><i class="material-icons" style="color: white">chevron_right</i></a></li>`;
    } else {
      html += `<li class="disabled"><a style="color: white"><i class="material-icons">chevron_right</i></a></li>`;
    }
    html += '</ul></div>';
    return html;
  }

  function getIsoString(date) {
    return new Date(date).toISOString().split('.')[0].slice(0, 10);
  }

  $(document).on('click', '.verif-waiting-page .search-btn', function () {
    drawTable({});
  });

  $(document).on('click', '.verif-waiting-page .pagination li:not(.disabled) a', function () {
    drawTable({
      page: $(this).data('value'),
    });
  });

  $(document).on('change', '.verif-waiting-page select', function () {
    drawTable({});
  });
});

/**
 * Click on 'Login' Button
 */
var profileCaptcha = null;

$(document).on('click', '#auth-login-button, .login-btn', function (e) {
  openReactAuthModal(0);
});

/**
 * Click on 'Register' Button
 */
$(document).on('click', '#auth-register-button, .open-register-modal', function (e) {
  openReactAuthModal(1);
});

/**
 * Click on "Login" in toggle Login/Register
 */
$(document).on('click', '.auth-login-btn', function (e) {
  toggleLogin();
});

/**
 * Click on "Reset password" in toggle Login/Register
 */
$(document).on('click', '#reset-password', function (e) {
  $('#login-form').hide();
  $('#reset-email-container').show();
});

/**
 * Click on "Cancel" in Reset Email
 */
$(document).on('click', '#reset-email-cancel', function (e) {
  $('#login-form').show();
  $('#reset-email-container').hide();
});

/**
 * Click on "Cancel" in Reset password
 */
$(document).on('click', '#reset-password-cancel', function (e) {
  $('#reset-password-container').hide();
  $('#login-form').show();
});

/**
 * Click on "Continue" in reset Email
 */
$(document).on('click', '#reset-email-continue', function (e) {
  const email = $('#reset-username').val();
  sendPassResetCode(email)
    .then((response) => {
      toastAlert(response);
      $('#reset-email-container').hide();
      $('#reset-password-container').show();
    })
    .catch((errorText) => {
      toastAlert('Error: ' + errorText);
    });
});

class AuthClientHelper {
  static getErrorMessage(response) {
    // This helper function will fix all the errors we get because of this line
    // rej(reason.responseJSON.errors?.[0] || reason.responseJSON.message)
    // sometimes responseJSON is undefined

    if (!response || !response.responseJSON) {
      return '';
    }

    const { errors, message } = response.responseJSON;

    if (Array.isArray(errors) && errors[0]) {
      return errors[0];
    }

    return message;
  }
}

function sendPassResetCode(username, recaptchaV2) {
  return new Promise((res, rej) => {
    grecaptcha.ready(function () {
      grecaptcha
        .execute('6LdWadMbAAAAAOSgP3qWVQ77e_7x4fVPDvZG_Tjv', { action: 'submit' })
        .then(function (token) {
          const url = 'fc-api/auth/reset-request';
          const headers = {
            'recaptcha-use-v2': recaptchaV2 ? true : false,
          };
          PostRequest(
            url,
            {
              username,
              email: username,
              captchaToken: recaptchaV2 ?? token,
            },
            headers
          )
            .then((response) => {
              res('Reset email successfully sent.');
            })
            .catch((reason) => {
              rej(reason.responseJSON);
            });
        })
        .catch((err) => {
          // Grecaptcha rejects with a string value "Timeout"
          if (err !== 'Timeout') {
            rej(err || 'Something went wrong. Please retry.');
          }
        });
    });
  });
}

/**
 * Click on "Reset password" in reset password
 */
$(document).on('click', '#reset-password-reset', function (e) {
  const passwordA = $('#reset-new-password').val();
  const passwordB = $('#reset-confirm-new-password').val();

  if (passwordA !== passwordB) {
    $('#reset-new-password').val('');
    $('#reset-confirm-new-password').val('');
    return toastAlert('Passwords do not match.');
  }

  resetPassport($('#reset-recovery-code').val(), passwordA, passwordB)
    .then((response) => {
      toastAlert(response);
      $('#reset-password-container').hide();
      $('#login-form').show();
    })
    .catch((errorText) => {
      toastAlert('Error: ' + errorText);
    });
});

function resetPassport(code, newPassword, newConfirmPassword, recaptchaV2) {
  return new Promise((res, rej) => {
    grecaptcha.ready(function () {
      grecaptcha
        .execute('6LdWadMbAAAAAOSgP3qWVQ77e_7x4fVPDvZG_Tjv', { action: 'submit' })
        .then(function (token) {
          const url = 'fc-api/auth/reset-password';
          const headers = {
            'recaptcha-use-v2': recaptchaV2 ? true : false,
          };
          PostRequest(
            url,
            {
              code,
              newPassword,
              newConfirmPassword,
              captchaToken: recaptchaV2 ?? token,
            },
            headers
          )
            .then((response) => {
              let message = 'Password successfully reset.';
              res(message);
              $('#reset-password-cancel').trigger('click');
            })
            .catch((reason) => {
              rej(reason.responseJSON);
            });
        })
        .catch((err) => {
          // Grecaptcha rejects with a string value "Timeout"
          if (err !== 'Timeout') {
            rej(err || 'Something went wrong. Please retry.');
          }
        });
    });
  });
}

/**
 * Click on "Register" in toggle Login/Register
 */
$(document).on('click', '.auth-register-btn', function (e) {
  toggleRegister();
});

/**
 * Click on LOGIN
 */
$(document).on('click', '#login-button', function (e) {
  if (checkIframeAndNavigate('login-button')) return;

  const username = $('#login-username').val(); // note: username is 'email'
  const password = $('#login-password').val();

  if (!username || !password) {
    return toastAlert('Please fill out all fields');
  }

  toastAlert('Signing In...');

  login(username, password).catch((error) => {
    toastAlert((error.errors && error.errors[0]) || error.message);
  });
});

function isKycRedirect() {
  var sPageURL = window.location.search.substring(1),
    sURLVariables = sPageURL.split('&'),
    sParameterName,
    i;

  for (i = 0; i < sURLVariables.length; i++) {
    sParameterName = sURLVariables[i].split('=');

    if (sParameterName[0] === 'redirect') {
      return sParameterName[1] === undefined
        ? false
        : decodeURIComponent(sParameterName[1] == 'kyc');
    }
  }
  return false;
}

function isRedirectToTopOfferPage() {
  const urlParams = new URLSearchParams(window.location.search);
  return urlParams.get('redirectUrl') === 'topoffer';
}

function login(username, password, verificationCode, recaptchaV2) {
  return new Promise((res, rej) => {
    grecaptcha.ready(function () {
      grecaptcha
        .execute('6LdWadMbAAAAAOSgP3qWVQ77e_7x4fVPDvZG_Tjv', { action: 'submit' })
        .then(function (token) {
          const url = 'fc-api/auth/login';
          const headers = {
            'recaptcha-use-v2': recaptchaV2 ? true : false,
          };
          PostRequest(
            url,
            {
              username: username.trim(),
              email: username.trim(),
              password: password,
              captchaToken: recaptchaV2 ?? token,
              nextUrl: window.location.pathname,
              verificationCode,
            },
            headers
          )
            .then((response) => {
              try {
                if (!response.accessToken) response = JSON.parse(response);
              } catch (e) {
                return console.error(e);
              }

              if (isRedirectToTopOfferPage()) {
                window.location.href = '/topoffer';
                return;
              }

              if (isKycRedirect()) {
                window.location.href = '/fc-api/kyc-verifications/start';
                return;
              }
              if (response.redirectUrl) {
                window.location.href = response.redirectUrl;
                return;
              }
              localStorage.removeItem('fc-reward-failed-game-offers');
              window.location.reload();
              res();
            })
            .catch((reason) => {
              rej(reason.responseJSON);
            });
        })
        .catch((err) => {
          // Grecaptcha rejects with a string value "Timeout"
          if (err !== 'Timeout') {
            rej({ message: err || 'Something went wrong. Please retry.' });
          }
        });
    });
  });
}

function authEnterPressed(e, eleId) {
  setTimeout(function () {
    if (e.keyCode == 13) {
      $(`#${eleId}`).click();
    }
  }, 1);
}

$(document).on('keydown', '#login-username, #login-password', function (e) {
  authEnterPressed(e, 'login-button');
});
$(document).on('keydown', '#register-email, #register-password', function (e) {
  authEnterPressed(e, 'register-button');
});
$(document).on('keydown', '#reset-username', function (e) {
  authEnterPressed(e, 'reset-email-continue');
});
$(document).on(
  'keydown',
  '#reset-recovery-code, #reset-new-password, #reset-confirm-new-password',
  function (e) {
    authEnterPressed(e, 'reset-password-reset');
  }
);

/**
 * Click on REGISTER
 */
$(document).on('click', '#register-button', function (e) {
  if (checkIframeAndNavigate('register-button')) return;

  const email = $('#register-email').val();
  const password = $('#register-password').val();
  const tosAgree = $('#tosAgreeCheckbox').is(':checked');

  if (!email || !password) {
    return toastAlert('Please fill out all fields');
  }

  if (!validateEmail(email)) {
    return toastAlert('Please enter a valid email address.');
  }

  if (!tosAgree) {
    return toastAlert('You need to agree to the Terms of Service.');
  }

  toastAlert('Signing Up...');

  register(email, password).catch((error) => {
    let errorMessage = (error.errors && error.errors[0]) || error.message;
    toastAlert(errorMessage);
  });
});

function openReactAuthModal(tabIndex, renderHeader) {
  if (checkIframeAndNavigate('auth-modal')) return;
  const isLiteMode = Boolean(Alpine.store('fcMain').isLiteMode);
  if (isLiteMode) {
    if (tabIndex === 0) {
      toggleLogin();
      openModal('#loginModalNew');
    }
    if (tabIndex === 1) {
      toggleRegister();
      openModal('#loginModalNew');
    }
  } else {
    const event = new CustomEvent('openReactAuth', {
      detail: {
        tab: tabIndex,
        renderHeader: renderHeader,
      },
    });
    window.dispatchEvent(event);
  }
}

function register(email, password, recaptchaV2, isSignupBonus, referralCode) {
  return new Promise((res, rej) => {
    grecaptcha.ready(function () {
      grecaptcha
        .execute('6LdWadMbAAAAAOSgP3qWVQ77e_7x4fVPDvZG_Tjv', { action: 'submit' })
        .then(function (token) {
          const url = 'fc-api/auth/register';
          const headers = {
            'recaptcha-use-v2': recaptchaV2 ? true : false,
          };
          PostRequest(
            url,
            {
              email: email,
              password: password,
              genUsername: true,
              captchaToken: recaptchaV2 ?? token,
              referralCode: referralCode,
            },
            headers
          )
            .then((response) => {
              localStorage.removeItem('premiumLiteOffersShown');
              localStorage.removeItem('earnGetStartedClose');
              localStorage.removeItem('fc-recurring-popups-countdown-info');
              localStorage.removeItem('fc-recurring-popups-cooldown-info');
              localStorage.removeItem('fc-last-seen-my-offer-ids');
              localStorage.removeItem('fc-dice-dream-extra-tasks-promotion-popup');
              localStorage.removeItem('fc-video-tap-guide');
              localStorage.removeItem('fc-reward-failed-game-offers');
              localStorage.removeItem('fc-cashout-bar-congrats-popup');
              localStorage.removeItem('fc-user-installed-game-offers');

              if (!!isSignupBonus) {
                localStorage.setItem('signupBonusEnabled', 'true');
              }

              if (isRedirectToTopOfferPage()) {
                window.location.href = '/topoffer';
                return;
              }

              if (response.accessToken) {
                let url = '/earn?signupSuccess=true';

                window.location.href = url;
              }

              try {
                response = JSON.parse(response);
              } catch (e) {
                return console.error(e);
              }

              if (response.redirectUrl) {
                window.location.href = response.redirectUrl;
                return;
              }

              toastAlert(
                'Successfully registered. Please check your E-Mail and verify your E-Mail Address!'
              );
              res(response);
            })
            .catch((reason) => {
              rej(reason.responseJSON);
            });
        })
        .catch((err) => {
          // Grecaptcha rejects with a string value "Timeout"
          if (err !== 'Timeout') {
            throw err;
          }
        });
    });
  });
}

function isIframe() {
  return window.location !== window.parent.location;
}

function checkIframeAndNavigate(authMethod) {
  if (isIframe() && window.app.utils.isMobile()) {
    const queryParams = new URLSearchParams({
      ...window.utm,
      sub2: authMethod,
    });

    const urlWithoutHash = `https://freecash.com/?${queryParams.toString()}`;
    const finalUrl = `${urlWithoutHash}#openAuthModal=true`;
    window.open(finalUrl, '_blank', 'noopener,noreferrer');
    return true;
  }
  return false;
}

function validateEmail(email) {
  return email.match(
    /^(([^<>()[\]\\.,;:+\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/
  );
}

function validateInput($input) {
  if ($input.val()) {
    $input.removeClass('invalid');
    return true;
  }
  $input.addClass('invalid');
  return false;
}

/**
 * Clears all textfields of the login form
 */
function clearLoginForm() {
  $('#login-username').val('');
  $('#login-password').val('');
}

/**
 * Clears all textfields of the register form
 */
function clearRegisterForm() {
  $('#register-email').val('');
  $('#register-password').val('');
}

function fixOpenFreeCaseText() {
  const el = document.getElementById('auth-modal-open-free-case-text');
  if (el) {
    setTimeout(() => {
      fixElementWidth(el);
    }, 300);
  }
}

/**
 * Opens the register panel
 */
function toggleRegister() {
  $('#login-form-container').hide();
  $('.loginIntroTextTerms').hide();
  $('#register-form-container').show();
  $('.auth-login-btn').removeClass('active');
  $('.auth-register-btn').addClass('active');
  fixOpenFreeCaseText();
}

function closeRegisterModal() {
  $('#loginModalNew').modal('close');
}

/**
 * Opens the login panel
 */
function toggleLogin() {
  $('#register-form-container').hide();
  $('.loginIntroTextTerms').show();
  $('#login-form-container').show();
  $('.auth-register-btn').removeClass('active');
  $('.auth-login-btn').addClass('active');
  fixOpenFreeCaseText();
}

if (!window.gainid) {
  // if user starts signup we trigger an event
  $(document).on('click', '[data-event="signup-initiated"]', function (e) {
    // console.log('signup-initiated', e);
    let $this = $(this);
    let source = $this.data('source');
    let method = $this.data('method');
    let isSignupBonus = $this.data('signupbonus');
    let isMobile = isPhone();
    let device = isMobile ? 'mobile' : 'desktop';

    window.dispatchEvent(
      new CustomEvent('signupInitiated', {
        detail: {
          device,
          source,
          method,
        },
      })
    );

    if (isSignupBonus) {
      setLocalStorage('signupBonusEnabled', 'true');
    }
  });
}
if (!window.gainid) {
  // if user clicks on any signup button except the main ones trigger an event
  $(document).on('click', '[data-event="signupButtonClicked"]', function (e) {
    // console.log('signup-initiated', e);
    let $this = $(this);
    let source = $this.data('source');
    let method = $this.data('method');
    let isMobile = isPhone();
    let device = isMobile ? 'mobile' : 'desktop';

    window.dispatchEvent(
      new CustomEvent('signupButtonClicked', {
        detail: {
          device,
          source,
          method,
        },
      })
    );
  });
}

/**
 * Will open the support chat on special notification click.
 */
function openSupportChat() {
  if (!gainid) {
    openModal('#supportSignupModal');
    return;
  }
  showIntercom();
  const interval = setInterval(() => {
    const $intercom = $('.intercom-messenger-frame');
    if ($intercom.length) {
      clearInterval(interval);
      $('.intercom-messenger-frame').append(`<div class="intercom-close-btn">
      <svg focusable="false" aria-hidden="true" width="8" height="8" viewBox="0 0 8 8" fill="none" xmlns="http://www.w3.org/2000/svg"><path fill-rule="evenodd" clip-rule="evenodd" d="M8 7.23251L7.23251 8L4 4.76749L0.767492 8L0 7.23251L3.23251 4L0 0.767492L0.767492 0L4 3.23251L7.23251 0L8 0.767492L4.76749 4L8 7.23251Z" fill="white"></path></svg>
      <div>`);
    }
  }, 1000);
}

function openChat() {
  const chatV2 = document.querySelector('.chat-v2');
  const isChatV2 = chatV2 !== null;
  if (document.getElementById('chat-nav')) {
    document.getElementById('chat-nav').classList.add('nav-active');
  }
  $('body').addClass('chatActive');
  if (isChatV2) {
    document.dispatchEvent(new CustomEvent('chatOpenedLegacy', { detail: { isOpen: true } }));
    window.Alpine?.store('fcMain').setChatOpened(true);
    return;
  }
  setLocalStorage('chatOpen', 'true');
  setTimeout(function () {
    jQuery(window).resize();
  }, 251);
}

function closeChat() {
  const chatV2 = document.querySelector('.chat-v2');
  const isChatV2 = chatV2 !== null;
  if (getLocalStorage('chatOpen') === 'false') return;
  if (document.getElementById('chat-nav')) {
    document.getElementById('chat-nav').classList.remove('nav-active');
  }
  $('body').removeClass('chatActive');
  if (isChatV2) {
    document.dispatchEvent(new CustomEvent('chatOpenedLegacy', { detail: { isOpen: false } }));
    window.Alpine?.store('fcMain').setChatOpened(false);
    return;
  }
  setLocalStorage('chatOpen', 'false');
  setTimeout(function () {
    jQuery(window).resize();
  }, 251);
}

function isChatOpen() {
  return getLocalStorage('chatOpen') == 'true';
}

function toggleChatV2(e) {
  if (e.detail.isOpen) {
    $('body').addClass('chatActive');
  } else {
    $('body').removeClass('chatActive');
  }
  $('body').addClass('chat-width-changing');
  setTimeout(function () {
    $('body').removeClass('chat-width-changing');
  }, 250);
  updateEarnPageSliders();
}

$(document).on('click', '.intercom-close-btn', function () {
  closeIntercom();
});

function closeIntercom() {
  window.Intercom && window.Intercom('hide');
}

function showIntercom() {
  window.Intercom && window.Intercom('show');
}

function shutdownIntercom() {
  window.Intercom && window.Intercom('shutdown');
  Intercom = null;
}

// Execute function by default - IIFE
(function () {
  const chatV2 = document.querySelector('.chat-v2');
  const isChatV2 = chatV2 !== null;
  if (isChatV2) {
    document.addEventListener('chatOpened', toggleChatV2);
    return;
  }
})();

let surveyModalsAlreadyOpen = {};

// TODO: migrated to WallCard.tsx to getSurveyWallURLHandler => Remove if not used
function getSurveyWallURL(slug, query = {}) {
  let url = `/w/${slug}`;
  if (query && query.length) {
    let arr = [];
    for (let key in query) {
      url += `${key}=${query[key]}`;
    }
    url += `?${arr.join('&')}`;
  }

  return url;
}

// TODO: migrated to WallCard.tsx to openSurveyTabHandler => Remove if not used
function openSurveyTab(slug) {
  if (!gainid) return;
  let wallUrl = getSurveyWallURL(slug);
  if (!wallUrl) return;
  window.open(wallUrl, '_blank').focus();
}

function openSurveyModal(slug) {
  if (!gainid) return;

  // Set a minor timeout to allow the modal to open before opening the onboarding modal
  // it will also allow react to load when this modal is opened on the first page load
  setTimeout(() => {
    if (window.openReactOfferWallOnboardingModal) {
      window.openReactOfferWallOnboardingModal();
    }
  }, 500);

  if (!surveyModalsAlreadyOpen[slug]) {
    if (slug === 'your-surveys-unlimited') return openModal('#modal_ys');
    let wallUrl = getSurveyWallURL(slug);
    if (!wallUrl) {
      return;
    }
    if (slug == 'tapjoy') return (window.location.href = window.location.origin + '/w/tapjoy');
    if (slug == 'playtime') return (window.location.href = window.location.origin + '/w/playtime');
    if (slug == 'digital-turbine')
      return (window.location.href = window.location.origin + '/w/digital-turbine');

    let symbol = wallUrl.includes('?') ? `&` : `?`;
    let embedUrl = wallUrl + symbol + `embed=true`;
    let $modal = $(`#${slug}ModalIframeContain`);
    if (!$modal) return;

    $modal.html(`<div class="progress ${slug}Progress lightPrimaryColor" style="margin: 0"><div class="indeterminate darkPrimaryColor"></div></div>
		<iframe style="width: 100%; height: 100%; border: none" class="surveyIframe" onload="iframeLoad('${slug}');" src="${embedUrl}"></iframe>`);

    surveyModalsAlreadyOpen[slug] = true;
  }

  openModal(`#${slug}Modal`, `/earn/${slug}`);
}

function openSurveyWallPage(slug) {
  if (!gainid) return;
  window.location.href = `${window.location.origin}/surveys/wall/${slug}`;
}

function iframeLoad(slug) {
  $(`.${slug}Progress`).remove();
}

$(document).on('click', '.custom-cpx-start-btn', function (e) {
  e.preventDefault();
  openSurveyTab('cpxresearch', { featured: true });
});

socket.on('dailyBonusClaimed', function () {
  $('.claimGainDailyBonusBtn').attr('disabled', 'true');
});

$(document).on('click', '.claimGainBonusCodeBtn', function () {
  socket.emit(
    'claimGainBonusCode',
    {
      code: $('#gainBonusCodeInput').val().trim(),
    },
    ({ codeStats }) => {
      AnalyticsService.bonusCodeUsed(codeStats);
    }
  );
});

$(document).on('click', '.claimGainDailyBonusBtn', function () {
  socket.emit('claimGainDailyBonus');
});

/*
  This is to set up the kind of tooltip that won't disappear immediately when cursor moves outside
  The trigger should be focusable element like <button>. <div> will not work on mobile.
*/
function setupInteractiveTooltip(triggerSelector, tooltipSelector) {
  var timerVariable;

  function hideOtherTooltips(exceptId) {
    $('.tooltip.show').each(function () {
      const tooltipId = $(this).attr('id');

      if (tooltipId === exceptId) {
        return;
      }

      $(`${triggerSelector}[aria-describedby=${tooltipId}]`).tooltip('hide');
    });
  }

  if (isTabletOrSmaller()) {
    /* For mobile, focus and blur event will trigger the triggerSelector */
    $(document).on('focus', triggerSelector, function () {
      $(this).tooltip('show');
      const currentId = $(this).attr('aria-describedby');
      hideOtherTooltips(currentId);
    });
    $(document).on('blur', triggerSelector, function () {
      $(this).tooltip('hide');
    });
  } else {
    /*
      For desktop or above
      - when mouse enters the trigger or the tooltip itself, show the tooltip
      - when mouse moves away from the trigger or the tooltip itslef, hide the tooltip

      The delay is 500ms.
    */
    $(document).on('mouseenter', triggerSelector, function () {
      $(this).tooltip('show');
      const currentId = $(this).attr('aria-describedby');
      hideOtherTooltips(currentId);
      clearTimeout(timerVariable);
    });

    $(document).on('mouseleave', triggerSelector, function () {
      timerVariable = setTimeout(() => {
        $(this).tooltip('hide');
      }, 500);
    });

    $(document).on('mouseenter', tooltipSelector, function () {
      clearTimeout(timerVariable);
    });

    $(document).on('mouseleave', tooltipSelector, function () {
      timerVariable = setTimeout(() => {
        $(this).tooltip('hide');
      }, 500);
    });
  }
}

$(function () {
  setupInteractiveTooltip('.offerWallTooltipTrigger', '.disabledTooltipContainer');
  setupInteractiveTooltip('.surveyTooltipTrigger', '.disabledTooltipContainer');
});

$(function () {
  const $goldenEggCaseModal = $('#goldenEggCaseModal');

  $(document).on('click', '.calendar-item.active .calendar-item-btn', function () {
    const $openButton = $(this);
    $openButton.parents('.calendar-item').removeClass('active').addClass('opened');
    $openButton.find('.cal-btn-text').text('opened');
    loadDayInfo().then(($dailyRewards) => showDailyRewards($dailyRewards, $openButton));
  });

  $(document).on('click', '.easter-reward-block.unlocked .show-egg-case-btn', function () {
    const $eggBlock = $(this).parents('.easter-reward-block');
    const egg = $eggBlock.data('egg');
    const $caseBlock = $('.easter-page .easter-eggs-case-block');
    const caseBlockHtmlTemplate = $('#easter-rewards-template .easter-eggs-case-block').html();
    $caseBlock.html(caseBlockHtmlTemplate); //reset old generated elements
    $caseBlock.removeClass('win');
    $caseBlock.data('egg', egg);
    $caseBlock.addClass(`egg-type-${egg.type}`);
    $caseBlock.find('.egg-rewards').html(getEggRewardsHtml(egg.rewards, true));
    $caseBlock.attr('id', 'easter-eggs-case-block');
    renderCaseItems($caseBlock, Object.assign({}, egg.rewards));
    loadDailyWinners([egg.type]);
    $('.easter-page .easter-rewards-content').addClass('show-case');
  });

  $(document).on(
    'click',
    '.easter-reward-block:not(.unlocked) .show-egg-case-btn, .golden-egg-section:not(.unlocked) .open-egg-btn',
    function () {
      if ($(this).parents('.easter-reward-block').hasClass('opened')) {
        toastAlert('You have already opened this.');
        return;
      }
      const secondsUntilEndOfEvent = parseInt($calendar.data('seconds-until-end'));
      if (secondsUntilEndOfEvent <= 0) {
        return toastAlert('Easter Event ended.');
      }
      toastAlert("You haven't earned enough coins yet to open this.");
    }
  );

  $(document).on('click', '.easter-eggs-case-block .open-case-btn', function () {
    const $this = $(this);
    const $caseBlock = $this.parents('.easter-eggs-case-block');
    const egg = $caseBlock.data('egg');
    $(`.egg-type-${egg.type}`).removeClass('unlocked').addClass('opened');
    $this.remove();
    $('body').trigger('playRollingCase', {
      modalId: '#easter-eggs-case-block',
      socketAction: 'claimEasterDailyReward',
      socketData: { eggType: egg.type },
      successMessage: 'Successfully claimed your reward!',
      possibleAmounts: [],
    });
  });

  $(document).on('click', '.easter-rewards-content .easter-close-btn', function () {
    const $this = $(this);
    if ($this.parents('.easter-rewards-content').hasClass('show-case')) {
      $this.parents('.easter-rewards-content').removeClass('show-case');
      loadDailyWinners();
      return;
    }
    $this.parents('.easter-rewards-block').remove();
    const $calItem = $('.easter-page .calendar-item.opened');
    $calItem.removeClass('opened').addClass('active');
    $calItem.find('.cal-btn-text').text('open');
  });

  $(document).on('click', '.golden-egg-section.unlocked .open-egg-btn', function () {
    socket.emit('goldenEggCaseModalHtml', {}, function (data) {
      if (!data) return;
      $goldenEggCaseModal.removeClass('win playing');
      $goldenEggCaseModal.html(data.html);
      $goldenEggCaseModal.data('possibleAmounts', data.possibleAmounts);

      $('body').trigger('showRollingCase', {
        modalId: '#goldenEggCaseModal',
        possibleAmounts: data.possibleAmounts,
        firstLevelOffsetLength: 5,
        onClose: () => {},
      });
    });
  });

  $(document).on('click', '#goldenEggCaseModal .open-case-btn', function () {
    $goldenEggCaseModal.removeClass('win');
    const $openBtn = $(this);
    $openBtn.prop('disabled', true);
    $('body').trigger('playRollingCase', {
      modalId: '#goldenEggCaseModal',
      socketAction: 'claimEasterGoldenReward',
      socketData: {},
      successMessage: `You've won $:amount!`,
      possibleAmounts: $goldenEggCaseModal.data('possibleAmounts'),
      postPlay: function (data) {
        const goldenEggInfo = data.goldenEggInfo;
        const $goldenEggSection = $('.golden-egg-section');
        if (!goldenEggInfo.unlocked) $goldenEggSection.removeClass('unlocked');
        $goldenEggSection.find('.earned-coins span').text(getCommas(goldenEggInfo.earnedCoins));
        $goldenEggSection
          .find('.reward-progress-percent')
          .css('width', `${goldenEggInfo.progress}%`);
      },
    });
  });

  $(document).on('click', '.calendar-item-view-winners', function () {
    const $openButton = $(this);
    const day = $openButton.parents('.calendar-item').data('day');
    $('.calendar-item.opened')
      .removeClass('opened')
      .addClass('active')
      .find('.cal-btn-text')
      .text('open');
    const $dailyRewards = $('#easter-rewards-template .easter-rewards-block').clone();
    socket.emit('getEasterWinnersHistory', { day }, function (data) {
      if (!data) return;
      $dailyRewards.find('.easter-winners-history-block').html(data.html || '');
      showDailyRewards($dailyRewards, $openButton, 'show-winners');
    });
  });

  initEasterTimers();

  function showDailyRewards($dailyRewards, $openButton, classList) {
    $('.easter-page .easter-rewards-block').remove();
    let currentScrollPos = $(document).scrollTop();
    if ($dailyRewards.hasClass('opened') && $dailyRewards.offset().top < currentScrollPos) {
      currentScrollPos -= $dailyRewards.height();
    }
    $dailyRewards.removeClass('opened').hide();
    const $currentElement = $openButton.parents('.calendar-item');
    const currentElementTopOffset = $currentElement.offset().top;
    let $rowLastElement = $currentElement;
    let $nextElement = $currentElement.next();
    while ($nextElement.length && $nextElement.offset().top - currentElementTopOffset <= 40) {
      $rowLastElement = $nextElement;
      $nextElement = $rowLastElement.next();
    }
    $dailyRewards.insertAfter($rowLastElement);
    $dailyRewards.show().addClass('opened');
    $dailyRewards.find('.easter-rewards-content').addClass(classList);
    const openBtnLeftOffset = $openButton.offset().left + $openButton.width() / 2;
    const dailyRewardsLeftOffset = $dailyRewards.offset().left;
    $dailyRewards.find('.top-arrow').css('left', `${openBtnLeftOffset - dailyRewardsLeftOffset}px`);
    $(document).scrollTop(currentScrollPos);
  }

  function loadDayInfo() {
    return new Promise((res, rej) => {
      socket.emit('getEasterDayInfo', {}, function (data) {
        const $dailyRewards = $('#easter-rewards-template .easter-rewards-block').clone();
        const $eggsRewordsBlock = $dailyRewards.find('.easter-reward-block');
        $eggsRewordsBlock.each((key, item) => {
          const $reward = $(item);
          const egg = data.eggByIndex[key];
          $reward.addClass(`egg-type-${egg.type}`);
          $reward.data('egg', egg);

          let earnedCoins = data.earnedCoins > egg.unlockCoins ? egg.unlockCoins : data.earnedCoins;
          let progress = (earnedCoins / egg.unlockCoins) * 100;
          $reward.find('.reward-progress-percent').css('width', progress);
          $reward
            .find('.earned-coins')
            .html(
              `Earn <span>${getCommas(earnedCoins)}</span> / ${getCommas(egg.unlockCoins)} Coins`
            );
          $reward.find('.egg-rewards').html(getEggRewardsHtml(egg.rewards));

          if (egg.opened) {
            $reward.addClass('opened');
          } else if (progress == 100) {
            $reward.addClass('unlocked');
          }
        });

        res($dailyRewards);
      });
    });
  }

  function renderCaseItems($case, rewards) {
    const $rewardSlider = $case.find('.rewards-slider');
    const $rewardItemTemplate = $case.find('.reward-item').eq(0).clone();
    let rewardsHtml = '';
    const possibleAmounts = rewards.coins.levels;
    delete rewards.coins;
    const specialRewards = Object.values(rewards);
    const specialRewardsKeys = Object.keys(rewards);
    const possibleRewardsCount = possibleAmounts.length + specialRewards.length - 1;
    let specialRewardOffset = 3; // the 1st level could be repeated not often, then after 7 items
    let specialRewardCurrentOffset = 0;
    let rewardStartIndex = 0;
    for (let i = 0; i < 150; i++) {
      let rewardWinIndex = Math.floor(getNumberInRange(rewardStartIndex, possibleRewardsCount));
      let specialReward = null;

      if (rewardWinIndex < specialRewards.length) {
        specialReward = specialRewards[rewardWinIndex];
        $rewardItemTemplate.find('.coin-amount').text(specialReward.title);
        $rewardItemTemplate.attr(
          'class',
          `reward-item win-prize-${specialRewardsKeys[rewardWinIndex]}`
        );

        rewardStartIndex = specialRewards.length;
        specialRewardCurrentOffset = 0;
      } else {
        rewardWinIndex = rewardWinIndex - specialRewards.length + 1;
        let amount = possibleAmounts[rewardWinIndex - 1];
        amount = getNumberInRange(possibleAmounts[rewardWinIndex], amount);
        $rewardItemTemplate.find('.coin-amount').text(`$${amount.toFixed(2)}`);
        $rewardItemTemplate.attr('class', `reward-item win-size-${rewardWinIndex}`);
      }

      // if last 1st level was more then 7 items ago then add it to possibilities
      if (specialRewardCurrentOffset >= specialRewardOffset) {
        rewardStartIndex = 0;
      }
      specialRewardCurrentOffset++;

      rewardsHtml += $rewardItemTemplate[0].outerHTML;
    }
    $rewardSlider.html(rewardsHtml);
  }

  function getEggRewardsHtml(rewards, showCanchesAndRanges) {
    let rewardsHtml = '';
    for (let rewardType in rewards) {
      const reward = rewards[rewardType];
      if (showCanchesAndRanges && reward.ranges) {
        reward.ranges.forEach((range) => {
          rewardsHtml += getEggRewardItemHtml(rewardType, range.title, range.chance);
        });
        continue;
      }
      rewardsHtml += getEggRewardItemHtml(
        rewardType,
        reward.title,
        showCanchesAndRanges ? reward.chance : null
      );
    }
    return rewardsHtml;
  }

  function getEggRewardItemHtml(rewardType, title, chance) {
    let rewardsHtml = ` <div class="reward-item easter-prize-${rewardType} ${
      chance ? 'show-chance' : ''
    }">
                      <img src="/public/img/easter/prize-${rewardType}.png" alt="Coins">
                      <span>${title}</span>`;
    if (chance) rewardsHtml += `<div class="reward-item-chance">${chance}</div>`;
    rewardsHtml += '</div>';
    return rewardsHtml;
  }

  function loadDailyWinners(eggTypes) {
    socket.emit('getEasterDailyWinners', { eggTypes }, function (data) {
      if (data) $('.easter-page .easter-daily-winners .top-winners-block').html(data.html || '');
    });
  }
});

const daySeconds = 60 * 60 * 24;

function initEasterTimers() {
  const $calendar = $('.easter-cal-row');
  const secondsUntilEndOfEvent = parseInt($calendar.data('seconds-until-end'));
  const startDateUnix = parseInt($calendar.data('start-date'));
  const todayUnix = parseInt($calendar.data('today'));
  const nowUnix = parseInt($calendar.data('now'));
  const $calendarItems = $calendar.find('.calendar-item');
  const days = $calendarItems.length;
  for (let i = 0; i < days; i++) {
    const currentDay = startDateUnix + i * daySeconds;
    const $currentItem = $calendarItems.eq(i);
    if (secondsUntilEndOfEvent <= 0 || currentDay < todayUnix) {
      $currentItem.addClass('closed').find('.cal-btn-text').text('closed');
    } else if (currentDay > todayUnix) {
      $currentItem.addClass('wating');
      updateCalendarItemTimer($currentItem, currentDay - nowUnix);
    } else {
      $currentItem.addClass('active');
      $currentItem.find('.calendar-item-btn').trigger('click');
    }
  }
}

function updateCalendarItemTimer($currentItem, seconds) {
  if (seconds > 2 * daySeconds) {
    $currentItem.find('.cal-btn-text').text(`${parseInt(seconds / daySeconds)} days`);
    return;
  }
  initTimer(
    seconds,
    null,
    () => {
      $currentItem.addClass('closed').removeClass('active').find('.cal-btn-text').text('closed');
    },
    (value) => {
      $currentItem
        .find('.cal-btn-text')
        .html(
          [':', ':', ''].map((unit, index) => `${addTrailingZero(value[index])}${unit}`).join('')
        );
    }
  );
}

const timerElement = document.getElementsByClassName('easter-timer')[0];
if (timerElement) {
  Tick.DOM.create(timerElement, {
    didInit: function (tick) {
      initTimer(
        timerElement.dataset.seconds,
        null,
        () => {
          $('.easter-page .easter-rewards-block ').remove();
          $('.open-egg-btn.btn-gold').text('CLOSED');
        },
        (value) => {
          tick.value = value;
        },
        ['d', 'h', 'm']
      );
    },
  });
}

const startTimerElement = document.getElementsByClassName('easter-start-timer')[0];
if (startTimerElement) {
  const timeElement = document.querySelector('.easter-start-timer .timer-values');
  console.log(timeElement);
  initTimer(
    startTimerElement.dataset.seconds,
    null,
    () => {
      startTimerElement.parentNode.removeChild(startTimerElement);
      window.reload();
    },
    (value) => {
      timeElement.innerHTML = ['', '', '']
        .map((unit, index) => `<span>${addTrailingZero(value[index])}${unit}</span>`)
        .join(':');
    }
  );
}

$(document).on('click', '.faqQuestion', function () {
  $faqItem = $(this).parent();
  $faqItem.toggleClass('faqItem--active');
});

function handleFaqLink(event) {
  event.preventDefault();
  return false;
}

const getScreenWidth = () =>
  window.innerWidth || document.documentElement.clientWidth || document.body.clientWidth;

class Slider {
  constructor(id, minSlideWidth, minSlideWidthChatOpen, getBreakpointOptions = () => {}) {
    this.initialized = false;
    this.id = id;
    this.minSlideWidth = minSlideWidth;
    this.minSlideWidthChatOpen = minSlideWidthChatOpen;
    this.gap = 10;
    this.maxSlidesCount = 14;
    this.getBreakpointOptions = getBreakpointOptions;
  }

  getOptions() {
    const slideWidth = isChatOpen() ? this.minSlideWidthChatOpen : this.minSlideWidth;

    const breakpoints = {
      0: {
        perPage: 3,
        perMove: 2,
        padding: {
          right: 50,
        },
        ...this.getBreakpointOptions(0, 3),
      },
    };
    let slidesCount = 4;

    while (slidesCount <= this.maxSlidesCount) {
      const screenWidth = (slideWidth + this.gap) * slidesCount;

      breakpoints[screenWidth] = {
        perPage: slidesCount,
        perMove: Math.floor(slidesCount * 0.8),
        padding: 0,
        ...this.getBreakpointOptions(screenWidth, slidesCount),
      };

      slidesCount += 1;
    }

    return {
      pagination: false,
      gap: this.gap,
      breakpoints: breakpoints,
      mediaQuery: 'min',
    };
  }

  initialize(force) {
    if (!this.initialized || force) {
      this.mounted = false;
      const el = $(`${this.id}`);
      if (el.length > 0) {
        this.splide = new Splide(this.id, this.getOptions());
        this.initialized = true;
      }
    }
  }

  mount(force) {
    if (force && this.splide) {
      this.splide.destroy();
    }
    if (!this.initialized || force) {
      this.initialize(force);
    }

    if (!this.mounted || force) {
      if (this.splide) {
        this.splide.mount();
        this.mounted = true;
      }
    }
  }

  /**
   * Update the slider options and re-mount the slider
   * @param {boolean} force - whether to forcefully update the slider, without checking if the
   *                          number of offers on this screen width has changed
   */
  update(force) {
    this.mount();

    const screenWidth = getScreenWidth();
    const screenWidthThreshold = (this.minSlideWidthChatOpen + this.gap) * this.maxSlidesCount;

    // Do not update past a certain screen width because the slider will be reset but the number of offers will
    // be the same as before
    if (force || screenWidth < screenWidthThreshold) {
      this.mount(true);
    }
  }

  removeSlidesBySelector(selector) {
    // Initialize if not initialized
    if (!this.splide) {
      this.initialize();
    }

    // Initialization doesn't guarantee that the slider is mounted
    // because the element used for initialization might not be present
    if (this.splide) {
      this.splide.Components.Slides.remove(selector);
    }
  }
}

let deviceSelectDropdown;

const featuredOffersSlider = new Slider(
  '#featured-offers-slider',
  135,
  160,
  (breakpoint, slidesPerPage) => {
    return {
      padding: {
        left: 'var(--earn-page-section-padding-horizontal)',
        right: 'var(--earn-page-section-padding-horizontal)',
      },
      drag: 'free',
      fixedWidth: `calc(100% / ${slidesPerPage + 0.8})`,
    };
  }
);

const surveysSlider = new Slider(
  '#surveys-slider',
  155,
  175,
  featuredOffersSlider.getBreakpointOptions
);

const surveysSkeletonsSlider = new Slider(
  '#survey-partners-skeletons-slider',
  surveysSlider.minSlideWidth,
  surveysSlider.minSlideWidthChatOpen,
  surveysSlider.getBreakpointOptions
);

const featuredSurveysSkeletonsSlider = new Slider(
  '#featured-surveys-skeletons-slider',
  featuredOffersSlider.minSlideWidth,
  featuredOffersSlider.minSlideWidthChatOpen,
  featuredOffersSlider.getBreakpointOptions
);

const FEATURED_OFFER_SKELETON = `
    <div class='featured-offer-skeleton splide__slide'>
      <div class='featured-offer-skeleton-image'></div>
      <div class='featured-offer-skeleton-title'>&nbsp;</div>
      <div class='featured-offer-skeleton-description'>&nbsp;</div>
      <div class='featured-offer-skeleton-footer'>
        <div class='featured-offer-skeleton-reward'>&nbsp;</div>
        <div class='featured-offer-skeleton-category'>&nbsp;</div>
      </div>
    </div>
    `;

function addOfferSkeletons(count, container) {
  Array.from({ length: count }).forEach(() => container.append(FEATURED_OFFER_SKELETON));
}

function removeOfferSkeletons(container) {
  container.find('.featured-offer-skeleton:not(.no-remove)').remove();
}

function initTooltips() {
  const questionMarks = $('.featured-survey-question-mark');
  let tooltipTimer = null;
  let currentTooltipId = null;

  questionMarks.each(function () {
    let $questionMark = $(this);
    const title = $questionMark.parent().find('.tooltip-content').html();

    if (!title) {
      return;
    }

    const tootlipId = `tt-${Math.floor(Math.random() * 100000)}`;
    $questionMark.attr('data-tooltip-id', tootlipId);
    $questionMark.tooltip({
      title: title,
      sanitize: false,
    });

    $questionMark
      .on('mouseenter', function () {
        const theTooltipId = $(this).attr('data-tooltip-id');
        if (currentTooltipId && currentTooltipId === theTooltipId) {
          clearTimeout(tooltipTimer);
        }

        tooltipTimer = setTimeout(() => {
          $questionMark.tooltip('show');
        }, 250);

        currentTooltipId = theTooltipId;
      })
      .on('mouseleave', function () {
        clearTimeout(tooltipTimer);
        tooltipTimer = setTimeout(() => {
          $questionMark.tooltip('hide');
        }, 125);
      });
  });

  $(document)
    .on('mouseenter', '.tooltip.featuredOfferTooltipContainer', function () {
      clearTimeout(tooltipTimer);
    })
    .on('mouseleave', '.tooltip.featuredOfferTooltipContainer', function () {
      if (tooltipTimer) {
        tooltipTimer = setTimeout(() => {
          $(this).tooltip('hide');
        }, 500);
      }
    });
}

const handleOnFeaturedOffersAppended = function () {
  // Replacing the offer's respective modal with signUp modal
  $('#featuredOffers--loggedOut').find('.modal-trigger').attr('href', '#loginModalNew');

  // Some offer has onclick event instead of <a>. We removed the original onclick handler.
  $('#featuredOffers--loggedOut').find('.featured-box').attr('onclick', null);
};

function checkRemainingScrollWidth(el, direction = 'left') {
  const scrollWidth = el.scrollWidth;
  const clientWidth = el.clientWidth;
  const scrollLeft = el.scrollLeft;

  if (direction === 'left') {
    return scrollLeft > 0;
  } else {
    return Math.floor(scrollWidth - clientWidth - scrollLeft) > 0;
  }
}

function updateCustomScrollerArrows(container, arrowsContainer) {
  const arrowPrev = arrowsContainer.find('.earn-scroll-arrow-prev');
  const arrowNext = arrowsContainer.find('.earn-scroll-arrow-next');

  if (arrowPrev) {
    if (checkRemainingScrollWidth(container[0], 'left')) {
      arrowPrev.attr('disabled', false);
    } else {
      arrowPrev.attr('disabled', true);
    }
  }

  if (arrowNext) {
    if (checkRemainingScrollWidth(container[0], 'right')) {
      arrowNext.attr('disabled', false);
    } else {
      arrowNext.attr('disabled', true);
    }
  }
}

function initializeCustomScroller() {
  $('.custom-scroller').each(function () {
    const arrowsContainer = $('#' + $(this).data('arrows-container-id'));

    $(this).on(
      'scroll',
      window.app.utils.debounce(() => {
        updateCustomScrollerArrows($(this), arrowsContainer);
      }, 200)
    );

    if (arrowsContainer) {
      const arrowPrev = arrowsContainer.find('.earn-scroll-arrow-prev');
      const arrowNext = arrowsContainer.find('.earn-scroll-arrow-next');

      if (arrowPrev) {
        arrowPrev.on('click', () => {
          $(this).animate({
            scrollLeft: '-=400',
          });
        });
      }

      if (arrowNext) {
        arrowNext.on('click', () => {
          $(this).animate({
            scrollLeft: '+=400',
          });
        });
      }
    }
  });
}

function initializeEarnPage() {
  featuredOffersSlider.mount(true);
  featuredSurveysSkeletonsSlider.mount(true);
  surveysSkeletonsSlider.mount(true);
  surveysSlider.mount(true);

  initializeSelectDropdowns();
  initializeCustomScroller();

  $('.earnHeaderViewAll').on('click', function () {
    showOffersPageGoBackButton = true;
  });

  if (window.app.utils.isMobile()) {
    loadFreeCase();
  }
}

function initializeSurveysPage() {
  surveysSlider.mount(true);

  $('.earnHeaderViewAll').on('click', function () {
    showOffersPageGoBackButton = true;
  });
}

function updateEarnPageSliders() {
  featuredOffersSlider.update();
  surveysSlider.update();
}

function initializeCategoryHover() {
  const elements = $('.featured-survey-category');
  elements.on('mouseenter', function () {
    const el = $(this)[0];
    if (el) {
      const isEllipsisActive = el.offsetWidth < el.scrollWidth;

      if (isEllipsisActive) {
        const amountContainer = el.parentElement.querySelector('.featured-survey-amount-wrapper');
        if (amountContainer) {
          amountContainer.classList.add('featured-survey-amount-wrapper-hidden');
        }
      }
    }
  });
  elements.on('mouseleave', function () {
    const el = $(this)[0];
    if (el) {
      const amountContainer = el.parentElement.querySelector('.featured-survey-amount-wrapper');
      if (amountContainer) {
        amountContainer.classList.remove('featured-survey-amount-wrapper-hidden');
      }
    }
  });
}

const selectDropdownCheckbox = `
  <span class='dropdown-item-check'>
    <img loading='lazy' src='/public/img/earn/select-check.svg' />
  </span>
`;

const selectDropdownCheckboxUnChecked = `
  <span class="dropdown-item-uncheck"></span>
`;

class SelectDropdown {
  constructor(options) {
    const { selector, initialValue, onChange, type = 'single', iconsOnlyWhenClosed } = options;

    this.selector = selector;
    this.value = initialValue;

    if (!this.value && type === 'multiple') {
      this.value = [];
    }
    this.type = type;

    this.onChange = onChange;
    this.iconsOnlyWhenClosed = iconsOnlyWhenClosed;
  }

  get isMultiple() {
    return this.type === 'multiple';
  }

  getOptionLabel(value) {
    const optionButton = this.getOptionButton(value);

    if (optionButton) {
      return optionButton.find('.dropdown-item-text').text();
    }
  }

  getOptionIcon(value) {
    const optionButton = this.getOptionButton(value);

    if (optionButton) {
      return optionButton.find('.dropdown-item-icon').html();
    }
  }

  getOptionButton(value) {
    return this.$el.find(`[data-value="${value}"]`);
  }

  removeCheckedIcon() {
    this.$el.find('.dropdown-item-check').remove();
  }

  setValue(value) {
    this.value = value;

    if (Array.isArray(value)) {
      this.removeCheckedIcon();
      for (const item of value) {
        const el = this.getOptionButton(item);
        el.append(selectDropdownCheckbox);
      }
    }

    this.update();
    if (this.onChange) {
      this.onChange(this.value);
    }
  }

  select(value) {
    if (this.isMultiple) {
      if (this.value.indexOf(value) === -1) {
        this.value.push(value);
      }
    } else {
      // Remove the checked icon from the previous selected option (only for single select)
      this.removeCheckedIcon();
      this.value = value;
    }

    const el = this.getOptionButton(value);
    el.find('.dropdown-item-uncheck').remove();
    el.append(selectDropdownCheckbox);

    this.update();
  }

  unselect(value) {
    const el = this.getOptionButton(value);
    el.find('.dropdown-item-check').remove();
    el.append(selectDropdownCheckboxUnChecked);

    if (this.isMultiple) {
      this.value = this.value.filter((v) => v !== value);
    } else {
      this.value = null;
    }

    this.update();
  }

  update() {
    this.updateLabel();
    this.updateIcon();
  }

  updateLabel() {
    if (!this.iconsOnlyWhenClosed) {
      let optionValue;

      if (this.isMultiple) {
        optionValue = this.value[0];
      } else {
        optionValue = this.value;
      }

      if (optionValue) {
        let firstOptionLabel = this.getOptionLabel(optionValue);

        if (this.isMultiple && this.value.length > 1) {
          firstOptionLabel = `${firstOptionLabel} (+${this.value.length - 1})`;
        }

        this.setLabel(firstOptionLabel);
      }
    } else {
      this.setLabel('');
    }
  }

  updateIcon() {
    if (!this.iconsOnlyWhenClosed) {
      let optionValue;

      if (this.isMultiple) {
        optionValue = this.value[0];
      } else {
        optionValue = this.value;
      }

      if (optionValue) {
        const firstOptionIcon = this.getOptionIcon(optionValue);
        this.setIcon(firstOptionIcon);
      }
    } else {
      const icons = this.value.map((v) => this.getOptionIcon(v));
      this.setIcon(...icons);
    }
  }

  setLabel(label) {
    const labelEl = this.$el.find('.earn-select-dropdown-label');
    if (label) {
      labelEl.text(label.trim());
    } else {
      labelEl.text('').hide();
    }
  }

  setIcon(...icons) {
    const container = this.$el.find('.earn-select-dropdown-icon');
    container.html('');

    icons.forEach((icon) => {
      container.append(icon);
    });
  }

  isSelected(value) {
    return this.value.indexOf(value) !== -1;
  }

  init() {
    this.$el = $(this.selector);

    if (this.isMultiple) {
      this.value.forEach((value) => {
        this.select(value);
      });
    } else {
      this.select(this.value);
    }

    $(`${this.selector} .dropdown-item`).click((e) => {
      e.stopPropagation();
      const dropdownItem = $(e.target).closest('.dropdown-item');

      const value = dropdownItem.attr('data-value');
      if (this.isSelected(value)) {
        // Unselect the value only if this is a multiple select
        if (this.isMultiple) {
          this.unselect(value);
        }
      } else {
        this.select(value);
      }

      if (this.onChange) {
        this.onChange(this.value);
      }
    });
  }
}

const DEVICE_DROPDOWN_VALUE_KEY_OLD = 'deviceDropdownValue';
const DEVICE_DROPDOWN_VALUE_KEY = 'deviceDropdownValue_v2';

function setStorageDeviceDropdownValue(value) {
  setLocalStorage(DEVICE_DROPDOWN_VALUE_KEY, value);
}

function getStorageDeviceDropdownValue() {
  const newDeviceDropdown = getLocalStorage(DEVICE_DROPDOWN_VALUE_KEY);
  if (newDeviceDropdown) {
    return newDeviceDropdown;
  }

  if (!window.app.utils.isIos() && !window.app.utils.isAndroid()) {
    // if new localStorage key is not found then:
    // on desktop - use old filters
    // on mobile - reset filters to default (just 'ios' or 'android')
    return getLocalStorage(DEVICE_DROPDOWN_VALUE_KEY_OLD);
  }
}

function getDefaultDeviceSelectDropdownValue() {
  const deviceSelectedOptions = [];

  if (window.app.utils.isIos()) {
    deviceSelectedOptions.push('ios');
  } else if (window.app.utils.isAndroid()) {
    deviceSelectedOptions.push('android');
  } else {
    deviceSelectedOptions.push('windows');
    deviceSelectedOptions.push('ios');
    deviceSelectedOptions.push('android');
  }

  return deviceSelectedOptions;
}

function getDeviceSelectDropdownValue() {
  const fromStorage = getStorageDeviceDropdownValue();

  if (fromStorage) {
    try {
      return JSON.parse(fromStorage);
    } catch (e) {
      // Ignore
    }
  }

  return getDefaultDeviceSelectDropdownValue();
}

function getOffersPageCategory() {
  let category;

  const parts = window.location.pathname.split('/');
  const secondPart = parts[2];

  if (parts[1] === 'offers' && secondPart) {
    category = secondPart;
  }

  return category;
}

function buildFeaturedOffersRequestPayload(selectedOptions = getDeviceSelectDropdownValue()) {
  return {
    limit: 30,
    isDesktop: selectedOptions.includes('windows'),
    isAndroid: selectedOptions.includes('android'),
    isIos: selectedOptions.includes('ios'),
    category: getOffersPageCategory(),
    sortBy: 'most-popular',
  };
}

function initializeSelectDropdowns() {
  deviceSelectDropdown = new SelectDropdown({
    selector: '#earn-page-device-select-dropdown',
    initialValue: getDeviceSelectDropdownValue(),
    onChange: (selectedOptions) => {
      setStorageDeviceDropdownValue(JSON.stringify(selectedOptions));
      if (window.reactUpdateFeaturedOffers) {
        window.reactUpdateFeaturedOffers();
      }
    },
    type: 'multiple',
    iconsOnlyWhenClosed: true,
  });
  deviceSelectDropdown.init();
}

function createMoreRewardsTag(rewardsContainer) {
  const tag = document.createElement('div');
  tag.classList.add('more-tag');
  const icon = document.createElement('span');
  icon.innerHTML =
    '<svg width="9" height="12" viewBox="0 0 9 12" fill="none" xmlns="http://www.w3.org/2000/svg">' +
    '<path d="M8.21875 7.23926L4.5 11.1351L0.78125 7.23926" stroke="white" stroke-linecap="round" stroke-linejoin="round"/>' +
    '<path d="M4.5 10.4268V0.864258" stroke="white" stroke-linecap="round" stroke-linejoin="round"/>' +
    '</svg>';
  icon.style['margin-right'] = '10px';
  icon.style.height = '12px';
  const text = document.createElement('span');
  text.innerText = 'More Rewards';
  tag.append(icon, text);

  const tagContainer = document.createElement('div');
  tagContainer.append(tag);
  tagContainer.classList.add('more-tag-container');

  $(tag).on('click', function () {
    rewardsContainer.scrollIntoView({
      behavior: 'smooth',
      block: 'start',
    });
  });

  return tagContainer;
}

function openOfferModal(
  slug,
  source,
  offerPosition = null,
  offerOpenSourceCategory = null,
  openOptions = null
) {
  if (window.app.utils.isLoggedIn()) {
    let url = `/offer/${slug}`;
    if (source === 'jackpot') {
      url += '?source=jackpot';
    }

    openPage('offer', url, {
      type: 'modal',
      modalType: 'offer',
      data: {
        slug,
        source,
        offerPosition,
        offerOpenSourceCategory,
        openOptions,
      },
    });
  } else {
    openReactAuthModal(1);
  }
}

function handleOfferCardClick(el) {
  el.find('.featured-offer-card-loader').remove();
  el.append(`
    <div class="featured-offer-card-loader flex">
      <div style="margin: auto">
        <div class="featured-offer-card-spinner"></div>
      </div>
    </div>
  `);

  const offer = el.data('offer');
  const clickSource = el.data('clickSource');
  const offerPosition = el.data('offerPosition');
  const offerOpenSourceCategory = el.data('offerOpenSourceCategory');
  openOfferModal(offer.slug, clickSource, offerPosition, offerOpenSourceCategory);
}

$(document).on('click', `.featured-offer-card`, function (e) {
  e.preventDefault();
  const target = $(this);
  handleOfferCardClick(target);
});

function handleOfferClick(
  offer,
  clickSource,
  offerPosition = null,
  offerOpenSourceCategory = null
) {
  const $offer = $(`#${offer.id}`);
  $offer.data('offer', offer);
  $offer.data('clickSource', clickSource);
  $offer.data('offerPosition', offerPosition);
  $offer.data('offerOpenSourceCategory', offerOpenSourceCategory);
}

function init() {
  $('.qr-modal-go-back-button, .qr-modal-close-button').on('click', function () {
    const parent = $(this).closest('.featured-offer-qr-modal-v2');
    $(parent).modal('close');
  });

  window.addEventListener('fc:offer-modal-opened', function () {
    // Remove all loaders
    $('.featured-offer-card-loader').remove();
  });

  window.addEventListener('fc:trigger-reload-offers', function () {
    if (deviceSelectDropdown && typeof deviceSelectDropdown.setValue === 'function') {
      deviceSelectDropdown.setValue(getDeviceSelectDropdownValue());
    }
  });
}

$(document).on('featuredOffers.appended', handleOnFeaturedOffersAppended);
$(document).ready(handleOnFeaturedOffersAppended);
$(document).ready(init);

function loadFreeCase(show) {
  if (show) {
    window.dispatchEvent(new CustomEvent('fc:open-freecase-modal'));
  }
}

$(function () {
  $(document).on('click', '.free-case-open-btn', () => {
    loadFreeCase(true);
  });
});

var captchaTokenLite = null;
var captchaTokenLoginLite = null;

document.addEventListener('alpine:init', () => {
  const emptyOffer = {
    offerValueDisplay: '',
    offerValueRaw: 0,
    thumbnail: '',
    is_ios: false,
    is_android: false,
    is_desktop: false,
    name: '',
  };

  function getSlidesPerView() {
    const width = document.querySelector('#almaView').clientWidth || 0;

    return Math.max(1.5, width / 300);
  }

  const handleLiteRegistration = async (email, password, captchaTokenLite, isSignupBonus) => {
    try {
      await register(email, password, captchaTokenLite, isSignupBonus);
    } catch (error) {
      if (captchaTokenLite) {
        grecaptcha.reset();
      }
      let errorMessage = (error.errors && error.errors[0]) || error.message;
      if (errorMessage) {
        toastAlert(errorMessage, null, { type: 'error' });
        if (error.statusCode === 412) {
          grecaptcha.render('my-lite-grecaptcha', {
            sitekey: '6LfxOKooAAAAAN9eUbmm3NgJwj4wWHpe-UGNHWlG',
            callback: (token) => {
              window.captchaTokenLite = token;
            },
          });
        }
      }
    }
  };

  const handleLiteLogin = async (email, password, undefined, captchaTokenLoginLite) => {
    const modal = $('#loginModalNew');
    try {
      await login(email, password, undefined, captchaTokenLoginLite);
    } catch (error) {
      if (captchaTokenLoginLite) {
        grecaptcha.reset();
      }
      let errorMessage = (error.errors && error.errors[0]) || error.message;
      if (error.statusCode === 412) {
        grecaptcha.render('login-lite-grecaptcha', {
          sitekey: '6LfxOKooAAAAAN9eUbmm3NgJwj4wWHpe-UGNHWlG',
          callback: (token) => {
            window.captchaTokenLoginLite = token;
          },
        });
      }
      if (error.errors[0] === 'unauthorized_login') {
        modal.modal('close');
        errorMessage = error.message;
        var evt = new CustomEvent('openAuth', { detail: { email: email, password: password } });
        window.dispatchEvent(evt);
      }
      toastAlert(errorMessage);
    }
  };

  Alpine.data('authLite', () => ({
    registerBox: {
      email: '',
      password: '',
      isRevealingPassword: false,
      checkAgreeTnc: false,
      checkNewsletter: false,
    },
    login: {
      email: '',
      password: '',
    },
    forgotPassword: {
      email: '',
    },
    recoverPassword: {
      code: '',
      newPassword: '',
      confirmPassword: '',
    },
    screen: 'default',

    validatePassword() {
      const password = this.registerBox.password;
      if (typeof password !== 'string') return [false, 'Password is required'];

      if (password.length < 8) return [false, 'Must be at least 8 characters'];
      if (password.length > 100) return [false, 'Must be less than 100 characters'];
      if (!password.match(/[A-Z]/)) return [false, 'Must contain at least one uppercase letter'];
      if (!password.match(/[a-z]/)) return [false, 'Must contain at least one lowercase letter'];
      if (password.match(/\s/)) return [false, 'Must not contain any spaces'];

      const blacklisted = ['Passw0rd', 'Password123'];
      if (blacklisted.includes(password)) return [false, 'Password is too common'];

      return [true, null];
    },

    doSendResetEmail(hasError, allErrors) {
      if (hasError) {
        return;
      }
      const modal = $('#loginModalNew');
      const email = this.forgotPassword.email;

      sendPassResetCode(email)
        .then((response) => {
          toastAlert(response);
          modal.modal('close');
          var evt = new CustomEvent('openEmailSent', { detail: { email: email } });
          window.dispatchEvent(evt);
        })
        .catch((error) => {
          let errorMessage = (error.errors && error.errors[0]) || error.message;
          toastAlert(errorMessage);
        });
    },

    doUpdatePassword(hasError, allErrors) {
      if (hasError) {
        return;
      }

      const newPassword = this.recoverPassword.newPassword;
      const confirmPassword = this.recoverPassword.confirmPassword;

      if (newPassword !== confirmPassword) {
        this.recoverPassword.newPassword = '';
        this.recoverPassword.confirmPassword = '';
        return toastAlert('Passwords do not match.');
      }

      resetPassport(this.recoverPassword.code, newPassword, confirmPassword)
        .then((response) => {
          toastAlert(response);
          this.screen = 'default';
        })
        .catch((errorText) => {
          toastAlert('Error: ' + errorText);
        });
    },

    doLogin(hasError, allErrors) {
      if (hasError) {
        return;
      }
      const modal = $('#loginModalNew');
      toastAlert('Signing In...', null, {
        type: 'info',
      });
      const { email, password } = this.login;
      handleLiteLogin(email, password, undefined, captchaTokenLoginLite);
    },

    doRegister(hasError, allErrors, isSignupBonus) {
      if (checkIframeAndNavigate('freecash-lite-register')) return;
      if (hasError) {
        return;
      }

      toastAlert('Signing Up...', null, {
        type: 'info',
      });

      const { email, password } = this.registerBox;
      handleLiteRegistration(email, password, captchaTokenLite, isSignupBonus);
    },
  }));
});

function runGraphql(query, variables) {
  return new Promise((res, rej) => {
    fetch('/fc-api/graphql', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        Accept: 'application/json',
      },
      body: JSON.stringify({
        query,
        variables,
      }),
    })
      .then((r) => res(r))
      .catch((e) => rej(e));
  });
}

var captchaTokenHome = null;

const GET_SURVEYS_COUNTRY_STATS = `query {
  getSurveyCountryStats{
    availableCount,
    highestPaying
  }
}`;

const calculateStep = ({ strip, rangeMin, rangeMax, parallaxValueFull }) => {
  const stripPercentage = (parallaxValueFull - rangeMin) / (rangeMax - rangeMin);
  return strip.from + (strip.to - strip.from) * stripPercentage;
};

const moveHandler =
  ({ rangeMin, rangeMax, el, dimension = '' }) =>
  (strip, propertyName, parallaxValueFull) => {
    const step = calculateStep({ strip, rangeMin, rangeMax, parallaxValueFull });
    el.style.setProperty(propertyName, `${step}${dimension}`);
  };

$(function () {
  new Sticky('.sticky-signup-box', {
    stickyContainer: '.sticky-signup-box-container',
    marginTop: 132,
  });

  //set current page nav item active
  $(`[href='${window.location.pathname}']`).addClass('active');

  //open/close FAQ
  $(document).on('click', '.faq-item .question', function () {
    $(this).parent().toggleClass('active');
  });

  //left menu open/close
  $(document).on(
    'click',
    '.left-menu-icon, .left-navigation .bg-layer, .bottom-navigation-open-menu',
    function () {
      const el = $('.left-menu-icon, .left-navigation');
      el.toggleClass('open');
      if (el.hasClass('open')) {
        AnalyticsService?.mobileMenuClickedEvent();
      }
    }
  );

  $(document).on('click', '.logo', function () {
    $('.left-menu-icon, .left-navigation').removeClass('open');
  });

  // Trigger initial currency update
  Currency.updateCurrencyValues();
});

const handleRegistration = async (email, password, captchaTokenHome) => {
  try {
    $('.loaderSignup').css('display', 'block');
    $('.signupText').css('display', 'none');
    await register(email, password, captchaTokenHome);
  } catch (error) {
    if (captchaTokenHome) {
      grecaptcha.reset();
    }
    $('.loaderSignup').css('display', 'none');
    $('.signupText').css('display', 'block');

    let errorMessage = error?.errors?.[0] || error?.message || 'An unknown error occurred';

    if (errorMessage) {
      toastAlert(errorMessage, null, { type: 'error' });
      if (error?.statusCode === 412) {
        grecaptcha.render('my-home-grecaptcha', {
          sitekey: '6LfxOKooAAAAAN9eUbmm3NgJwj4wWHpe-UGNHWlG',
          callback: (token) => {
            window.captchaTokenHome = token;
          },
        });
      }
    }
  }
};

document.addEventListener('alpine:init', () => {
  Alpine.data('homePage', () => ({
    registerBox: {
      email: '',
      password: '',
      checkAgreeTnc: false,
      checkNewsletter: false,
      isRevealingPassword: false,
      isEmailFocused: false,
    },

    init() {
      new Swiper('#home-testimonial-slider', {
        slidesPerView: 'auto',
        slidesPerGroup: 1,
        spaceBetween: 30,
        navigation: {
          nextEl: '.swiper-button-next',
          prevEl: '.swiper-button-prev',
        },
        pagination: {
          el: '.home-trust-pilot-swiper-pagination',
          clickable: true,
        },
      });
    },

    setEmailFocused() {
      // timeout the state change since the Alpine @focus event enabled and
      // the click is blocked until state changed
      setTimeout(() => {
        this.registerBox.isEmailFocused = true;
      }, 0);
    },

    shouldShowPasswordField() {
      return this.registerBox.isEmailFocused;
    },

    /*
     * @param {number} offerPopularity, either 60 (3 stars), 80 (4 stars) or 100 (5 stars)
     */
    getOfferRating(offerPopularity) {
      if (offerPopularity >= 100) return '5.0';
      if (offerPopularity >= 80) return '4.0';

      return '3.0';
    },

    validatePassword() {
      const password = this.registerBox.password;
      if (typeof password !== 'string') return [false, 'Password is required'];

      if (password.length < 8) return [false, 'Must be at least 8 characters'];
      if (password.length > 100) return [false, 'Must be less than 100 characters'];
      if (!password.match(/[A-Z]/)) return [false, 'Must contain at least one uppercase letter'];
      if (!password.match(/[a-z]/)) return [false, 'Must contain at least one lowercase letter'];
      if (password.match(/\s/)) return [false, 'Must not contain any spaces'];

      const blacklisted = ['Passw0rd', 'Password123'];
      if (blacklisted.includes(password)) return [false, 'Password is too common'];
      return [true, null];
    },

    checkiFrame(e) {
      if (window?.checkIframeAndNavigate?.('home-page-register')) {
        e.preventDefault();
      }
    },

    doRegister(hasError, allErrors) {
      if (checkIframeAndNavigate('home-page-register')) return;

      if (hasError) {
        if (allErrors['checkAgreeTnc'] && allErrors['checkAgreeTnc'].length) {
          const checkAgreeTncError = allErrors['checkAgreeTnc'][0];
          let shouldShowTooltip = true;
          if (!this.registerBox.isEmailFocused) {
            shouldShowTooltip = false;
          }

          if (checkAgreeTncError) {
            if (shouldShowTooltip) {
              $('#registerSubmit')
                .tooltip({
                  title: 'Please agree to the Terms and Conditions',
                  sanitize: false,
                  placement: 'top',
                  trigger: 'focus',
                  delay: { show: 500 },
                  customClass: 'validator-tooltip',
                })
                .tooltip('show');
              $('#registerSubmitSurveyLite')
                .tooltip({
                  title: 'Please agree to the Terms and Conditions',
                  sanitize: false,
                  placement: 'top',
                  trigger: 'focus',
                  delay: { show: 500 },
                  customClass: 'validator-tooltip',
                })
                .tooltip('show');
            }
          }

          return;
        }
      }

      $('#registerSubmit').tooltip('dispose');
      $('#registerSubmitSurveyLite').tooltip('dispose');

      toastAlert('Signing Up...', null, {
        type: 'info',
      });

      const { email, password } = this.registerBox;
      handleRegistration(email, password, captchaTokenHome);
    },

    onParallaxHowToEarn(e) {
      const { parallaxValueFull } = e.detail;
      const rangeMin = 0;
      const rangeMax = 3.6;
      const el = document.querySelector('.paralax-image-strips');

      const strip1 = {
        translateXFrom: 40,
        translateXTo: -200,
      };

      const strip1Percentage = (parallaxValueFull - rangeMin) / (rangeMax - rangeMin);
      const strip1TranslateX =
        strip1.translateXFrom + (strip1.translateXTo - strip1.translateXFrom) * strip1Percentage;

      el.style.setProperty('--fc-home-image-strip1-offset-x', `${strip1TranslateX}px`);

      const strip2 = {
        translateXFrom: -320,
        translateXTo: -170,
      };

      const strip2Percentage = (parallaxValueFull - rangeMin) / (rangeMax - rangeMin);
      const strip2TranslateX =
        strip2.translateXFrom + (strip2.translateXTo - strip2.translateXFrom) * strip2Percentage;

      el.style.setProperty('--fc-home-image-strip2-offset-x', `${strip2TranslateX}px`);

      const strip3 = {
        translateXFrom: -30,
        translateXTo: -140,
      };

      const strip3Percentage = (parallaxValueFull - rangeMin) / (rangeMax - rangeMin);
      const strip3TranslateX =
        strip3.translateXFrom + (strip3.translateXTo - strip3.translateXFrom) * strip3Percentage;

      el.style.setProperty('--fc-home-image-strip3-offset-x', `${strip3TranslateX}px`);
    },

    onParallaxSurveyLiteHowToEarn() {
      const rangeMin = 0;
      const rangeMax = 3.6;
      const el = document.querySelector('.survey-lite--paralax-image-strips');

      const handle = moveHandler({ rangeMin, rangeMax, el, dimension: 'px' });
      return (e) => {
        const { parallaxValueFull } = e.detail;
        handle({ from: -350, to: -110 }, '--fc-home-image-sl-strip1-offset-x', parallaxValueFull);
        handle({ from: -170, to: -410 }, '--fc-home-image-sl-strip2-offset-x', parallaxValueFull);
        handle({ from: -440, to: -200 }, '--fc-home-image-sl-strip3-offset-x', parallaxValueFull);
        handle({ from: -240, to: -460 }, '--fc-home-image-sl-strip4-offset-x', parallaxValueFull);
        handle({ from: -20, to: 220 }, '--fc-home-image-sl-strip5-offset-x', parallaxValueFull);
      };
    },

    onParallaxChooseAnOffer(e) {
      const { parallaxValueFull } = e.detail;
      const el = document.querySelector('.complete-offer.card-image');

      const rangeMin = -0.16;
      const rangeMax = 1.3;
      const backgroundSizeMin = 105;
      const backgroundSizeMax = 150;

      const backgroundScalePercentage = (parallaxValueFull - rangeMin) / (rangeMax - rangeMin);
      const backgroundScale =
        backgroundSizeMin + (backgroundSizeMax - backgroundSizeMin) * backgroundScalePercentage;

      el.style.setProperty('--fc-home-offer-card-image-scale', `${backgroundScale}%`);

      const imageScaleMin = 0.6;
      const imageScaleMax = 0.8;

      const imageScalePercentage = (parallaxValueFull - rangeMin) / (rangeMax - rangeMin);
      const imageScale = imageScaleMin + (imageScaleMax - imageScaleMin) * imageScalePercentage;

      el.style.setProperty('--fc-home-offer-progress-image-scale', `${imageScale}`);
    },

    onParallaxSurveyLiteCard() {
      const el = document.querySelector('.survey-lite--earn-coins-img');

      const rangeMin = -0.16;
      const rangeMax = 1.3;
      const imageScaleMin = 1.2;
      const imageScaleMax = 1.9;
      const handle = moveHandler({ rangeMin, rangeMax, el });

      return (e) => {
        const { parallaxValueFull } = e.detail;
        handle(
          { from: imageScaleMin, to: imageScaleMax },
          '--fc-home-survey-lite-progress-image-scale',
          parallaxValueFull
        );
      };
    },

    onParallaxRecommendedBy(el) {
      return (e) => {
        const { elementVisiblityPercentage } = e.detail;

        if (elementVisiblityPercentage >= 0.25) {
          const items = el.querySelectorAll('.item');

          items.forEach((item) => {
            item.classList.add('fly-in');
          });

          el.dispatchEvent(new CustomEvent('parallax:dispose'));
        }
      };
    },

    onParallaxSurveyLiteWithdraws() {
      const el = document.querySelector('.survey-lite--box-get-rewarded-img');
      const rangeMin = -0.16;
      const rangeMax = 1.3;
      const imageRotateMin = 10;
      const imageRotateMax = 55;
      const handle = moveHandler({ rangeMin, rangeMax, el, dimension: 'deg' });

      return (e) => {
        const { parallaxValueFull } = e.detail;
        handle(
          { from: imageRotateMin, to: imageRotateMax },
          '--fc-home-survey-lite-progress-image-rotate',
          parallaxValueFull
        );
      };
    },

    onParallaxHeresWhy(el) {
      return (e) => {
        const { elementVisiblityPercentage } = e.detail;

        if (elementVisiblityPercentage >= 0.25) {
          const items = el.querySelectorAll('.heres-why-grid-item');

          items.forEach((item) => {
            item.classList.add('fly-in');
          });

          el.dispatchEvent(new CustomEvent('parallax:dispose'));
        }
      };
    },

    onParallaxGetPaid(e) {
      const { elementVisiblityPercentage } = e.detail;
      const el = document.querySelector('.card-image.get-paid');

      const scaleMin = 1;
      const scaleMax = 1.6;

      const scalePercentage = scaleMin + (scaleMax - scaleMin) * elementVisiblityPercentage;
      el.style.setProperty('--fc-home-get-paid-card-image-scale', `${scalePercentage}`);
    },

    onParallaxFaq(el) {
      return (e) => {
        const { elementVisiblityPercentage } = e.detail;

        if (elementVisiblityPercentage >= 0.25) {
          const items = el.querySelectorAll('.faq-item');

          items.forEach((item) => {
            item.classList.add('fly-in');
          });

          el.dispatchEvent(new CustomEvent('parallax:dispose'));
        }
      };
    },

    getDuration(duration) {
      return Alpine.store('fcMain').pluralize(duration, 'min', 's');
    },
  }));

  Alpine.data('liveCashout', () => ({
    thisMonthCashedOut: 0,
    latestWithdraws: [],
    maxItemsToShow: 7,

    init() {
      socket.on('homeStatsWithdrawTotal', (withdrawalStats) => {
        this.thisMonthCashedOut = withdrawalStats.thisMonthCashedOut;
      });

      socket.on('activityFeed', (withdrawItem) => {
        withdrawItem._id = app.utils.generateUniqueId('home:withdraw:');

        if (!this.isWithdrawal(withdrawItem)) return;
        this.latestWithdraws.unshift(withdrawItem);
        this.thisMonthCashedOut += withdrawItem.coins / 1000;

        if (this.latestWithdraws.length > this.maxItemsToShow) {
          this.latestWithdraws.pop();
        }
      });

      socket.once('earnFeedLoaded', (items) => {
        let withdrawFeedItems = items
          .filter((item) => this.isWithdrawal(item))
          .map((item) => {
            return {
              ...item,
              _id: app.utils.generateUniqueId('home:withdraw:'),
            };
          });
        withdrawFeedItems.sort((a, b) => {
          return new Date(b.date) - new Date(a.date);
        });

        this.latestWithdraws = withdrawFeedItems.slice(0, this.maxItemsToShow);
      });
    },

    isWithdrawal(feed) {
      return feed.feedType === 'withdrawal' && feed.withdrawType;
    },

    revealWdItem(el) {
      el.classList.add('withdraw-item-entering');
    },

    getWithdrawIcon(type) {
      return window.app.misc.getWithdrawIcon(type);
    },
  }));

  Alpine.data('surveyCountryStats', () => ({
    availableCount: 0,
    highestPaying: 0,
    highestReward: '0',

    init() {
      const res = getLocalStorage('surveyCountryStats');

      if (res) {
        try {
          const stats = JSON.parse(res);
          this.availableCount = app.utils.formatNumber(stats.availableCount, 0) || 0;
          this.highestPaying = stats.highestPaying || 0;
        } catch (e) {}
      }

      app.utils
        .makeGraphQLQuery(GET_SURVEYS_COUNTRY_STATS)
        .then((data) => {
          if (!data.data) {
            return;
          }

          setLocalStorage('surveyCountryStats', JSON.stringify(data.data?.getSurveyCountryStats));
          this.availableCount =
            app.utils.formatNumber(data.data?.getSurveyCountryStats.availableCount, 0) || 0;
          this.highestPaying = data.data?.getSurveyCountryStats.highestPaying || 0;
        })
        .catch((e) => console.error(e))
        .finally(() => {
          this.highestReward = this.getReward();
        });
    },

    getReward() {
      const coinsAsString = this.highestPaying;
      const numericValue = Number(coinsAsString);
      const formattedValue = Alpine.store('fcMain').getDisplayedCurrencyValue(
        numericValue,
        'coins'
      );
      switch (Alpine.store('fcMain').currency) {
        case 'currency':
          const symbol = Alpine.store('fcMain').getFiatCurrencySymbol();

          if (symbol === '€') {
            return `${formattedValue}${symbol}`;
          }

          return `${symbol}${formattedValue}`;
        case 'coins':
        default:
          return formattedValue;
      }
    },
  }));
});

$(function () {
  if (window.location.hash === '#id-verification-completed') {
    window.location.hash = '';
    setTimeout(() => {
      openModal('#idVerificationCompletedModal');
    }, 1000);
  }

  $(document).on('click', '.id-verification-modal .verification-btn', function () {
    $('#idVerificationStartModal').modal('close');
  });

  $(document).on('click', '.open-verification-modal-btn', function () {
    window.dispatchEvent(new CustomEvent('fc:reactapp:show-veriff-verification-modal'));
  });
});

let currentBackRoute, hasOpenModal;

let prevState = {};
let currentState = {};

function initializeCurrentState() {
  currentState = JSON.parse(JSON.stringify(window.history.state));

  if (currentState && currentState.type === 'modal') {
    delete currentState.type;
    delete currentState.modalType;
  }
}

function checkPath() {
  let path = window.location.pathname;
  let pathArr = path.split('/');

  // make sure currentBackRoute is always defined
  currentBackRoute = path;
  initializeCurrentState();

  let title = getTitleFromRoute(path);
  let page = pathArr.slice(1)[0];
  let subPage = pathArr.slice(1)[1];

  if (page !== 'user') document.title = title;

  if (page == 'admin') {
    socket.emit('renderAdmin', 'admin');
  } else if (page == 'earn' && subPage) {
    if (subPage) {
      currentBackRoute = '/earn';
      openSurveyModal(subPage);
    }
  } else if (page == 'login') {
    currentBackRoute = '/';
    openReactAuthModal(0);
  } else if (page == 'register') {
    currentBackRoute = '/';
    openReactAuthModal(1);
  } else if (page == 'rewards') {
    currentBackRoute = '/';
  } else if (page == 'affiliates') {
    currentBackRoute = '/';
  } else if (page == 'bonuscode') {
    currentBackRoute = '/';
    let params = new URLSearchParams(document.location.search);
    let code = params.get('code');
    if (code) {
      $('#gainBonusCodeInput').val(code);
    }
    openModal('#bonusCodeModal');
  } else if (page == 'mod') {
    currentBackRoute = '/mod';
    socket.emit('renderMod', 'mod');
  } else if (page == 'owner') {
    currentBackRoute = '/owner';
    socket.emit('renderOwner');
  } else if (page == 'promoter') {
    currentBackRoute = '/promoter';
    socket.emit('renderPromoter');
  } else if (page == 'monitoring') {
    currentBackRoute = '/monitoring';
    socket.emit('renderMonitoring');
  } else if (page === 'unban-panel') {
    currentBackRoute = '/unban-panel';
    socket.emit('renderUnbanPanel');
  }
}

$(document).ready(function () {
  M.AutoInit();
  $('.tooltipped').tooltip({ html: true });

  setTimeout(function () {
    checkPath();
  }, 1000);

  //  socket.emit('getEarnFeed');

  $('.tabs').tabs();

  setTimeout(function () {
    function loadFP() {
      if (!window.FingerprintJS) return;
      window.FingerprintJS.load().then((agent) =>
        agent.get().then((res) => handleFingerprint(res))
      );
    }
    loadFP();
  }, 500);

  if (!window.gainid && window.app.utm && window.app.utm.source === 'freecash') {
    socket.emit('submitSource', { ...window.app.utm });
  }
});

let loaderHtml = `<div class="datLoader">
  <div class="preloader-wrapper active">
    <div class="spinner-layer spinner-red-only">
      <div class="circle-clipper left">
        <div class="circle"></div>
      </div><div class="gap-patch">
        <div class="circle"></div>
      </div><div class="circle-clipper right">
        <div class="circle"></div>
      </div>
    </div>
  </div>
</div>`;

function getCommasFixed2(number) {
  return number.toFixed(2).replace(/\B(?=(\d{3})+(?!\d))/g, ',');
}

function getCommas(number) {
  if (number == null) return;
  const splitNum = number.toString().split('.');
  splitNum[0] = splitNum[0].replace(/\B(?=(\d{3})+(?!\d))/g, ',');
  return splitNum.join('.');
}

function removeCommas(number) {
  return number.replace(/\,/g, '');
}

function getDollarsFromCoins(coinAmount) {
  return '$' + (coinAmount / 1000).toFixed(2).replace(/\B(?=(\d{3})+(?!\d))/g, ',');
}

function getNumberInRange(min, max) {
  return Math.random() * (max - min) + min;
}

let earnSound;

function playEarnSound() {
  if (!earnSound) {
    earnSound = new Audio('/public/sounds/earnSound.mp3');
  }

  if (earnSound) {
    earnSound.play().catch(() => {
      // do nothing, this would prevent the Unhandled Promise Rejection error
    });
  }
}

socket.on('playEarnSound', function () {
  playEarnSound();
});

function toastAlert(title, text, { classes, type, timeout } = {}) {
  M.toast({
    html: getToastHtml({
      type: type || 'info',
      title,
      text,
    }),
    classes: classes || 'stdToastNotification',
    displayLength: timeout || 7000,
  });
}

function toastAlertRaw(html, classes) {
  M.toast({
    html,
    classes: classes || 'stdToastNotification',
    displayLength: 7000,
  });
}

function mobileAlert(message) {
  toastAlert(message, null, { classes: 'mobile-notification' });
}

socket.on('withdrawalConfirmed', function (data) {
  const title = 'Withdrawl Confirmed';
  const text = `Your ${data.coins} coin withdrawal has been confirmed ${
    data.address ? `for<br>${data.address}` : ''
  }`;
  toastAlert(title, text, { type: 'success', timeout: 10000 });
});

socket.on('withdrawalCancelled', function (data) {
  const title = 'Withdrawal Cancelled';
  const text = `Your ${data.coins} coin withdrawal has been cancelled ${
    data.address ? `for<br>${data.address}` : ''
  }`;
  toastAlert(title, text, { type: 'error', timeout: 10000 });
});

socket.on('withdrawalPending', function (data) {
  const title = 'Withdrawal Pending';
  const text = `Your ${data.coins} coin withdrawal is pending ${
    data.address ? `for<br>${data.address}` : ''
  }`;
  toastAlert(title, text, { type: 'success', timeout: 10000 });
});

socket.on('alert', (message) => {
  toastAlert(message);
});

socketFC.on('reward:granted', (data) => {
  if (data.reward && data.reward.category === 'signup_bonus') {
    setLocalStorage('fc-signup-bonus-reward-granted', 1);
  }
});

// socketFC.on('chatRoomsOnline', ({ success, data, errors }) => {
//   const activeRoomCode = $('.chatRoomSelectorDropdown > .menuItems')
//     .find('.active')
//     .attr('data-value');
//   $('.usersOnline').text(data[activeRoomCode]);
// });

function ordinalSuffix(i) {
  var j = i % 10,
    k = i % 100;
  if (j == 1 && k != 11) {
    return i + 'st';
  }
  if (j == 2 && k != 12) {
    return i + 'nd';
  }
  if (j == 3 && k != 13) {
    return i + 'rd';
  }
  return i + 'th';
}

socket.on('renderPage', function (html, page) {
  try {
    Alpine.store('fcMain').setPage(page);
  } catch (err) {}

  $('#almaView').text('');
  $('#almaView').html(html);
  $('#almaView').attr('data-page', page || 'home');

  $('.loadReveal').show();
  $('.loadReveal').css('left', '0');
  $('.loadReveal').css('top', '0');

  $('html, body').animate(
    {
      scrollTop: 0,
    },
    200
  );

  try {
    M.updateTextFields();
    $('.tooltipped').tooltip({ html: true });
    $('.collapsible').collapsible();
    $('time.timeago').timeago();
  } catch (error) {
    console.error(error);
  }

  // $('.modal').modal('close');
  if (page == 'easter') {
    initEasterTimers();
  }
  if (window.ReactApp && window.ReactApp.onRenderPage) {
    window.ReactApp.onRenderPage(page);
  }

  // Update currency values on page change
  Currency.updateCurrencyValues();

  window.dispatchEvent(new CustomEvent('fc:alma-page-changed', { detail: { selectedPage: page } }));
});

$(document).on('click', '.gainProfileLink', function () {
  let datGainId = $(this).attr('data-gainid');

  openPage(datGainId, `/user/${datGainId}`, {
    type: 'modal',
    modalType: 'userProfile',
    data: {
      gainId: datGainId,
    },
  });
});

$(document).on(
  'click',
  '.gainProfileLink, .pageRoute, .withdrawPageLink, .winRouteBtn, .openOfferWallBtn',
  function (e) {
    if (e.which == 1) {
      e.preventDefault();
    }
  }
);

console.log(
  `%cIf someone told you to paste code here, you're being scammed and about to get your account hijacked.

Never paste code here unless you're sure you know what you're doing.`,
  'background: #303F9F; color: white; font-size: 24px;'
);

// function openRebrandPopup() {
//   if (getLocalStorage('rebrandingModalShown')) return;
//   openModal('#rebrandingModal');
//   setLocalStorage('rebrandingModalShown', 1);
// }

$(document).ready(function () {
  const urlParams = new URLSearchParams(window.location.search);
  let toastText = null;
  let toastDescription = null;

  let yourSurveysBanned = urlParams.get('ys-banned') == 'true';
  let yourSurveysCompleted = urlParams.get('ys-completed') == 'true';
  let yourSurveysCompletedDelayed =
    urlParams.get('ys-completed') == 'true' && urlParams.get('delay') == '1';
  let yourSurveysNoAlloc = urlParams.get('ys-no-alloc') == 'true';
  let yourSurveysQualityConcern = urlParams.get('ys-quality-concern') == 'true';
  let yourSurveysNoSurveysAvailable = urlParams.get('ys-no-surveys') == 'true';
  let yourSurveysTermed = urlParams.get('ys-termed') == 'true';

  AnalyticsService.onInitialLoad();

  const from = urlParams.get('from');
  if (from === 'freeskins.com') {
    // openRebrandPopup();
  } else if (from === 'unavailable-android-wall') {
    toastText = `Available in the Android App`;
    toastDescription = `Please upgrade your Freecash Android app to the newest version and try again. If the problem persists, please message support.`;
  }

  if (urlParams.get('exclusiveSurvey')) {
    if (urlParams.get('processingError')) {
      toastText = `Your Freecash Exclusive Survey could not be processed right now. Please contact support.`;
    } else if (urlParams.get('disqualified')) {
      toastText = `Freecash Exclusive Survey was completed, but unfortunately you've been disqualified.`;
    } else if (urlParams.get('incomplete')) {
      toastText = `Freecash Exclusive Survey was either not completed or you've been disqualified. Please try another survey.`;
    } else if (urlParams.get('success')) {
      toastText = `You have completed a Freecash Exclusive Survey.`;
    }
    // reset the params in the address bar.
    // window.history.replaceState({ title: document.title }, '', window.location.pathname);
  } else if (urlParams.get('cpxExclusive')) {
    if (urlParams.get('success')) {
      toastText = `You have completed an CPX Exclusive Survey.`;
    }
  } else if (yourSurveysBanned) {
    toastText = `You are banned from Your-Surveys. Please try another offer wall.`;
  } else if (yourSurveysCompletedDelayed) {
    toastText = `Successfully completed survey! Your coins for this survey have have been delayed by Your Surveys and will be credited in the near future.`;
  } else if (yourSurveysCompleted) {
    toastText = `Successfully completed survey!`;
  } else if (yourSurveysNoAlloc) {
    toastText = `No allocation available for this survey. Please try another survey!`;
  } else if (yourSurveysQualityConcern) {
    toastText = `The survey provider indicated a quality concern with your survey. Please be careful when answering surveys to fill them out carefully and honestly.`;
  } else if (yourSurveysNoSurveysAvailable) {
    toastText = `There are no surveys available at this time. Please try again later or use other survey walls below.`;
  } else if (yourSurveysTermed) {
    toastText = `You were termed on the survey.`;
  }

  if (toastText) toastAlert(toastText, toastDescription);

  let twitterStatus = urlParams.get('twitter-status');

  if (twitterStatus) {
    if (twitterStatus == 'already_claimed') {
      toastAlert(`You have already claimed your Twitter reward!`);
    } else if (twitterStatus == 'err') {
      toastAlert(`An error occurred fetching your Twitter profile. Please try again!`);
    } else if (twitterStatus == 'not_logged_in') {
      toastAlert(
        `You are not logged in! Please login and attempt to claim your twitter bonus again.`
      );
    } else if (twitterStatus == 'not_logged_in') {
      toastAlert(
        `You are not logged in! Please login and attempt to claim your twitter bonus again.`
      );
    } else if (twitterStatus == 'success') {
      toastAlert(`Successfully claimed Twitter bonus!`);
    } else if (twitterStatus == 'not_following') {
      toastAlert(`You are not following us on Twitter. Please follow us then try again!`);
    } else if (twitterStatus == 'retweet') {
      toastAlert(`Please follow Freecash on twitter & retweet our tweet to get the reward!`);
    }
  }

  let instagramStatus = urlParams.get('instagram-status');

  if (instagramStatus) {
    if (instagramStatus == 'already_claimed') {
      toastAlert(`You have already claimed your Instagram reward!`);
    } else if (instagramStatus == 'err') {
      toastAlert(`An error occurred fetching your Instagram profile. Please try again!`);
    } else if (instagramStatus == 'not_logged_in') {
      toastAlert(
        `You are not logged in! Please login and attempt to claim your Instagram bonus again.`
      );
    } else if (instagramStatus == 'not_logged_in') {
      toastAlert(
        `You are not logged in! Please login and attempt to claim your Instagram bonus again.`
      );
    } else if (instagramStatus == 'success') {
      toastAlert(`Successfully claimed Instagram bonus!`);
    } else if (instagramStatus == 'not_following') {
      toastAlert(`You are not following us on Instagram. Please follow us then try again!`);
    }
  }

  let emailVerified = urlParams.get('emailverified');

  if (emailVerified) {
    toastAlert(`E-mail successfully verified. You are allowed to request withdrawals now.`);
  }

  if (urlParams.get('signupSuccess')) {
    AnalyticsService.signupConversion();
    window.history.replaceState({ title: document.title }, '', window.location.pathname);
  }

  const redirectParams = [
    'ref',
    'click_id',
    'sub1',
    'sub2',
    'from',
    'utm_source',
    'utm_medium',
    'utm_campaign',
    'utm_term',
    'utm_content',
    'page',
    'lg',
  ];
  let shouldRedirect = false;
  if (!window.gainid) {
    for (const [paramName] of urlParams.entries()) {
      if (redirectParams.includes(paramName) || paramName.startsWith('utm_')) {
        shouldRedirect = true;
        break;
      }
    }
  }

  const hash = window.location.hash;

  if (shouldRedirect && hash !== '#openAuthModal=true') {
    window.history.replaceState({ title: document.title }, '', window.location.pathname);
  }

  $(document).on('click', '.open-support-chat, #footer-support-link', function (e) {
    e.preventDefault();
    openSupportChat();
  });

  $(document).on('click', '.footer-link-do-not-sell-my-data', function (e) {
    e.preventDefault();
    if (window.openDoNotSellMyDataModal) {
      window.openDoNotSellMyDataModal();
    }
  });

  function storeGTagApiResult() {
    const gTagApiResult = app.utils.getGTagApiResult();
    const cookieValue = gTagApiResult
      ? `${gTagApiResult.googleClientId}|${gTagApiResult.googleSessionId}`
      : '';
    document.cookie = `gTagApiResult=${cookieValue}`;
  }

  storeGTagApiResult();
});

socket.on('newUserJoined', function () {
  let currentRegUsers = parseInt($('#totalUsersStat').text().replace(/,/g, ''));

  $('#totalUsersStat').text(getCommas(currentRegUsers + 1));
});

socket.on('refreshPage', function () {
  location.reload();
});

socket.on('logout', function () {
  document.location.href = '/fc-api/auth/logout';
});

socketFC.on('user:forceLoggedOut', function () {
  location.reload();
});

// socketFC.on('user:deleted', function () {
//   document.location.href = '/fc-api/auth/logout';
// });

socketFC.on('user:passChanged', function () {
  document.location.href = '/fc-api/auth/logout';
});

function handleFingerprint(data) {
  if (!data) return;
  const components = data.components;
  let resolution = `${components.screenResolution.value[0]}x${components.screenResolution.value[1]}`;
  let timezone = components.timezone.value;
  let audio = components.audio.value;
  let cpuCores = components.hardwareConcurrency.value;
  let deviceMemory = components.deviceMemory.value;
  let visitorId = data.visitorId;
  let language = components.languages.value[0] && components.languages.value[0][0];
  let platform = components.platform.value;
  let browser = components.vendor.value || '';
  let browserAdd = components.vendorFlavors.value.join(' ');
  if (browserAdd) browser += ` ${browserAdd}`;
  let useragent = navigator?.userAgent;

  const networkInformation = navigator?.connection; // https://developer.mozilla.org/en-US/docs/Web/API/Network_Information_API
  const networkType = networkInformation?.type;
  const networkEffectiveType = networkInformation?.effectiveType;

  socket.emit('submitFinger', {
    resolution,
    timezone,
    audio,
    cpuCores,
    deviceMemory,
    visitorId,
    language,
    platform,
    browser,
    useragent,
    networkType,
    networkEffectiveType,
  });
}

// $('.nameBonusBtn').hover(function() {
//   $('.nameBonusDescription').removeClass('bounceOut');
//   $('.nameBonusDescription').addClass('bounceIn');
//   $('.nameBonusDescription').show();
// }, function() {
//   $('.nameBonusDescription').removeClass('bounceIn');
//   $('.nameBonusDescription').addClass('bounceOut');
// }).children().hover(function() {
//   return false;
// });

function showLeaderboardEarnedMessage(data) {
  if (data.dailyEarnMessage) {
    $('#leaderboardDailyTopBox').html(data.dailyEarnMessage);
  }

  if (data.weeklyEarnMessage) {
    $('#leaderboardWeeklyTopBox').html(data.weeklyEarnMessage);
  }

  if (data.monthlyEarnMessage) {
    $('#leaderboardMonthlyTopBox').html(data.monthlyEarnMessage);
  }

  if (data.positions && data.positions.easter) {
    let easterHtml = `You opened <span class="exag">${data.positions.easter.points || 0} ${
      data.positions.easter.points == 1 ? 'egg' : 'eggs'
    } this month</span> and are ranked <span class="exag">${
      data.positions.easter.pos || '-'
    } out of ${data.totalUsers.easter || 0} users</span>`;
    $('#leaderboardEasterTopBox').html(easterHtml);
  }
}

socket.on('leaderboardPositionAndUsers', showLeaderboardEarnedMessage);
showLeaderboardEarnedMessage({ positions: {}, totalUsers: {} });

function closeNav() {
  $('#mobileNavContent').addClass('mobile-nav-hidden');
  $('#mobileNavContent').attr('data-state', 'closed');
}

function openNav() {
  $('#mobileNavContent').removeClass('mobile-nav-hidden');
  $('#mobileNavContent').attr('data-state', 'open');
}

function toggleNav() {
  if ($('#mobileNavContent').attr('data-state') == 'open') {
    closeNav();
  } else {
    openNav();
  }
}

$(document).on('click', '.mobileNavButton', closeNav);

$(document).on('click', '.toggleMobileNavBtn', toggleNav);

function initTimer(timeDuration, element, onComplete, onUpdate, format) {
  if (!timeDuration) return;
  format = format || ['h', 'm', 's'];
  // get timer offset (if not found, set to today)
  var offset = new Date(new Date());

  // add 24 hours to get final deadline
  var deadline = new Date(offset.setSeconds(offset.getSeconds() + parseInt(timeDuration)));

  // create counter
  var counter = Tick.count.down(deadline, { format });

  // update tick with the counter value
  if (typeof onUpdate !== 'function') {
    onUpdate = function (value) {
      if (element) {
        // element is nullable
        element.innerHTML = format
          .map((unit, index) => `${addTrailingZero(value[index])}${unit}`)
          .join(' ');
      }
    };
  }

  counter.onupdate = onUpdate;
  counter.onended = function () {
    if (typeof onComplete === 'function') onComplete();
  };

  return counter;
}

function addTrailingZero(digit) {
  return digit < 10 ? ('0' + digit).slice(-2) : digit;
}

window.mobileCheck = function () {
  let check = false;
  (function (a) {
    if (
      /(android|bb\d+|meego).+mobile|avantgo|bada\/|blackberry|blazer|compal|elaine|fennec|hiptop|iemobile|ip(hone|od)|iris|kindle|lge |maemo|midp|mmp|mobile.+firefox|netfront|opera m(ob|in)i|palm( os)?|phone|p(ixi|re)\/|plucker|pocket|psp|series(4|6)0|symbian|treo|up\.(browser|link)|vodafone|wap|windows ce|xda|xiino/i.test(
        a
      ) ||
      /1207|6310|6590|3gso|4thp|50[1-6]i|770s|802s|a wa|abac|ac(er|oo|s\-)|ai(ko|rn)|al(av|ca|co)|amoi|an(ex|ny|yw)|aptu|ar(ch|go)|as(te|us)|attw|au(di|\-m|r |s )|avan|be(ck|ll|nq)|bi(lb|rd)|bl(ac|az)|br(e|v)w|bumb|bw\-(n|u)|c55\/|capi|ccwa|cdm\-|cell|chtm|cldc|cmd\-|co(mp|nd)|craw|da(it|ll|ng)|dbte|dc\-s|devi|dica|dmob|do(c|p)o|ds(12|\-d)|el(49|ai)|em(l2|ul)|er(ic|k0)|esl8|ez([4-7]0|os|wa|ze)|fetc|fly(\-|_)|g1 u|g560|gene|gf\-5|g\-mo|go(\.w|od)|gr(ad|un)|haie|hcit|hd\-(m|p|t)|hei\-|hi(pt|ta)|hp( i|ip)|hs\-c|ht(c(\-| |_|a|g|p|s|t)|tp)|hu(aw|tc)|i\-(20|go|ma)|i230|iac( |\-|\/)|ibro|idea|ig01|ikom|im1k|inno|ipaq|iris|ja(t|v)a|jbro|jemu|jigs|kddi|keji|kgt( |\/)|klon|kpt |kwc\-|kyo(c|k)|le(no|xi)|lg( g|\/(k|l|u)|50|54|\-[a-w])|libw|lynx|m1\-w|m3ga|m50\/|ma(te|ui|xo)|mc(01|21|ca)|m\-cr|me(rc|ri)|mi(o8|oa|ts)|mmef|mo(01|02|bi|de|do|t(\-| |o|v)|zz)|mt(50|p1|v )|mwbp|mywa|n10[0-2]|n20[2-3]|n30(0|2)|n50(0|2|5)|n7(0(0|1)|10)|ne((c|m)\-|on|tf|wf|wg|wt)|nok(6|i)|nzph|o2im|op(ti|wv)|oran|owg1|p800|pan(a|d|t)|pdxg|pg(13|\-([1-8]|c))|phil|pire|pl(ay|uc)|pn\-2|po(ck|rt|se)|prox|psio|pt\-g|qa\-a|qc(07|12|21|32|60|\-[2-7]|i\-)|qtek|r380|r600|raks|rim9|ro(ve|zo)|s55\/|sa(ge|ma|mm|ms|ny|va)|sc(01|h\-|oo|p\-)|sdk\/|se(c(\-|0|1)|47|mc|nd|ri)|sgh\-|shar|sie(\-|m)|sk\-0|sl(45|id)|sm(al|ar|b3|it|t5)|so(ft|ny)|sp(01|h\-|v\-|v )|sy(01|mb)|t2(18|50)|t6(00|10|18)|ta(gt|lk)|tcl\-|tdg\-|tel(i|m)|tim\-|t\-mo|to(pl|sh)|ts(70|m\-|m3|m5)|tx\-9|up(\.b|g1|si)|utst|v400|v750|veri|vi(rg|te)|vk(40|5[0-3]|\-v)|vm40|voda|vulc|vx(52|53|60|61|70|80|81|83|85|98)|w3c(\-| )|webc|whit|wi(g |nc|nw)|wmlb|wonu|x700|yas\-|your|zeto|zte\-/i.test(
        a.substr(0, 4)
      )
    )
      check = true;
  })(navigator.userAgent || navigator.vendor || window.opera);
  return check;
};

$(function () {
  if (Alpine.store('fcMain').ghostVariant === 'var1-v3' && !window.gainid) {
    const hideLobbyShowTerms = () => {
      $('#react-app-mobile-lobby').css('display', 'none');
      $('.site-header').css('display', 'none');
      $('.mobile-navigation').css('visibility', 'hidden');
    };

    const showLobby = () => {
      $('#react-app-mobile-lobby').css('display', 'block');
    };

    if (
      window.location.pathname === '/policies/terms' ||
      window.location.pathname === '/policies/privacy-eu'
    ) {
      hideLobbyShowTerms();
    } else {
      showLobby();
    }
  }

  if (Alpine.store('fcMain').ghostVariant === 'var3-v3' && !window.gainid) {
    const hideLoaderShowTerms = () => {
      $('#react-ghost-account-loader').css('display', 'none');
      $('#react-app-mobile-lobby').css('display', 'none');
      $('.site-header').css('display', 'none');
      $('.mobile-navigation').css('visibility', 'hidden');
    };

    const hideLoader = () => {
      $('#react-ghost-account-loader').css('display', 'none');
      $('#react-app-mobile-lobby').css('display', 'block');
    };
    const showLoader = () => {
      $('#react-ghost-account-loader').css('display', 'block');
      $('#react-app-mobile-lobby').css('display', 'none');
    };

    if (app.utils.hasPassedGhostRegister()) {
      hideLoader();
    }

    if (
      window.location.pathname === '/policies/terms' ||
      window.location.pathname === '/policies/privacy-eu'
    ) {
      hideLoaderShowTerms();
    } else {
      if (app.utils.hasPassedGhostRegister()) {
        hideLoader();
      } else {
        showLoader();
      }
    }
  }
});

function sendMessageToIosApp(message) {
  // Check if `webkit` and `webkit.messageHandlers.callbackHandler` exist
  if (window.webkit && window.webkit?.messageHandlers?.callbackHandler) {
    window.webkit.messageHandlers.callbackHandler.postMessage(message);
  }
}

const tvSquaredRevenue1DollarEvent = () => {
  if (window.countryHeader !== 'DE' || !window.cookiehub?.hasConsented('marketing')) return;

  window._tvq = window._tvq || [];

  const _tvq = window._tvq;

  const session = { user: window.gainid };
  const actionname = 'offer_complete_v2';
  const action = {
    rev: 1,
    prod: 'NEW',
  };

  const u =
    'https:' == document.location.protocol
      ? 'https://collector-45913.tvsquared.com/'
      : 'http://collector-45913.tvsquared.com/';

  _tvq.push(['setSiteId', 'TV-5445098163-1']);
  _tvq.push(['setTrackerUrl', u + 'tv2track.php']);
  _tvq.push([
    function () {
      this.setCustomVariable(5, 'session', JSON2.stringify(session), 'visit');
    },
  ]);
  _tvq.push([
    function () {
      this.setCustomVariable(5, actionname, JSON2.stringify(action), 'page');
    },
  ]);
  _tvq.push(['trackPageView']);
};

if (window.gainid) {
  // Post message to ios about user signup/in
  sendMessageToIosApp('apple:userSignedIn');

  fetch('/fc-api/analytics/gtm-events')
    .then((response) => response.json())
    .then((events) => {
      events.forEach(({ eventName, payload }) => {
        if (eventName === 'rev1') {
          tvSquaredRevenue1DollarEvent();
        }
        if (window.dataLayer && Array.isArray(window.dataLayer)) {
          if (eventName === 'signup_backend' && payload.source === 'naver')
            Sentry.captureMessage('Naver signup datalayer push', { user: { id: window.gainid } });
          window.dataLayer.push({ event: eventName, payload });
        }
      });
    });
}

window.cookiehubModified = () => {
  if (!window.cookiehub) return;
  const necessary = window.cookiehub.hasConsented('necessary');
  const preferences = window.cookiehub.hasConsented('preferences');
  const analytics = window.cookiehub.hasConsented('analytics');
  const marketing = window.cookiehub.hasConsented('marketing');
  const uncategorized = window.cookiehub.hasConsented('uncategorized');
  const oneYear = 60 * 60 * 24 * 365;

  document.cookie = `consent_necessary=${necessary}; path=/; max-age=${oneYear}`;
  document.cookie = `consent_preferences=${preferences}; path=/; max-age=${oneYear}`;
  document.cookie = `consent_analytics=${analytics}; path=/; max-age=${oneYear}`;
  document.cookie = `consent_marketing=${marketing}; path=/; max-age=${oneYear}`;
  document.cookie = `consent_uncategorized=${uncategorized}; path=/; max-age=${oneYear}`;

  if (!window.gainid) return;

  runGraphql(
    `
      mutation saveConsent(
        $necessary: Boolean!,
        $preferences: Boolean!,
        $analytics: Boolean!,
        $marketing: Boolean!,
        $uncategorized: Boolean!
      ) {
        saveConsent(
          necessary: $necessary,
          preferences: $preferences,
          analytics: $analytics,
          marketing: $marketing,
          uncategorized: $uncategorized
        )
      }
    `,
    {
      necessary,
      preferences,
      analytics,
      marketing,
      uncategorized,
    }
  );
};

$(function () {
  if (!app.utils.isAppOrWebApp() || gainid) return;

  toggleEarnFeed('false');

  // If we're running Android LP experiment and the variant is 2023,
  // No need to execute script for mobile onboarding
  if (!document.querySelector('.onboarding-pages')) return;

  const mainSlider = new Swiper('.main-slider', {
    on: {
      slideChange: (slider) => {
        if (slider.previousIndex > slider.realIndex) {
          slider.removeSlide(slider.previousIndex);
        }
      },
    },
  });

  const subSlider = new Swiper('.sub-slider', {
    pagination: {
      el: '.heading-pagination',
      bulletActiveClass: 'active',
      bulletClass: 'heading-page-nav',
    },
  });

  const bgSlider = new Swiper('.bg-slider', {
    spaceBetween: 200,
  });

  subSlider.controller.control = bgSlider;
  bgSlider.controller.control = subSlider;

  const pages = {
    signupMethodPage: document.querySelector('.onboarding-pages .signup-method-page').outerHTML,
    signinMethodPage: document.querySelector('.onboarding-pages .signin-method-page').outerHTML,
    signupPage: document.querySelector('.onboarding-pages .signup-page').outerHTML,
    signinPage: document.querySelector('.onboarding-pages .signin-page').outerHTML,
    forgotPassPage: document.querySelector('.onboarding-pages .forgot-pass-page').outerHTML,
    resetPassPage: document.querySelector('.onboarding-pages .reset-pass-page').outerHTML,
  };

  $(document).on('click touchend', '.change-page', function () {
    const pageIndex = $(this).data('page');
    mainSlider.appendSlide(pages[pageIndex]);
    mainSlider.slideNext();
  });

  $(document).on('click touchend', '.signin-form .signin-btn', function (e) {
    if (checkIframeAndNavigate('mobile-onboarding-register')) return;

    // preventing triggering of two events
    e.stopPropagation();
    e.preventDefault();
    const $form = $(this).parents('.signin-form');
    const $email = $form.find('.email');
    const $password = $form.find('.password');

    const emailIsValid = validateInput($email);
    const passIsValid = validateInput($password);
    if (!emailIsValid || !passIsValid) {
      return mobileAlert('Please fill out all fields.');
    }

    mobileAlert('Signing In...');

    login($email.val(), $password.val(), 'mobile-notification')
      .then(function () {
        $('body').removeClass('mobile-onboarding-page');
        $('.mobile-onboarding').hide();
      })
      .catch((errorText) => {
        mobileAlert(errorText);
      });
  });

  $(document).on('focusout change', '.mobile-onboarding input', function () {
    const $this = $(this);
    validateInput($this);
  });

  $(document).on('click touchend', '.sub-slider', function (e) {
    if (e.target.href || $(e.target).parent().is('a')) return;
    if (window.outerWidth / 2 < e.clientX) {
      subSlider.slideNext();
    } else {
      subSlider.slidePrev();
    }
  });

  $(document).on('click touchend', '.validate-email-btn', function () {
    const $form = $(this).parents('.forgot-pass-form');
    const $email = $form.find('.email');

    const emailIsValid = validateInput($email);
    if (!emailIsValid) {
      return mobileAlert('Please fill out all fields.');
    }
    sendPassResetCode($email.val())
      .then((response) => {
        mobileAlert(response);
        mainSlider.appendSlide(pages.resetPassPage);
        mainSlider.slideNext();
      })
      .catch((reason) => {
        mobileAlert(
          ('Error: ' + reason && reason.responseText) || 'Something went wrong. Please try again.'
        );
      });
  });

  $(document).on('click touchend', '.reset-pass-btn', function () {
    const $form = $(this).parents('.reset-pass-form');
    const $recoveryCode = $form.find('.recovery-code');
    const $pass = $form.find('.password');
    const $confirmPass = $form.find('.confirm-pass');

    const codeIsValid = validateInput($recoveryCode);
    const passIsValid = validateInput($pass);
    const confirmPassIsValid = validateInput($confirmPass);
    if (!codeIsValid || !passIsValid || !confirmPassIsValid) {
      return mobileAlert('Please fill out all fields.');
    }
    const recoveryCode = $recoveryCode.val();
    const pass = $pass.val();
    const confirmPass = $confirmPass.val();

    if (pass !== confirmPass) {
      return mobileAlert('Passwords do not match.');
    }

    resetPassport(recoveryCode, pass, confirmPass)
      .then((response) => {
        mobileAlert(response);
        mainSlider.removeSlide(mainSlider.activeIndex - 1);
        mainSlider.slidePrev();
      })
      .catch((reason) => {
        mobileAlert('Error: ' + reason.responseText);
      });
  });
});

$(document).on('click', '.modRestriction:not(.disabled)', function () {
  const reason = $('.banReason').val();
  if (!reason) {
    toastAlert('A reason must be provided.');
    return;
  }
  $(this).addClass('disabled');
  PostRequest(`fc-api/user-restrictions/change-restriction`, {
    gainId: +$(this).attr('data-gainid'),
    publicReason: $(this).attr('data-public-reason'),
    reason,
    type: $(this).attr('data-type'),
  })
    .then(() => {
      toastAlert('Success!');
    })
    .catch((error) => {
      $(this).removeClass('disabled');
      console.log(error);
      toastAlert(error.responseJSON.errors[0] || error.responseJSON.message);
    });
});

$(document).on('click', '.deleteVerification:not(.disabled)', function () {
  const reason = $('.banReason').val();
  if (!reason) {
    toastAlert('A reason must be provided.');
    return;
  }
  const gainId = +$(this).attr('data-gainid');
  $(this).addClass('disabled');
  DeleteRequest(`fc-api/id-verifications/veriff`, {
    gainId,
    reason,
  })
    .then(() => {
      toastAlert('Success!');
    })
    .catch((error) => {
      $(this).removeClass('disabled');
      toastAlert(error.responseJSON.errors[0] || error.responseJSON.message);
    });
});

$(document).on('click', '.modVet', function () {
  const gainId = $(this).attr('data-gainid');
  const modUsername = $(this).attr('data-mod-user');
  PostRequest(`fc-api/users/${gainId}/vet`, {})
    .then(() => {
      toastAlert('User vetted!');
      let elem = $(`#lastVetted`);
      elem?.html(`Last vetted by ${modUsername} just now`);
    })
    .catch((error) => {
      toastAlert(error.responseJSON.errors[0] || error.responseJSON.message);
    });
});

socket.on('modVetSucceeded', function (data) {
  let elem = $(`#lastVetted`);
  elem?.html(`Last vetted by ${data.modname} just now`);
});

$(document).on('click', '.modBan', function () {
  socket.emit('modBan', {
    gainid: $(this).attr('data-gainid'),
    reason: $('.banReason').val(),
    publicReason: $(this).attr('data-public-reason'),
    type: $(this).attr('data-type'),
  });
});

$(document).on('click', '.modRequestPhoneVerification:not(.disabled)', function () {
  const reason = $('.banReason').val();
  if (!reason) {
    toastAlert('A reason must be provided.');
    return;
  }
  $(this).addClass('disabled');
  PostRequest(`fc-api/phone-verifications/request`, {
    gainId: +$(this).attr('data-gainid'),
    reason,
  })
    .then(() => {
      toastAlert('Success!');
    })
    .catch((error) => {
      $(this).removeClass('disabled');
      console.log(error);
      toastAlert(error.responseJSON.errors[0] || error.responseJSON.message);
    });
});

$(document).on('click', '.modRequestIdVerification:not(.disabled)', function () {
  const $this = $(this);
  const reason = $('.banReason').val();
  if (!reason) {
    toastAlert('A reason must be provided.');
    return;
  }
  $('.modRequestIdVerification').addClass('disabled');
  PostRequest('fc-api/id-verifications/request', {
    reason,
    gainId: $this.data('gainid'),
    reqType: $this.data('req-type'),
    provider: $this.data('provider') ?? 'Veriff',
    trigger: 'manual',
  })
    .then((response) => {
      toastAlert(response.message);
    })
    .catch((error) => {
      $('.modRequestIdVerification').removeClass('disabled');
      console.log(error);
      toastAlert(error.responseJSON.message);
    });
});

$(document).on('click', '.modRequestKycVerification:not(.disabled)', function () {
  const $this = $(this);
  const reason = $('.banReason').val();
  if (!reason) {
    toastAlert('A reason must be provided.');
    return;
  }
  $('.modRequestKycVerification').addClass('disabled');
  PostRequest('fc-api/kyc-verifications/request', {
    reason,
    gainId: $this.data('gainid'),
    reqType: $this.data('req-type'),
    trigger: 'manual',
  })
    .then((response) => {
      toastAlert(response.message);
    })
    .catch((error) => {
      $('.modRequestKycVerification').removeClass('disabled');
      console.log(error);
      toastAlert(error.responseJSON.message);
    });
});

$(document).on('click', '.releaseHeldSurvey', function () {
  const surveyId = $(this).attr('data-surveyid');
  toastAlert('Releasing survey...');
  PostRequest(`fc-api/user-offers/release-held-survey`, { surveyId })
    .then((response) => {
      toastAlert(response.message);
      $(`.heldSurvey${surveyId}`).fadeOut();
    })
    .catch((error) => {
      toastAlert(error.responseJSON.errors[0] || error.responseJSON.message);
    });
});

$(document).on('click', '.creditSkippedOffer', function () {
  const surveyId = $(this).attr('data-surveyid');
  toastAlert('Crediting offer...');
  PostRequest(`fc-api/user-offers/credit-skipped-offer`, { surveyId })
    .then((response) => {
      toastAlert(response.message);
    })
    .catch((error) => {
      toastAlert(error.responseJSON.errors[0] || error.responseJSON.message);
    });
});

$(document).on('click', '.holdCompletedSurvey', function () {
  const surveyId = $(this).attr('data-surveyid');
  toastAlert('Holding survey...');
  PostRequest(`fc-api/user-offers/hold-completed-survey`, { surveyId })
    .then((response) => {
      toastAlert(response.message);
      $(`.completedSurvey${surveyId}`).fadeOut();
    })
    .catch((error) => {
      toastAlert(error.responseJSON.errors[0] || error.responseJSON.message);
    });
});

$(document).on('click', '.queueReleaseSurvey', function () {
  const surveyId = $(this).attr('data-surveyid');
  const days = $(this).attr('data-time');
  toastAlert('Queueing survey...');
  PostRequest(`fc-api/user-offers/queue-release-survey`, { surveyId, days })
    .then((response) => {
      toastAlert(response.message);
    })
    .catch((error) => {
      toastAlert(error.responseJSON.errors[0] || error.responseJSON.message);
    });
});

$(document).on('click', '.cancelQueuedSurvey', function () {
  const surveyId = $(this).attr('data-surveyid');
  toastAlert('Canceling queued survey...');
  PostRequest(`fc-api/user-offers/cancel-queued-survey`, { surveyId })
    .then((response) => {
      toastAlert(response.message);
    })
    .catch((error) => {
      toastAlert(error.responseJSON.errors[0] || error.responseJSON.message);
    });
});

$(document).on('click', '.releasePendingWithdraw', function () {
  socket.emit('releasePendingWithdraw', {
    releaseId: $(this).attr('data-releaseid'),
    flagged: false,
  });
});

$(document).on('click', '.chargebackSurvey', function () {
  const surveyId = $(this).attr('data-surveyid');
  toastAlert('Survey chargeback...');
  PostRequest(`fc-api/user-offers/manual-chargeback`, { surveyId })
    .then((response) => {
      toastAlert(response.message);
    })
    .catch((error) => {
      toastAlert(error.responseJSON.errors[0] || error.responseJSON.message);
    });
});

socket.on('chargebackSurveySucceeded', function (data) {
  let row = $(`.completedSurvey${data.surveyid}`);
  row?.css('color', '#d14665');
  row?.find('.chargebackSurvey')?.fadeOut();
  row?.find('.holdCompletedSurvey')?.fadeOut();
});

$(document).on('click', '.flagPendingWithdraw', function () {
  socket.emit('releasePendingWithdraw', {
    releaseId: $(this).attr('data-releaseid'),
    flagged: true,
  });
});

$(document).on('click', '.markPendingWithdrawalReview', function () {
  socket.emit('markPendingWithdrawalReview', $(this).attr('data-releaseid'));
});

socket.on('pendingWithdrawalReleased', function (releaseid) {
  $(`.pendingWithdrawReleaseRejectBox[data-releaseid="${releaseid}"]`).html(
    `<span style="color: green">Processed</span>`
  );
});

socket.on('pendingWithdrawalRejected', function (releaseid) {
  $(`.pendingWithdrawReleaseRejectBox[data-releaseid="${releaseid}"]`).html(
    `<span style="color: red">Rejected</span>`
  );
  const el = document.getElementById('paypal_' + releaseid);
  if (el) {
    el.innerHTML = `<span style="color: red">Rejected</span>`;
  }
});

socket.on('pendingWithdrawStatusChanged', function ({ releaseid, status }) {
  let section = null;

  if ($('.rootMod').length) {
    section = '.rootMod';
  }

  const releaseBtn = $(
    `${section} .responsive-table .pendingWithdraw${releaseid} .btn.autoReleasePaypal`
  );
  const statusColIx = $(`${section} .responsive-table th:contains("Status")`).first().index();
  const statusCell = $(`${section} .responsive-table .pendingWithdraw${releaseid} > td`).get(
    statusColIx
  );
  $(statusCell).text(status);

  if (status === 'FAILED') {
    $(releaseBtn).attr('disabled', false);
  }
});

socket.on('pendingPaypallRejected', function (releaseid) {
  $(`.pendingPaypalReleaseRejectBox[data-releaseid="${releaseid}"]`).html(
    `<span style="color: red">Rejected</span>`
  );
});

socket.on('markPendingWithdrawalUnderReview', function (data) {
  $(`.markPendingWithdrawalReviewTd[data-releaseid="${data.releaseid}"]`).html(`
		<div class="truncate" style="max-width: 120px;" title="${data.reviewerName}"><i class="fas fa-search-dollar"></i> ${data.reviewerName}</div>
	`);
});

$(document).on('click', '.rejectPendingWithdraw', function () {
  socket.emit('rejectPendingWithdraw', $(this).attr('data-releaseid'));
});

$(document).on('click', '.flagOffer', function () {
  socket.emit('flagOffer', {
    offerId: $(this).attr('data-offer-id'),
    offerName: $(this).attr('data-offer-name'),
    providerName: $(this).attr('data-offer-provider'),
    reason: $(this).closest('.modal-content').find('.flagReason').val(),
  });
});

socket.on('flagOfferSucceeded', function (data) {
  let cell = $(
    `.offerActionContainer[data-offer-id="${data.offerId}"][data-offer-provider="${data.providerName}"]`
  );
  cell.html(`<span style="color: orangered">Flagged</span>`);
  cell.closest('tr').addClass('flagged');
});

$(document).on('click', '.unflagOffer', function () {
  socket.emit('unflagOffer', {
    offerId: $(this).attr('data-offer-id'),
    providerName: $(this).attr('data-offer-provider'),
  });
});

socket.on('unflagOfferSucceeded', function (data) {
  $(
    `.offerActionContainer[data-offer-id="${data.offerId}"][data-offer-provider="${data.providerName}"]`
  ).html(`<span style="color: green">Unflagged</span>`);
});

/* referral event */

$(document).on('click', '.releaseRefEvent', function () {
  socket.emit('releaseRefEvent', { id: $(this).attr('data-id') });
});

$(document).on('click', '.rejectRefEvent', function () {
  socket.emit('rejectRefEvent', { id: $(this).attr('data-id') });
});

$(document).on('click', '.reviewRefEvent', function () {
  socket.emit('reviewRefEvent', {
    id: $(this).attr('data-id'),
    elemId: $(this).attr('data-parent'),
  });
});

socket.on(`markUnderReview`, function (data) {
  const elemId = data.elemId;
  const reviewerName = data.reviewerName;
  $(`#${elemId}`).html(`
  	<div class="truncate" style="max-width: 120px;" title="${reviewerName}"><i class="fas fa-search-dollar"></i> ${reviewerName}</div>
  `);
});

socket.on('removeSomething', function (thing) {
  $(thing).fadeOut();
});

$(document).on('click', '.modNavBtn', function () {
  $('.rootMod').html(loaderHtml);
  $('.rootAdmin').html(loaderHtml);

  socket.emit('renderRootMod', {
    page: $(this).attr('data-page'),
    paginatePage: 1,
  });
});

$(document).on('click', '.bannedSearchBtn', function () {
  var filterValue = $('#bannedFilterValue').val();

  console.log('Filter value ', filterValue);

  socket.emit('renderRootMod', {
    page: $(this).attr('data-page'),
    paginatePage: 1,
    filter: filterValue,
    search: $('#bannedSearchInput').val(),
  });
});

$(document).on('click', '.bannedSearchSuggestion', function () {
  $('#bannedSearchInput').val($(this).text());
  $('.bannedSearchBtn').click();
});

socket.on('renderRootMod', function (html) {
  $('.rootMod').html(html);
  $('.rootAdmin').html(html);

  $('time.timeago').timeago();
  M.updateTextFields();
  $('.pendingWithdrawTooltip').tooltip();
});

$(document).on('click', '.modRootPaginate', function () {
  socket.emit('renderRootMod', {
    page: $(this).attr('data-page'),
    paginatePage: $(this).attr('data-value'),
    search: $(this).attr('data-search'),
    subPage: $(this).attr('data-subPage'),
    provider: $(this).attr('data-provider'),
    campaignName: $(this).attr('data-campaignName'),
  });
});

function doModSearch(paginatePage) {
  socket.emit('modUserSearch', {
    query: $('#modUserSearchInput').val(),
    searchBy: $('.modUserSearchSelectSearchBy').val(),
    paginatePage: paginatePage || 1,
  });
}

$(document).on('click', '.modUserSearchBtn', function () {
  $('.modSearchResults').html(loaderHtml);
  doModSearch();
});

$(document).on('keydown', '#modUserSearchInput', function () {
  $('.modSearchResults').html(loaderHtml);
  setTimeout(function () {
    doModSearch();
  }, 1);
});

$(document).on('change', '.modUserSearchSelectSearchBy', function () {
  $('.modSearchResults').html(loaderHtml);
  setTimeout(function () {
    doModSearch();
  }, 1);
});

$(document).on('click', '.modUserSearchPaginate', function () {
  doModSearch($(this).attr('data-value'));
});

socket.on('renderModSearchResults', function (html) {
  $('.modSearchResults').html(html);
});

$(document).on('click', '.closeBannedSupportBtn', function () {
  socket.emit('alterBannedSupportTicket', {
    usergainid: $(this).attr('data-usergainid'),
    action: 'close',
    sendMessage: !!parseInt($(this).data('msg')),
  });
});

$(document).on('click', '.muteBannedSupportBtn', function () {
  socket.emit('alterBannedSupportTicket', {
    usergainid: $(this).attr('data-usergainid'),
    action: 'mute',
  });
});

$(document).on(
  'click',
  '.banned-support-ticket .requestVerificationBtn:not(.disabled)',
  function () {
    const $this = $(this);
    $this.addClass('disabled');
    PostRequest('fc-api/id-verifications/request', {
      reason: $this.data('reason'),
      gainId: $this.data('gainid'),
      reqType: 'review',
      trigger: 'manual',
    })
      .then(({ message, verification }) => {
        toastAlert(message);
        const status = verification.status.charAt(0).toUpperCase() + verification.status.slice(1);
        $this.parent()
          .html(`<a href="https://hub.veriff.com/verifications/${verification.inquiryId}"
      target="_blank">${status}</a>`);
      })
      .catch((error) => {
        $this.removeClass('disabled');
        console.log(error);
        toastAlert(error.responseJSON.message);
      });
  }
);

$(document).on('click', '#changeUserAllowanceBtn', function () {
  socket.emit('changeUserAllowance', {
    gainid: $(this).attr('data-gainid'),
    newAllowance: $('#newUserAllowance').val(),
  });
});

socket.on('newUserWithdrawalAllowance', function (data) {
  let gainid = data.gainid,
    newAllowance = data.newAllowance;

  $(`#userAllowanceValue[data-gainid="${gainid}"]`).text(newAllowance);
});
{
  let bannedSupportDirections = {};
  let currentSortBy = 'users.xp';
  let currentSortDirection = 'DESC';
  let minBalance = 0;

  $(document).on('click', '.bannedSupportPaginate', function () {
    socket.emit('renderBannedSupport', {
      paginatePage: $(this).attr('data-value'),
      sortBy: currentSortBy,
      sortDirection: currentSortDirection,
    });
  });

  $(document).on('click', '.bannedSupportTh', function () {
    let sortBy = $(this).attr('data-sort');
    let sortDirection = bannedSupportDirections[sortBy] || $(this).attr('data-sort-direction');

    if (sortDirection == 'ASC') {
      bannedSupportDirections[sortBy] = 'DESC';
    } else {
      bannedSupportDirections[sortBy] = 'ASC';
    }
    currentSortBy = sortBy;
    currentSortDirection = sortDirection;

    socket.emit('renderBannedSupport', {
      sortBy: sortBy,
      sortDirection: sortDirection,
    });
  });

  $(document).on('click', '.filterBannedSupportBtn', function () {
    minBalance = $('#bannedSupportMinCoins').val() || 0;

    socket.emit('renderBannedSupport', {
      sortBy: currentSortBy,
      sortDirection: currentSortDirection,
      minBalance: minBalance,
    });
  });

  $(document).on('click', '.potentialVerificationsTh', function () {
    let sortBy = $(this).attr('data-sort');
    let sortDirection = bannedSupportDirections[sortBy] || $(this).attr('data-sort-direction');

    if (sortDirection == 'ASC') {
      bannedSupportDirections[sortBy] = 'DESC';
    } else {
      bannedSupportDirections[sortBy] = 'ASC';
    }
    currentSortBy = sortBy;
    currentSortDirection = sortDirection;

    socket.emit('renderRootMod', {
      sortBy: sortBy,
      sortDirection: sortDirection,
      page: 'potential-verifications',
      paginatePage: 1,
    });
  });

  $(document).on('click', '.potentialVerificationsPaginate', function () {
    socket.emit('renderBannedSupport', {
      paginatePage: $(this).attr('data-value'),
      sortBy: currentSortBy,
      sortDirection: currentSortDirection,
    });
  });

  $(document).on('click', '.cancelQueuedReward', function () {
    const id = $(this).attr('data-id');
    toastAlert('Canceling queued reward...');
    PostRequest(`fc-api/user-rewards/cancel-queued-reward`, { id })
      .then((response) => {
        toastAlert(response.message);
      })
      .catch((error) => {
        toastAlert(error.responseJSON.errors[0] || error.responseJSON.message);
      });
  });

  $(document).on('click', '.queueReleaseReward', function () {
    const id = $(this).attr('data-id');
    const days = $(this).attr('data-time');
    toastAlert('Queueing reward...');
    PostRequest(`fc-api/user-rewards/queue-release-reward`, { id, days })
      .then((response) => {
        toastAlert(response.message);
      })
      .catch((error) => {
        toastAlert(error.responseJSON.errors[0] || error.responseJSON.message);
      });
  });
}

function rejectVerification(gainid) {
  PatchRequest(`fc-api/users/${gainid}/potential-verifications/keep-unverified`, {})
    .then((response) => {
      toastAlert(response.message);
    })
    .catch((error) => {
      console.log(error);
      toastAlert(error.responseJSON.errors[0] || error.responseJSON.message);
    });
}

function changeUiMode(uiMode, gainid) {
  return PatchRequest(`fc-api/users/${gainid}/change-ui-mode`, {
    uiMode: uiMode,
  })
    .then((response) => {
      toastAlert(response.message);
    })
    .catch((error) => {
      toastAlert(error.responseJSON.errors[0] || error.responseJSON.message);
    });
}

function Modal(id, title) {
  this.html = `
  <div id="${id}" class="modal">
    <div class="modal-content modalContent">
      <h5 class="modalTitle">${title} <a href="#!" class="modal-close waves-effect btn-flat closeModalBtn"><i 
      class="far fa-times-circle"></i></a></h5>
      <div class="rootModalBody">
        ${loaderHtml}
      </div>
    </div>
  </div>`;
}

function openModal(name, route, onClose, modalProps = {}, goBackOnClose) {
  $(name).modal({
    onOpenStart: function () {
      window.dispatchEvent(new CustomEvent('fc:bs-modal-shown'));
    },
    onCloseStart: function () {
      window.dispatchEvent(new CustomEvent('fc:bs-modal-hidden'));
      if (goBackOnClose) {
        window.history.back();
      } else {
        pushState(currentBackRoute);
        $('body').css('overflow', '');
        if (typeof onClose === 'function') onClose();
      }
    },
    preventScrolling: false, // Preventing scrolling ads overflow hidden to body, which moves the page content
    ...modalProps,
  });
  $(name).modal('open');
}
$(document).on('click', '.modalLoginBtn', function (e) {
  if (getLocalStorage('termsAgreed')) {
    window.location = $(this).attr('loginLink');
  } else {
    openModal('#loginModal');
  }
});

$(document).on('click', '.claimDownloadButton', function (e) {
  socket.emit(
    'claimDownloadAppReward',
    {
      ios: app.utils.isIos(),
      standalone: app.utils.isInStandaloneMode(),
      source: app.appSource,
    },
    function ({ html, claimed }) {
      if (html) {
        $('#downloadRewardModal').html(html);
        $('#downloadRewardModal').modal('open');
      }

      if (claimed) {
        $('.claimDownloadButton').text('Claimed').attr('disabled', true);
      }
    }
  );
});

$(document).on('click', '.modalLoginBtn2', function (e) {
  openReactAuthModal(0);
});

$(document).on('click', '.how-to-use-btn', function () {
  openModal('#how-to-use-modal');
});

function setTosAgreed() {
  setLocalStorage('termsAgreed', 1);
}

$(function () {
  // Get and render new table based on event
  $(document).on('click', '.monitoringPanelNavBtn', function () {
    $('.rootMonitoring').html(loaderHtml);
    const page = $(this).attr('data-page');
    socket.emit('renderRootMonitoring', {
      page: page,
    });
    $('#modMonitoringPage').find('.active').removeClass('active');
    $(this).addClass('active');
  });

  // Inject table HTML received from server
  socket.on('renderRootMonitoring', function (html) {
    $('.rootMonitoring').html(html);
    $('time.timeago').timeago();
  });

  // Handling Pagination
  $(document).on('click', '.modMonitoringPanelPaginateBtn', function () {
    const activePage = getActivePage();
    const filtersVals = getFilterValues(activePage);
    const pageNumber = $(this).attr('data-value');
    renderPage(activePage, pageNumber, filtersVals);
  });

  // Filter button event handler
  $(document).on('click', '.monitoringPanelFilterBtn', function () {
    const activePage = getActivePage();
    const filtersVals = getFilterValues(activePage);
    const pageNumber = 1;

    if (filtersVals && filtersVals.validations) {
      const validateInputs = filtersVals.validations();
      if (!validateInputs) return;
      delete filtersVals.validations; // else delete validation prop
    }

    renderPage(activePage, pageNumber, filtersVals);
  });

  // Filter button event handler for offer stats panel
  $(document).on('click', '.offerStatsmonitoringPanelGoBtn', function () {
    const activePage = getActivePage();
    const filtersVals = getFilterValues(activePage);

    const pageNumber = 1;
    renderPage(activePage, pageNumber, filtersVals);
  });

  // Open offer completes panel upon clicking on offer name in offer volume table
  $(document).on('click', '.openOfferNameData', function () {
    const offerName = $(this).text();
    const activatePage = 'offercompletes';
    const filters = {
      offername: offerName,
      wall: $(this).closest('tr').children('td:first').text(),
    };
    renderPage(activatePage, 1, filters);
    //Active offer completes page
    $('#modMonitoringPage').find('.active').removeClass('active');
    $('#modMonitoringPage').find(`[data-page="${activatePage}"]`).addClass('active');
  });

  // Open offer completes panel upon clicking on offer name in offer completes table
  $(document).on('click', '.openOfferStatsPanel', function () {
    const offerName = $(this).text();
    const activatePage = 'offerstatistics';
    const filters = {
      offerName: offerName,
      wall: $(this).closest('tr').children('td').eq(1).text(),
      fromDate: new Date(new Date().setDate(new Date().getDate() - 1)).toISOString().slice(0, 10),
      toDate: new Date().toISOString().slice(0, 10),
    };
    renderPage(activatePage, 1, filters);
    //Active offer completes page
    $('#modMonitoringPage').find('.active').removeClass('active');
    $('#modMonitoringPage').find(`[data-page="${activatePage}"]`).addClass('active');
  });

  // Open offer volume panel upon clicking on country code in country volume table
  $(document).on('click', '.openCountryCodeData', function () {
    const countryCode = $(this).text();
    const activatePage = 'highoffervolume';
    const filters = {
      countryCode: countryCode,
    };
    renderPage(activatePage, 1, filters);
    //Active offer volume page
    $('#modMonitoringPage').find('.active').removeClass('active');
    $('#modMonitoringPage').find(`[data-page="${activatePage}"]`).addClass('active');
  });

  // Open scheduled releases panel upon clicking on offer name in scheduled releases summary table
  $(document).on('click', '.openScheduledReleasesData', function () {
    const offerName = $(this).text();
    const activatePage = 'scheduledreleases';
    const filters = {
      offername: offerName,
      wall: $(this).closest('tr').children('td:first').text(),
    };
    renderPage(activatePage, 1, filters);
    //Active offer completes page
    $('#modMonitoringPage').find('.active').removeClass('active');
    $('#modMonitoringPage').find(`[data-page="${activatePage}"]`).addClass('active');
  });

  // Handle Low Tier Countries Logic
  $(document).on('change', '#showlowtierearners-highearners', function () {
    $('#countrycode-highearners').val('');
    const activePage = getActivePage();
    const filtersVals = getFilterValues(activePage);
    const pageNumber = 1;
    renderPage(activePage, pageNumber, filtersVals);
  });

  // Rendering page, used to send event/data to server and get updated HTML
  function renderPage(page, pageNumber, filters) {
    const renderSocketEvent = 'renderRootMonitoring';
    $('.rootMonitoring').html(loaderHtml);
    socket.emit(renderSocketEvent, {
      page: page,
      filters: filters ? filters : {},
      paginatePage: pageNumber || 1,
    });
  }
  // Get active tab on page
  const getActivePage = () => {
    const activePage = $('#modMonitoringPage').find('.active').attr('data-page') || 'offervolume';
    return activePage;
  };
  // Manage and get filters based on active event
  function getFilterValues(event) {
    const filters = {
      highoffervolume: {
        multiple: $('#multiple-highoffervolume').val(),
        countryCode: $('#countrycode-highoffervolume').val(),
      },
      offervolume: {
        wall: $('select[name="wall"]').val(),
        countryCode: $('#countrycode-offervolume').val(),
        signUpDays: $('#signupdays-offervolume').val(),
        flag: $('.offervolume-selected-flag').attr('value'),
        offerDays: $('#offerdays-offervolume').val(),
        held: $('#held-offervolume').is(':checked') ? true : false,
        offername: $('#offername-offervolume').val(),
      },
      offercompletes: {
        offername: $('#offername-offercompletes').val(),
        wall: $('select[name="wall"]').val(),
        countryCode: $('#countrycode-offercompletes').val(),
        coins: $('#coins-offercompletes').val(),
        held: $('#held-offercompletes').is(':checked') ? true : false,
      },
      countrywallvolume: {
        multiple: $('#multiple-countrywallvolume').val(),
        countryCode: $('#countrycode-countrywallvolume').val(),
      },
      scheduledreleasessummary: {
        numDays: $('#numDays-scheduledreleasessummary').val(),
      },
      scheduledreleases: {
        offername: $('#offername-scheduledreleases').val(),
        wall: $('select[name="wall"]').val(),
        minCoins: $('#mincoins-scheduledreleases').val(),
        maxCoins: $('#maxcoins-scheduledreleases').val(),
        hidebanned: $('#scheduledreleases-hidebanned').is(':checked') ? true : false,
        flag: $('.scheduledreleases-selected-flag').attr('value'),
        orderByCol: $('#scheduledreleases-orderbycol').val(),
        orderByDir: $('#scheduledreleases-orderbydir').val(),
      },
      highearners: {
        wall: $('select[name="wall"]').val(),
        surveydays: $('#surveydays-highearners').val(),
        datejoineddays: $('#datejoineddays-highearners').val(),
        countryCode: $('#countrycode-highearners').val(),
        hidebanned: $('#hidebanned-highearners').is(':checked') ? true : false,
        showLowTierEarners: $('#showlowtierearners-highearners').is(':checked') ? true : false,
      },
      unbans: {
        bannedby: $('#bannedby-unbans').val(),
        unbannedby: $('#unbannedby-unbans').val(),
        rule: $('#rule-unbans').val(),
      },
      bans: {
        bannedby: $('#bannedby-bans').val(),
        rule: $('#rule-bans').val(),
        minbalance: $('#minbalance-bans').val(),
        minlevel: $('#minlevel-bans').val(),
        manualbans: $('#manualbans-bans').is(':checked') ? true : false,
        appealstatus: $('#appealstatus-bans').val(),
      },
      offerstatistics: {
        wall: $('select[name="wall"]').val(),
        offerName: $('#offerstatistics-offername').val(),
        countryCode: $('#offerstatistics-countrycode').val(),
        fromDate: $('#offerstatistics-fromDate').val(),
        toDate: $('#offerstatistics-toDate').val(),
        validations: function () {
          if (!this.offerName) return toastAlert('Offer name is required');
          if (!this.fromDate || !this.toDate) return toastAlert('From/To date is required');
          if (new Date(this.fromDate) > new Date(this.toDate))
            return toastAlert('From date should be less than to date');
          const daysDiff = (new Date(this.toDate) - new Date(this.fromDate)) / 86400000;
          if (daysDiff > 62) return toastAlert('You can fetch 62 days data at a time');

          return true;
        },
      },
      offerchargebacks: {
        wall: $('select[name="wall"]').val(),
        offerName: $('#offername-offerchargebacks').val(),
        startDays: $('#startdays-offerchargebacks').val(),
        endDays: $('#enddays-offerchargebacks').val(),
        orderByCol: $('#offerchargebacks-orderbycol').val(),
        orderByDir: $('#offerchargebacks-orderbydir').val(),
      },
      dailyofferhelds: {
        wall: $('select[name="wall"]').val(),
        flag: $('.dailyofferhelds-selected-flag').attr('value'),
        signUpDays: $('#signupdays-dailyofferhelds').val(),
        coins: $('#coins-dailyofferhelds').val(),
        surveyDays: $('#surveydays-dailyofferhelds').val(),
        countryCode: $('#countrycode-dailyofferhelds').val(),
      },
      dailynewuserspercentage: {
        wall: $('select[name="wall"]').val(),
        flag: $('.dailynewusers-selected-flag').attr('value'),
        coins: $('#coins-dailynewusers').val(),
        surveyDays: $('#surveydays-dailynewusers').val(),
        countryCode: $('#countrycode-dailynewusers').val(),
      },
      bansbyflag: {
        lastFlagged: $('#lastflagged-bansbyflags').val(),
        userLevel: $('#userlevel-bansbyflags').val(),
      },
      bansbywall: {
        signUpDays: $('#signupdays-bansbywall').val(),
        surveyDays: $('#surveydays-bansbywall').val(),
      },
      heldearnings: {
        wall: $('select[name="wall"]').val(),
        heldBy: $("input[name='heldby-heldearnings']:checked").val(),
        surveyDays: $('#surveydays-heldearnings').val(),
        signUpDays: $('#signupdays-heldearnings').val(),
        coins: $('#coins-heldearnings').val(),
        countryCode: $('#countrycode-heldearnings').val(),
        excludeQuality: $('#qualitycheck-heldearnings').is(':checked') ? true : false,
      },
      chargebacks: {
        chargebacksby: $("input[name='chargebacksby']:checked").val(),
        wall: $('select[name="wall"]').val(),
        startDays: $('#startdays-chargebacks').val(),
        endDays: $('#enddays-chargebacks').val(),
        coins: $('#coins-chargebacks').val(),
        countryCode: $('#countrycode-chargebacks').val(),
        excludeQuality: $('#qualitycheck-chargebacks').is(':checked') ? true : false,
      },
      offertxnids: {
        txnIds: $('#offer-txnids').val(),
      },
    };

    const eventFilters = filters[event];
    if (eventFilters && Object.keys(eventFilters).length > 0) {
      for (let key in eventFilters) {
        if (typeof eventFilters[key] === 'undefined' || eventFilters[key] === '') {
          delete eventFilters[key];
          //eventFilters[key] = null;
        }
      }
      return eventFilters;
    }
    return {};
  }

  //**************Start Manual Override Tab CRUD OPs****************//
  // Get modal form values
  const getManualOverrideFormData = () => {
    const offerData = {
      offername: $('#manualoverride-offername').val(),
      offerid: $('#manualoverride-offerid').val(),
      days: $('#manualoverride-days').val(),
      maxDaysJoined: $('#manualoverride-maxDaysJoined').val(),
      minCoins: $('#manualoverride-minCoins').val(),
      providerName: $('#manualoverride-providername').val(),
      country: $('#manualoverride-country').val(),
    };

    //Delete key that is empty or not set
    Object.keys(offerData).forEach((key) => {
      if (!offerData[key] || `${offerData[key]}`.trim() === '') {
        delete offerData[key];
      }
    });

    // Add id to data if the state is edit
    const state = $('#manualOverrideSaveData').attr('data-action');
    if (state === 'edit') {
      offerData['id'] = $('#manualOverrideSaveData').attr('data-id');
    }

    // Remove " - " values - those are added to show empty values as '-'
    Object.keys(offerData).forEach((key) =>
      offerData[key] == '-' ? (offerData[key] = null) : false
    );
    return offerData;
  };

  // Open Modal for Add new/Edit resource
  const openDataModal = () => {
    const modalProps = {
      dismissible: false,
      onCloseEnd: () => {
        $('#manualOverrideDataForm').trigger('reset');
      },
    };
    openModal('#manualOverrideDataModal', null, null, modalProps);
  };

  // Open Manual Override on Adding New Resource
  $(document).on('click', '#manualOverrideAddData', function () {
    $('#manualOverrideFormTitle').text('Add New Offer Override');
    $('#manualOverrideSaveData').attr('data-action', 'add');
    openDataModal();
  });

  //Edit Resource
  $(document).on('click', '.manualOverrideEditData', function () {
    $('#manualOverrideFormTitle').text('Edit Offer Override');
    $('#manualOverrideSaveData').attr('data-action', 'edit');
    const tableRow = $(this).closest('tr');
    // Get the current row & Set Data
    const id = tableRow.attr('data-id');
    $('#manualOverrideSaveData').attr('data-id', id);

    // Get td data & remove "-" from cell values
    const rowLen = tableRow.find('td').length;
    const rowData = [];
    for (let i = 0; i < rowLen; i++) {
      const text = tableRow.find(`td:eq(${i})`).text().trim();
      text === '-' ? rowData.push('') : rowData.push(text);
    }
    $('#manualoverride-offername').val(rowData[0]);
    $('#manualoverride-offerid').val(rowData[1]);
    $('#manualoverride-days').val(rowData[2]);
    $('#manualoverride-maxDaysJoined').val(rowData[3]);
    $('#manualoverride-minCoins').val(rowData[4]);
    $('#manualoverride-providername').val(rowData[5]);
    $('#manualoverride-country').val(rowData[7]);

    openDataModal();
  });

  // Open Delete Confirmation Modal
  $(document).on('click', '.manualOverrideDeleteData', function () {
    const id = $(this).closest('tr').attr('data-id');
    $('#manualOverrideConfirmDelete').attr('data-id', id); //Set id on modal
    openModal('#manualOverrideDeleteModal', null, null, {
      dismissible: false,
    });
  });

  // Create/Edit Resource
  $(document).on('click', '#manualOverrideSaveData', function () {
    const offerData = getManualOverrideFormData();
    const state = $('#manualOverrideSaveData').attr('data-action');
    const actions = {
      add: 'manualoverride.create',
      edit: 'manualoverride.update',
    };
    // Validations
    if (!offerData.offername && !offerData.offerid)
      return toastAlert('Either offer name or offer id is required.');
    if (!offerData.days) return toastAlert('Days are required.');
    if (`${offerData.country}`.length > 10)
      return toastAlert('Country name should be less than 10 characters.');

    const payload = {
      action: actions[state],
      data: offerData,
    };

    socket.emit('monitoringActions', payload, (response) => {
      if (response.status === 200) {
        $('#manualOverrideDataForm').trigger('reset');
        $('#manualOverrideDataModal').modal('close');
        toastAlert(response.message || 'Data saved successfully!');
        // because same event is being used in offer volume - check page
        if (getActivePage() === 'manualoverrides') {
          $('#modMonitoringPage').find('.active').trigger('click'); // Fetch data again
        }
      } else {
        toastAlert('An error occured, please try again!');
      }
    });
  });

  //Delete row
  $(document).on('click', '#manualOverrideConfirmDelete', function () {
    const rowID = $(this).attr('data-id');
    const action = 'manualoverride.delete';
    const payload = {
      action: action,
      id: rowID,
    };
    socket.emit('monitoringActions', payload, (response) => {
      if (response.status === 200) {
        $(this).removeAttr('data-id');
        $('#manualOverrideDeleteModal').modal('close');
        toastAlert(response.message || 'Data deleted successfully!');
        // because same event is being used in offer volume - check page
        if (getActivePage() === 'manualoverrides') {
          $('#modMonitoringPage').find('.active').trigger('click'); // Fetch data again
        }
      } else {
        toastAlert('An error occured, please try again!');
      }
    });
  });

  // Open offer completes panel upon clicking on offername in manual override panel
  $(document).on('click', '.manualOverrideOfferName', function () {
    const offerName = $(this).text();
    const activatePage = 'offercompletes';
    const filters = {
      offername: offerName,
    };
    renderPage(activatePage, 1, filters);
    //Active offer volume page
    $('#modMonitoringPage').find('.active').removeClass('active');
    $('#modMonitoringPage').find(`[data-page="${activatePage}"]`).addClass('active');
  });
  //**************END Manual Override Tab CRUD OPs****************//

  // Offer overrides modal
  $(document).on('click', '.showOfferOverridesModal', function () {
    const tableRow = $(this).closest('tr');
    const payload = {
      action: 'openOfferVolumeOverrideModal',
      data: {
        providerName: tableRow.find(`td:eq(0)`).text(),
        offerName: tableRow.find(`td:eq(1)`).text(),
        offerId: tableRow.attr('data-offerid'),
      },
    };
    socket.emit('monitoringActions', payload, function ({ html }) {
      $('#rootModal').html(html);
    });
  });
});

let notificationsState = false;

let totalNotifications = 0;

/**
 * Will fetch all unseen notifications
 * ATTENTION: THIS FUNCTION WILL EXCECUTE ITSELF
 */
(init = () => {
  socket.once('onAllUnseenNotifications', (data) => {
    if (!data || !data.length) {
      toggleNotificationIcon(false);
      return;
    }
    // create the notifications
    const parent = $('#notifications--content--container');
    parent.html('');
    for (const notification of data) {
      createNotificationElement(
        parent,
        notification.id,
        notification.category,
        notification.cluster,
        notification.message
      );
    }
  });
})();

/**
 * This will accept the notification messages from the backend (postbacks, etc.)
 */
socket.on('userNotification', (data) => {
  createNotificationElement(
    $('#notifications--content--container'),
    data.notificationId,
    data.category,
    data.cluster,
    data.message
  );

  if (data.cluster.startsWith('leaderboard_custom_')) {
    toastAlert(data.message);
  }
});

/**
 * This will open the support chat tab.
 */
socket.on('openSupportChatTab', () => {
  openSupportChat();
});

/**
 * This will delete clusters of notifications
 */
socket.on('notificationClusterSeen', (cluster) => {
  const allClusterElements = $(`.notifications--content--wrapper[data-cluster=${cluster}]`);

  for (const element of allClusterElements) {
    allClusterElements.remove();
    decreaseCounter();
  }
});

/**
 * Close Notification on click anywhere else (but not notifications)
 */
$(document).on('click', function (e) {
  if (!notificationsState) return;

  const $target = $(e.target);
  const $dropdownLock = $target.parents('.notification-dropdown-lock');
  if (!$target.hasClass('notification-dropdown-lock') && !$dropdownLock.length) {
    // do hide the dropdown if the clicked element is not in the list
    $('#notifications-popup').hide();
    notificationsState = false;
  }
});

function decreaseCounter() {
  if (totalNotifications > 0) {
    --totalNotifications;
  }
}

function increaseCounter() {
  ++totalNotifications;
}

/**
 * Will toggle the main dropdown of notification
 * @param show
 */
function toggleNotificationDropdown(show) {
  if (show) {
    $('#notifications-popup').show();
    notificationsState = true;
  } else {
    $('#notifications-popup').hide();
    notificationsState = false;
  }
}

/**
 * Toggle the dropdown
 */
$(document).on('click', '.notifications-bell', function () {
  if (!notificationsState) {
    if (totalNotifications === 0) {
      return toastAlert('No new notifications');
    }
    toggleNotificationDropdown(true);
  } else {
    toggleNotificationDropdown(false);
  }
});

/**
 * "Mark ALL as read"
 */
$(document).on('click', '#notifications-mark', function () {
  socket.emit('markAllNotificationAsRead');
  toastAlert('All notifications marked as read.');
  $('#notifications--content--container').html('');
  toggleNotificationDropdown(false);
  toggleNotificationIcon(false);
  totalNotifications = 0;
  $('.notifications-counter').html('');
});

/**
 * This will toggle the notification container in the navbar (show and hide).
 * @param shown
 */
function toggleNotificationIcon(shown) {
  const element = $('.notifications-bell');
  if (shown) {
    element.addClass('show');
  } else {
    element.removeClass('show');
  }
}

/**
 * Will navigate to leaderboard
 */
function goToLeaderboard(hash) {
  if (!window.location.href.includes('leaderboard')) {
    window.location.href = '/leaderboard' + (hash ? `#${hash}` : '');
  }
}

/**
 * Will navigate to the profile
 */
function goToProfile() {
  if (!window.location.href.includes('myprofile')) {
    window.location.href = '/myprofile#withdrawals';
  }
}

/**
 * Will mark the notification as read and delete it from the DOM
 * @param notificationID
 * @param cluster
 * @param text
 */
function markAsRead(notificationID, cluster, text) {
  socket.emit('markNotificationAsRead', notificationID);
  if (cluster === 'referral_event') {
    return app.openReferralModal();
  }
  const element = $(`#notification_${notificationID}`);
  const counter = $('.notifications-counter');
  element.addClass('slideOutRight');
  element[0].addEventListener('animationend', () => {
    element.hide();
    decreaseCounter();
    counter.html(totalNotifications);
    if (totalNotifications === 0) {
      toggleNotificationIcon(false);
      toggleNotificationDropdown(false);
      counter.html('');
    }
    if (cluster === 'support' || cluster === 'heldings') {
      openSupportChat();
    }
    if (cluster.includes('leaderboard')) {
      goToLeaderboard(cluster === 'leaderboard_easter' ? 'easter' : '');
    }
    if (text.toLowerCase().includes('gift card') && cluster !== 'pendingwithdrawal') {
      goToProfile();
    }
  });
}

/**
 * Create the Element
 * @param parent
 * @param notificationID
 * @param category
 * @param cluster
 * @param text
 */
function createNotificationElement(parent, notificationID, category, cluster, text) {
  increaseCounter();
  $('.notifications-counter').html(totalNotifications);
  // trigger the animation
  toggleNotificationIcon(false);
  toggleNotificationIcon(true);

  let img;
  switch (category) {
    case 'Success':
      img = 'success.png';
      break;
    case 'Info':
      img = 'info.png';
      break;
    case 'Warning':
      img = 'warning.png';
      break;
    case 'Error':
      img = 'error.png';
      break;
    default:
      img = 'info.png';
      break;
  }
  parent.prepend(`
    <div class="notifications--content--wrapper animated notification-dropdown-lock faster" id="notification_${notificationID}" data-cluster="${cluster}">
        <div class="notifications--content notification-dropdown-lock" onclick="markAsRead('${notificationID}', '${cluster}', '${text}')">
            <div class="category-image notification-dropdown-lock">
                <img alt="category" src="../../public/img/notifications/${img}" class="notification-dropdown-lock">
            </div>
            <div class="notification-text notification-dropdown-lock">
                <p class="category-header notification-dropdown-lock">
                    ${category}
                </p>
                <p class="notification notification-dropdown-lock">
                    ${text}
                </p>
            </div>
        </div>
    </div>
`);
}

let showOffersPageGoBackButton = false;

function getLimit() {
  const { width, height } = window.app.utils.getWindowDimensions();

  const offerHeight = 210;

  const rows = Math.ceil(height / offerHeight);

  let offersPerRow = 3;
  if (width > 1800) {
    offersPerRow = 12;
  } else if (width > 1600) {
    offersPerRow = 11;
  } else if (width > 1400) {
    offersPerRow = 10;
  } else if (width > 1200) {
    offersPerRow = 9;
  } else if (width > 999) {
    offersPerRow = 8;
  } else if (width > 800) {
    offersPerRow = 7;
  } else if (width >= 701) {
    offersPerRow = 6;
  }

  return offersPerRow * rows;
}

$(document).on('click', '.ownerNavBtn', function () {
  $('.rootOwner').html(loaderHtml);
  socket.emit('renderRootOwner', {
    page: $(this).attr('data-page'),
  });
});

$(document).on('click', '.ownerRootPaginate', function () {
  $('.rootOwner').html(loaderHtml);
  socket.emit('renderRootOwner', {
    page: $(this).attr('data-page'),
    paginatePage: $(this).attr('data-value'),
  });
});

socket.on('renderRootOwner', function (html) {
  $('.rootOwner').html(html);
  $('time.timeago').timeago();
  $('.datepicker').datepicker({
    format: 'yyyy-mm-dd',
  });
  M.updateTextFields();
});

$(document).on('click', '.refreshOwnerDayGraph', function () {
  socket.emit('renderRootOwner', {
    page: 'daygraphs',
    customDate: $('.ownerGraphDayPicker').val(),
  });
});

$(document).on('click', '.refreshOwnerRangeGraph', function () {
  socket.emit('renderRootOwner', {
    page: 'rangegraphs',
    startDate: $('.ownerGraphRangePickerStart').val(),
    endDate: $('.ownerGraphRangePickerEnd').val(),
  });
});

/* TAXES EXPORT DAY */

$(document).on('click', '.getOwnerWaxpeerDaily', function () {
  window.location.href = `/ownerGetDayWaxpeer?date=${$('.ownerGraphDayPicker').val()}`;
});

$(document).on('click', '.getOwnerEthereumDaily', function () {
  window.location.href = `/ownerGetDayEthereum?date=${$('.ownerGraphDayPicker').val()}`;
});

$(document).on('click', '.getOwnerGiftcardDaily', function () {
  window.location.href = `/ownerGetDayGiftcard?date=${$('.ownerGraphDayPicker').val()}`;
});

$(document).on('click', '.getOwnerPaypalDaily', function () {
  window.location.href = `/ownerGetDayPaypal?date=${$('.ownerGraphDayPicker').val()}`;
});

$(document).on('click', '.getWithdrawalsDataByDay', function () {
  const currency = $(this).attr('data-currency');
  const minDate = $('.ownerGraphDayPicker').val();
  const maxDate = $('.ownerGraphDayPicker').val();
  downloadTxnCSV(currency, minDate, maxDate);
});

/* TAXES EXPORT RANGE */

$(document).on('click', '.getOwnerWaxpeerRange', function () {
  window.location.href = `/ownerGetRangeWaxpeer?xmin=${$(
    '.ownerGraphRangePickerStart'
  ).val()}&xmax=${$('.ownerGraphRangePickerEnd').val()}`;
});

$(document).on('click', '.getOwnerEthereumRange', function () {
  window.location.href = `/ownerGetRangeEthereum?xmin=${$(
    '.ownerGraphRangePickerStart'
  ).val()}&xmax=${$('.ownerGraphRangePickerEnd').val()}`;
});

$(document).on('click', '.getOwnerGiftcardRange', function () {
  window.location.href = `/ownerGetRangeGiftcard?xmin=${$(
    '.ownerGraphRangePickerStart'
  ).val()}&xmax=${$('.ownerGraphRangePickerEnd').val()}`;
});

$(document).on('click', '.getOwnerPaypalRange', function () {
  window.location.href = `/ownerGetRangePaypal?xmin=${$(
    '.ownerGraphRangePickerStart'
  ).val()}&xmax=${$('.ownerGraphRangePickerEnd').val()}`;
});

$(document).on('click', '.getWithdrawalsDataByRange', function () {
  const currency = $(this).attr('data-currency');
  const minDate = $('.ownerGraphRangePickerStart').val();
  const maxDate = $('.ownerGraphRangePickerEnd').val();
  downloadTxnCSV(currency, minDate, maxDate);
});

// Download file endpoint
const downloadTxnCSV = (currency, minDate, maxDate) => {
  window.location.href = `/ownerGetTransactionsDataCSV/${currency}?minDate=${minDate}&maxDate=${maxDate}`;
};
//****************************CSV END ************************************/
$(document).on('click', '#ownerCreateBonusCodeBtn', function () {
  socket.emit('createNewGainBonusCode', {
    code: $('#newGainBonusCodeActualCode').val().trim(),
    reward: $('#newGainBonusCodeReward').val(),
    totalUses: $('#newGainBonusCodeTotalUses').val(),
    minToEarn: $('#newGainBonusCodeMinToEarn').val(),
    requirement: $('#newGainBonusCodeRequirement').val() || null,
    requirementValue: $('#newGainBonusCodeRequirementValue').val(),
  });
});

$(document).on('change', '#newGainBonusCodeRequirement', function () {
  const requirement = $('#newGainBonusCodeRequirement').val();

  if (['SIGNUP_BEFORE', 'SIGNUP_AFTER'].includes(requirement)) {
    $('#newGainBonusCodeRequirementValue').attr('type', 'date');
  } else {
    $('#newGainBonusCodeRequirementValue').attr('type', 'text');
  }
});

$(document).on('click', '#ownerAddGiftCardBtn', function () {
  socket.emit('ownerAddGiftCard', {
    code: $('#ownerNewGiftCardRedeemCode').val(),
    dollarPrice: $('#ownerNewGiftCardDollarPrice').val(),
    coinPrice: $('#ownerNewGiftCardCoinPrice').val(),
    euroPrice: $('#ownerNewGiftCardEuroPrice').val(),
    type: $('#ownerNewGiftCardType').val(),
    country: $('#ownerNewGiftCardCountry').val(),
  });
});

$(document).on('click', '#ownerEnableBonusCode', function () {
  socket.emit('ownerEnableBonusCode', {
    codeid: $(this).attr('data-codeid'),
  });
});

function makeOwnerGraph(labels, data, id, title) {
  new Chart(document.getElementById(id), {
    type: 'line',
    data: {
      labels: labels,
      datasets: data,
    },
    options: {
      title: {
        display: true,
        text: title,
      },
      //      legend: {
      //          display: false
      //      },
      spanGaps: true,
      scales: {
        yAxes: [
          {
            ticks: {
              callback: function (value, index, values) {
                return parseInt(value * 1000) / 1000 + ' coins';
              },
              beginAtZero: true,
            },
          },
        ],
      },
      tooltips: {
        mode: 'index',
        intersect: false,
        //        custom: function(tooltip) {
        //          if (!tooltip) return;
        //          tooltip.displayColors = false;
        //        },
        callbacks: {
          label: function (tooltipItem, data) {
            return getCommas(tooltipItem.yLabel) + ' coins';
          },
        },
      },
    },
  });
}

function makeOwnerPie(stuff, labels, id, title, colors) {
  new Chart(document.getElementById(id), {
    type: 'pie',
    data: {
      labels: labels,
      datasets: [
        {
          backgroundColor: colors,
          data: stuff,
        },
      ],
    },
    options: {
      title: {
        display: true,
        text: title,
      },
    },
  });
}

function makeOwnerPieHelper(data, id, title, valueKey) {
  let values = [];
  let labels = [];
  let colors = [];
  for (let key in data) {
    let d = data[key];
    let value = d[valueKey];
    if (!value) continue;
    values.push(Math.round(value));
    labels.push(d.label);
    colors.push(d.color);
  }

  return makeOwnerPie(values, labels, id, title, colors);
}

function ownerVerification(status, gainid) {
  const gainId = gainid || $('#ownerVerificationGainId').val();
  PatchRequest(`fc-api/users/${gainId}/verification-status-change`, {
    status: !!status,
  })
    .then((response) => {
      toastAlert(response.message);
    })
    .catch((error) => {
      console.log(error);
      toastAlert(error.responseJSON.errors[0] || error.responseJSON.message);
    });
}

$(document).on('click', '.ownerGainInsertChargebackBtn', function () {
  socket.emit('insertOwnerChargeback', {
    surveyid: $('#ownerGainInsertChargebackSurveyId').val(),
  });
});

$(document).on('click', '#ownerIoEmitBtn', function () {
  socket.emit('ownerIoEmit', {
    event: $('#ownerIoEmitEvent').val(),
    stuff: $('#ownerIoEmitString').val(),
  });
});

$(document).on('click', '.ownerRemoveGiftCard', function () {
  let cardId = $(this).attr('data-cardid');

  socket.emit('ownerRemoveGiftCard', {
    cardId: cardId,
  });
});

//Start Provider Adjustment

// Open Modal for Add new/Edit resource
const openDataModal = () => {
  const modalProps = {
    dismissible: false,
    onCloseEnd: () => {
      $('#balanceAdjustmentsDataForm').trigger('reset');
    },
  };
  openModal('#ownerBalanceAdjustmentsDataModel', null, null, modalProps);
};

$(document).on('click', '.ownerBalanceAdjustmentsAddData', function () {
  openDataModal();
});

$(document).on('click', '.ownerBalanceAdjustmentSaveData', function () {
  const pageData = {
    action: 'create',
    data: {
      provider: $('select[name="wall"]').val(),
      amount: $('#balanceAdjustAmount').val(),
      date: $('#balanceAdjustDate').val(),
    },
  };

  // Validations
  if (!pageData.data.provider) return toastAlert('Provider name is required.');
  if (!pageData.data.amount) return toastAlert('Valid amount is required.');
  if (!pageData.data.date) return toastAlert('Date is required');

  socket.emit('ownerBalanceAdjustment', pageData, (response) => {
    if (response.status === 200) {
      $('#balanceAdjustmentsDataForm').trigger('reset');
      $('#ownerBalanceAdjustmentsDataModel').modal('close');
      toastAlert(response.message || 'Data saved successfully!');
      $('#ownerPage').find(`[data-page='providerbalanceadjustment']`).trigger('click'); // Fetch data again
    } else {
      toastAlert('An error occured, please try again!');
    }
  });
});

// Owner Balance Adjustment Open Delete Confirmation Modal
$(document).on('click', '.balanceAdjustmentDeleteData', function () {
  const id = $(this).closest('tr').attr('data-id');
  $('#balanceAdjustmentConfirmDelete').attr('data-id', id); //Set id on modal
  openModal('#balanceAdjustmentDeleteModal', null, null, {
    dismissible: false,
  });
});

//Delete row
$(document).on('click', '#balanceAdjustmentConfirmDelete', function () {
  const pageData = {
    action: 'delete',
    data: {
      id: $(this).attr('data-id'),
    },
  };
  socket.emit('ownerBalanceAdjustment', pageData, (response) => {
    if (response.status === 200) {
      $(this).removeAttr('data-id');
      $('#balanceAdjustmentDeleteModal').modal('close');
      toastAlert(response.message || 'Data deleted successfully!');
      $('#ownerPage').find(`[data-page='providerbalanceadjustment']`).trigger('click'); // Fetch data again
    } else {
      toastAlert('An error occured, please try again!');
    }
  });
});

//End Provider Adjustment

const video = document.querySelector('#video');
const modalVideo = document.querySelector('#modal-video');
const button = document.querySelector('#playpause');
const modalButton = document.querySelector('#modal-playpause');
var clicked = false;
var modalClicked = false;

const play = (element) => {
  if (element.getAttribute('data-type') === 'video') {
    clicked = !clicked;
    button.style.mixBlendMode = 'overlay';

    if (clicked) {
      video.play();

      button.style.opacity = 0;
      button.src = 'public/img/pause.webp';
    } else {
      video.pause();

      button.style.opacity = 1;
      button.src = 'public/img/play.webp';
    }
  } else {
    modalClicked = !modalClicked;
    modalButton.style.mixBlendMode = 'overlay';

    if (modalClicked) {
      modalVideo.play();

      modalButton.style.opacity = 0;
      modalButton.src = 'public/img/pause.webp';
    } else {
      modalVideo.pause();

      modalButton.style.opacity = 1;
      modalButton.src = 'public/img/play.webp';
    }
  }
};

const enter = (element) => {
  if (element.getAttribute('data-type') === 'video') {
    clicked ? (button.style.opacity = 1) : null;
  } else {
    modalClicked ? (modalButton.style.opacity = 1) : null;
  }
};

const leave = (element) => {
  if (element.getAttribute('data-type') === 'video') {
    clicked ? (button.style.opacity = 0) : null;
  } else {
    modalClicked ? (modalButton.style.opacity = 0) : null;
  }
};

$(document).on('click', '.tosAgreeCheckbox', function () {
  let termsIsChecked = $('#tosTermsCheckbox').is(':checked');
  let privacyIsChecked = $('#tosPrivacyCheckbox').is(':checked');

  if (termsIsChecked && privacyIsChecked) {
    $('#modalGoogleBtnLink').attr('onclick', 'setTosAgreed()');
    $('#modalGoogleBtnLink').attr('href', '/fc-api/auth/google');
    $('#modalGoogleBtnLink').css('cursor', 'pointer');
    $('#modalSteamBtnLink').attr('onclick', 'setTosAgreed()');
    $('#modalSteamBtnLink').attr('href', '/fc-api/auth/steam');
    $('#modalSteamBtnLink').css('cursor', 'pointer');
  } else {
    $('#modalGoogleBtnLink').removeAttr('onclick');
    $('#modalGoogleBtnLink').removeAttr('href');
    $('#modalGoogleBtnLink').css('cursor', 'not-allowed');
    $('#modalSteamBtnLink').removeAttr('onclick');
    $('#modalSteamBtnLink').removeAttr('href');
    $('#modalSteamBtnLink').css('cursor', 'not-allowed');
  }
});

$(document).on('click', '.promoterNavBtn', function () {
  $('.rootPromoter').html(loaderHtml);
  socket.emit('renderRootPromoter', {
    page: $(this).attr('data-page'),
    paginatePage: $(this).attr('data-paginate') || 1,
  });
});

socket.on('renderRootPromoter', function (html) {
  $('.rootPromoter').html(html);
});

$(function () {
  $(document).on('click', '.social-item', function () {
    const $this = $(this);
    const refCodeUrl = encodeURIComponent(
      $('#copyRefLinkBtn').data('code') || 'https://freecash.com'
    );
    const text = getShareText(refCodeUrl);
    const social = $this.data('social');
    let url;
    switch (social) {
      case 'twitter':
        url = `https://twitter.com/share?url=${refCodeUrl}&text=${text}`;
        break;
      case 'fb':
        url = `https://www.facebook.com/sharer/sharer.php?u=${refCodeUrl}&quote=${text}`;
        break;
      case 'whatsapp':
        url = window.mobileCheck()
          ? `https://api.whatsapp.com/send?text=${text}`
          : `https://web.whatsapp.com/send?text=${text}`;
        break;
      case 'telegram':
        url = `https://t.me/share/url?url=${refCodeUrl}&text=${text}`;
        break;
      case 'mail':
        url = `mailto:?subject=Freecash&body=${text}`;
        break;
    }
    window.open(url, '_blank').focus();
  });

  //when opens in pwa
  $(document).on('click', '.social-btn', function () {
    if (!navigator.share) return;
    const refCodeUrl = $('#copyRefLinkBtn').data('code') || 'https://freecash.com';
    try {
      navigator.share({
        title: 'Freecash',
        text: getShareText(refCodeUrl),
        url: refCodeUrl,
      });
    } catch (error) {
      // Catch ShareError to stop it being sent to Sentry
    }
  });

  const getShareText = (refCodeUrl) => {
    return (
      `I’m earning money by completing tasks like testing apps or playing games on ${refCodeUrl}. ` +
      `If you sign up through my link you can open a free case and win up to $250.`
    );
  };
});

$(function () {
  $('body').on('showRollingCase', function (_event, data) {
    const $modal = $(data.modalId);
    const $rewardSlider = $modal.find('.rewards-slider');
    const $rewardItemTemplate = $modal.find('.reward-item').eq(0).clone();
    let rewardsHtml = '';
    const possibleAmountsCount = data.possibleAmountsCount || data.possibleAmounts.length;
    let firstLevelOffset = 7; // the 1st level could be repeated not often, then after 7 items
    let firstLevelOffsetLength = data.firstLevelOffsetLength || 1; // fist n number of items
    let firstLevelCurrentOffset = 0;
    let startLevel = 1; // start level of coins, f.e. 1 => $50
    for (let i = 0; i < 150; i++) {
      const rewardWinLevel = Math.floor(getNumberInRange(startLevel, possibleAmountsCount + 1)); //from 1 to n
      // if win level is 1 then exclude it from next possibilities
      if (rewardWinLevel <= firstLevelOffsetLength) {
        startLevel = firstLevelOffsetLength + 1;
        firstLevelCurrentOffset = 0;
      }
      // if last 1st level was more then 7 items ago then add it to possibilities
      if (firstLevelCurrentOffset >= firstLevelOffset) {
        startLevel = 1;
      }
      firstLevelCurrentOffset++;
      let amount = data.possibleAmounts[rewardWinLevel - 1];
      if (data.randomNumbers) {
        amount = getNumberInRange(data.possibleAmounts[rewardWinLevel], amount);
      }
      $rewardItemTemplate.find('.coin-amount').text(`$${amount.toFixed(2)}`);
      $rewardItemTemplate.attr('class', `reward-item win-size-${rewardWinLevel}`);
      rewardsHtml += $rewardItemTemplate[0].outerHTML;
    }
    $rewardSlider.html(rewardsHtml);
    openModal(data.modalId, null, data.onClose);
  });

  $('body').on('playRollingCase', function (_event, data) {
    const $modal = $(data.modalId);
    const $rewardSlider = $modal.find('.rewards-slider');
    const $winLine = $modal.find('.win-line');
    const $winItem = $rewardSlider.find('.reward-item').eq(90);
    const $winCelebration = $modal.find('.win-celebration');
    const slideLength =
      $winItem.position().left - $winLine.position().left + $winItem.outerWidth() / 2;
    if (typeof data.prePlay === 'function') data.prePlay();
    socket.emit(data.socketAction, data.socketData, function (socketResponse, error) {
      if (error) {
        if (typeof data.postPlay === 'function') data.postPlay(socketResponse);
        return;
      }
      const amount = socketResponse.coins / 1000;
      let winItemClass, winItemName;
      if (socketResponse.prize) {
        winItemClass = `win-prize-${socketResponse.prize.key}`;
        winItemName = socketResponse.prize.title;
      } else {
        const winLevel = data.possibleAmounts.indexOf(amount) + 1;
        winItemClass = `win-size-${winLevel}`;
        winItemName = `$${amount.toFixed(2)}`;
      }
      $winItem.attr('class', `reward-item ${winItemClass}`);
      $winItem.find('.coin-amount').text(winItemName);
      $winCelebration.addClass(winItemClass);
      $winCelebration.find('.coin-amount').text(winItemName);
      $modal.addClass('playing');
      $.keyframe.define([
        {
          name: 'streaks-slide',
          '0%': { transform: 'translateX(0)' },
          '100%': { transform: `translateX(-${slideLength}px)` },
        },
      ]);
      $(`${data.modalId} .rewards-slider`).playKeyframe({
        name: 'streaks-slide',
        duration: '6s',
        timingFunction: 'cubic-bezier(0.3, 0.9, 0.3, 1)',
        iterationCount: '1',
        direction: 'normal',
        fillMode: 'forwards',
        complete: function () {
          playEarnSound();
          let alert = data.successMessage;
          if (amount) alert = alert.replace(':amount', amount.toFixed(2));
          toastAlert(alert);
          $winItem.addClass('active');
          $modal.addClass('win');
          $animationElement = $(`${data.modalId} .win-animation`);
          $animationElement.removeClass('hide');
          addWinAnimation($animationElement);
          winAnimation.goToAndPlay(0, true);
          socket.emit('updateBalance', {}, () => {});
          if (typeof data.postPlay === 'function') data.postPlay(socketResponse);
        },
      });
    });
  });

  function addWinAnimation($element) {
    if ($element.data('animation-added')) return;
    $element.data('animation-added', true);
    winAnimation = bodymovin.loadAnimation({
      wrapper: $element[0],
      animType: 'svg',
      loop: false,
      autoplay: false,
      path: '/public/animations/winBox.json',
    });

    winAnimation.addEventListener('complete', () => {
      $element.addClass('hide');
    });
  }
});

///load animation lib
let winAnimation;
const script = document.createElement('script');
let bodymovinResolve;
var bodymovinPromise = new Promise((res, _rej) => {
  bodymovinResolve = res;
});
script.src = '/public/js/min/lottie.5.13.0.min.js';
script.crossorigin = 'anonymous';
script.onerror = (event) => window.reportScriptError(event, 'bodymovin-rolling-case');
script.async = true;
script.onload = function () {
  bodymovinResolve();
};
document.body.append(script);

function getTitleFromRoute(route) {
  if (!route) return;

  // Remove query string and trailing slash/question mark
  const cleanedRoute = route.split('?')[0].replace(/[/?]$/, '');
  const pathArr = cleanedRoute.split('/');

  if (pathArr[1] == 'earn') {
    return `Earn - Freecash.com`;
  } else if (pathArr[1] == 'myprofile') {
    return `Profile - Freecash.com`;
  } else if (pathArr[1] == 'mod') {
    return `Mod - Freecash.com`;
  } else if (pathArr[1] == 'leaderboard') {
    return `Leaderboard - Freecash.com`;
  } else if (pathArr[1] == 'user') {
    return `GainID ${pathArr[2]} - Freecash.com`;
  } else if (pathArr[1] == 'owner') {
    return `Owner - Freecash.com`;
  } else if (pathArr[1] == 'faq') {
    return `FAQ - Freecash.com`;
  } else if (pathArr[1] == 'privacy') {
    return `Privacy - Freecash.com`;
  } else if (pathArr[1] == 'contact') {
    return `Contact - Freecash.com`;
  } else if (pathArr[1] == 'offers') {
    return 'Offers - Freecash.com';
  } else if (pathArr[1] == 'rewards') {
    return `Rewards - Freecash.com`;
  } else if (pathArr[1] == 'my-offers') {
    return `My Offers - Freecash.com`;
  } else if (pathArr[1] == 'cashout') {
    return `Cashout - Freecash.com`;
  } else if (pathArr[1] == 'jackpot') {
    return `Arcade - Freecash.com`;
  } else if (pathArr[1] == 'affiliates') {
    return `Affiliates - Freecash.com`;
  } else if (pathArr[1] == 'surveys') {
    return `Surveys - Freecash.com`;
  } else if (pathArr[1] == 'cashback') {
    return `Cashback - Freecash.com`;
  } else if (pathArr[1] == 'external-offer') {
    return `External Offer - Freecash.com`;
  }

  return `Freecash: Free Cash, PayPal, Bitcoin & more! | Freecash.com `;
}

function notifyOneFlow() {
  if (window._1flow) {
    window._1flow('url_location_tracking');
  }
}

function pushState(route, state = {}) {
  notifyOneFlow();
  let title = getTitleFromRoute(route);
  if (route && route.split('/')[1] !== 'user') document.title = title;
  prevState = JSON.parse(JSON.stringify(window.history.state));
  window.history.pushState({ title: title, ...state }, '', route);
  currentState = JSON.parse(JSON.stringify(window.history.state));
  hasOpenModal = currentState && currentState.type === 'modal';
  return;
}

function replaceState(route) {
  let title = getTitleFromRoute(route);
  document.title = title;
  window.history.replaceState({ title: title }, '', route);
  return;
}

$(document).on('click', '.pageRoute', function (event) {
  selectedPage = $(this).attr('alma-page');
  let datRoute = $(this).attr('alma-route');
  const isRedirect = $(this).attr('alma-redirect');

  if (isRedirect) {
    window.location.href = datRoute;
    return;
  }

  let source = $(this).attr('class');

  openPage(selectedPage, datRoute, { source });
});

function handlePageChange(previousState) {
  const state = JSON.parse(JSON.stringify(window.history.state || {}));
  const { type, data, modalType } = state;

  const isModal = type === 'modal';

  if (hasOpenModal && previousState && previousState.type === 'modal' && previousState.modalType) {
    if (previousState.modalType === 'offer') {
      if (window.closeReactOfferModal) {
        window.closeReactOfferModal();
      }

      if (!isModal) {
        hasOpenModal = false;
        return true;
      }
    }

    if (previousState.modalType === 'userProfile') {
      if (window.closeReactUserModal) {
        window.closeReactUserModal();
      }

      if (!isModal) {
        hasOpenModal = false;
        return true;
      }
    }

    if (previousState.modalType === 'paymentStatus') {
      if (window.closeReactPaymentStatusModal) {
        window.closeReactPaymentStatusModal();
      }

      if (!isModal) {
        hasOpenModal = false;
        return true;
      }
    }
  }

  hasOpenModal = state && state.type === 'modal';

  if (!data || !modalType || type !== 'modal') {
    return false;
  }

  if (modalType === 'offer') {
    const { slug, source, offerPosition, offerOpenSourceCategory, openOptions, token } = data;

    if (window.openReactOfferModal) {
      window.openReactOfferModal(
        slug,
        Alpine.store('fcMain').isLiteMode,
        source,
        offerPosition,
        offerOpenSourceCategory,
        openOptions,
        token
      );
      return true;
    }
  }

  if (modalType === 'userProfile') {
    const { gainId } = data;

    if (gainId) {
      if (window.openReactUserModal) {
        window.openReactUserModal(gainId);
      }

      return true;
    }
  }

  if (modalType === 'paymentStatus') {
    const { paymentStatus, orderId } = data;

    if (paymentStatus) {
      if (window.openReactPaymentStatusModal) {
        window.openReactPaymentStatusModal(paymentStatus, orderId);
      }

      return true;
    }
  }

  return false;
}

function shouldHardReload() {
  try {
    const elapsedTimeInMilliseconds = performance.now();
    const elapsedTimeInSeconds = elapsedTimeInMilliseconds / 1000;
    const minutes = window?.app?.utils?.isAndroidApp?.() ? 3 : 5;

    // When user has been on the page for more than X minutes,
    // then we hard-reload the next time they navigate around
    if (elapsedTimeInSeconds >= 60 * minutes) {
      return true;
    }

    return false;
  } catch (error) {
    return false;
  }
}

window.PAGE_CACHE = {};

let fadeInTimer = undefined;

function openPage(selectedPage, datRoute, state) {
  if (socket?.connected === false) {
    window.location.href = datRoute;
    return;
  }

  if (selectedPage === 'offer' && (!state || !state.modalType || !state.type || !state.data)) {
    if (window.Sentry && window.Sentry.captureException) {
      const message = 'Offer opened with no source or position';
      window.Sentry.captureException(new Error(message), {
        fingerprint: [message],
        extra: {
          slug: datRoute,
        },
      });
    }

    const offerSlug = datRoute.split('/')[2];

    state = {
      type: 'modal',
      modalType: 'offer',
      data: {
        slug: offerSlug,
      },
    };
  }

  if (selectedPage == 'promo') return openModal('#promocodeModal');

  if (isTabletOrSmaller() && selectedPage !== 'chat' && state?.modalType !== 'userProfile') {
    closeChat();
  }

  pushState(datRoute, state);
  clearTimeout(fadeInTimer);

  const handled = handlePageChange(prevState);

  if (!handled) {
    window.dispatchEvent(new CustomEvent('fc:alma-page-changing', { detail: { selectedPage } }));
  }

  if (handled) {
    return;
  }

  $('#almaView').html('');
  $('#almaView').css('opacity', '0.001'); // Setting 0 is problematic for some browsers
  fadeInTimer = setTimeout(() => {
    // Failsafe mechanism in case transition animation doesn't work
    $('#almaView').css('opacity', '1');
  }, 3_000);

  if (shouldHardReload()) {
    const finalUrl = new URL(datRoute, window.location.origin);
    const timestamp = new Date().getTime();
    finalUrl.searchParams.set('_t', timestamp);

    window.location.href = finalUrl.toString();
    return;
  }

  currentBackRoute = datRoute;

  switch (selectedPage) {
    case 'mod':
      return socket.emit('renderMod', selectedPage);
    case 'promoter':
      return socket.emit('renderPromoter', selectedPage);
    case 'admin':
      return socket.emit('renderAdmin', selectedPage);
    case 'owner':
      return socket.emit('renderOwner', selectedPage);
    case 'monitoring':
      return socket.emit('renderMonitoring', selectedPage);
    case 'offers':
      const parts = datRoute.split('/');
      const category = parts[parts.length - 1];
      return socket.emit('render', selectedPage, 'renderPage', { category });
    default:
      if (!gainid && selectedPage.startsWith('withdraw/')) {
        const subPage = selectedPage.split('/')[1];
        return socket.emit('render', 'cashout', 'renderPage', { subPage });
      }

      socket.emit('render', selectedPage, 'renderPage');
  }
  $('.pageRoute.active').removeClass('active');
  $(`[alma-page='${selectedPage}']`).addClass('active');
}

window.onpopstate = function (e) {
  if (window.location.hash) return;

  notifyOneFlow();
  const newTitle = e.state && e.state.title;
  if (newTitle) {
    document.title = newTitle;
  }

  let path = window.location.pathname;
  let pathArr = path.split('/');

  if (pathArr[1] !== 'user') currentBackRoute = path;

  const handled = handlePageChange(currentState);

  prevState = JSON.parse(JSON.stringify(currentState));
  currentState = JSON.parse(JSON.stringify(window.history.state));

  // Do not reload the page if we are going back from a modal
  if (handled) {
    return;
  }

  // Some route are mapped differently to the directory structure
  const routeMappings = {
    worldcup: 'worldcup2022',
    worldcupaffiliate: 'worldcup2022Affiliate',
    christmas: 'christmas2022',
  };

  // $('.modal').modal('close');

  if (!pathArr[1]) {
    socket.emit('render', 'home', 'renderPage');
  } else if (pathArr[1] == 'earn' && pathArr[2]) {
    openSurveyModal(pathArr[2]);
  } else if (pathArr[1] == 'mod') {
    socket.emit('renderMod', 'mod');
  } else if (pathArr[1] === 'cashout' && pathArr[2]) {
    const page =
      pathArr[2] && pathArr[3] ? `withdraw/${pathArr[2]}/${pathArr[3]}` : `withdraw/${pathArr[2]}`;
    socket.emit('render', page, 'renderPage');
  } else if (pathArr[1] === 'christmas') {
    // No need to re-render the page, just close modal
    $('.modal.open').modal('close');
  } else {
    const pageToRender = pathArr[1] in routeMappings ? routeMappings[pathArr[1]] : pathArr[1];

    if (pageToRender === 'offer') {
      return;
    }

    socket.emit('render', pageToRender, 'renderPage');
  }
};

$(function () {
  $(document).on('click', '.signup-form .register-btn', function () {
    if (checkIframeAndNavigate('signup-form-register')) return;

    const $form = $(this).parents('.signup-form');
    const $email = $form.find('.email');
    const $password = $form.find('.password');
    const toastClass = $form.data('toast-class');
    const email = $email.val();
    const password = $password.val();

    const emailIsValid = validateInput($email);
    const passIsValid = validateInput($password);

    if (!emailIsValid || !passIsValid) {
      return toastAlert('Please fill out all fields', null, { classes: toastClass });
    }

    if (!validateEmail(email)) {
      return toastAlert('Please enter a valid email address.', null, { classes: toastClass });
    }

    if (!$form.find('.terms').is(':checked')) {
      return toastAlert('You need to agree to the Terms of Service.', null, {
        classes: toastClass,
      });
    }

    toastAlert('Signing Up...', null, { classes: toastClass });

    register(email, password).catch((error) => {
      let errorMessage = (error.errors && error.errors[0]) || error.message;
      toastAlert(errorMessage, null, { classes: toastClass });
    });
  });
});

/**
 * Sticky.js
 * Library for sticky elements written in vanilla javascript. With this library you can easily set sticky elements on your website. It's also responsive.
 *
 * @version 1.3.0
 * @author Rafal Galus <biuro@rafalgalus.pl>
 * @website https://rgalus.github.io/sticky-js/
 * @repo https://github.com/rgalus/sticky-js
 * @license https://github.com/rgalus/sticky-js/blob/master/LICENSE
 */

class Sticky {
  /**
   * Sticky instance constructor
   * @constructor
   * @param {string} selector - Selector which we can find elements
   * @param {string} options - Global options for sticky elements (could be overwritten by data-{option}="" attributes)
   */
  constructor(selector = '', options = {}) {
    this.selector = selector;
    this.elements = [];

    this.version = '1.3.0';

    this.vp = this.getViewportSize();
    this.body = document.querySelector('body');

    this.options = {
      wrap: options.wrap || false,
      wrapWith: options.wrapWith || '<span></span>',
      marginTop: options.marginTop || 0,
      marginBottom: options.marginBottom || 0,
      stickyFor: options.stickyFor || 0,
      stickyClass: options.stickyClass || null,
      stickyContainer: options.stickyContainer || 'body',
    };

    this.updateScrollTopPosition = this.updateScrollTopPosition.bind(this);

    this.updateScrollTopPosition();
    window.addEventListener('load', this.updateScrollTopPosition);
    window.addEventListener('scroll', this.updateScrollTopPosition);

    this.run();
  }

  /**
   * Function that waits for page to be fully loaded and then renders & activates every sticky element found with specified selector
   * @function
   */
  run() {
    // wait for page to be fully loaded
    const pageLoaded = setInterval(() => {
      if (document.readyState === 'complete') {
        clearInterval(pageLoaded);

        const elements = document.querySelectorAll(this.selector);
        this.forEach(elements, (element) => this.renderElement(element));
      }
    }, 10);
  }

  /**
   * Function that assign needed variables for sticky element, that are used in future for calculations and other
   * @function
   * @param {node} element - Element to be rendered
   */
  renderElement(element) {
    // create container for variables needed in future
    element.sticky = {};

    // set default variables
    element.sticky.active = false;

    element.sticky.marginTop =
      parseInt(element.getAttribute('data-margin-top')) || this.options.marginTop;
    element.sticky.marginBottom =
      parseInt(element.getAttribute('data-margin-bottom')) || this.options.marginBottom;
    element.sticky.stickyFor =
      parseInt(element.getAttribute('data-sticky-for')) || this.options.stickyFor;
    element.sticky.stickyClass =
      element.getAttribute('data-sticky-class') || this.options.stickyClass;
    element.sticky.wrap = element.hasAttribute('data-sticky-wrap') ? true : this.options.wrap;
    // @todo attribute for stickyContainer
    // element.sticky.stickyContainer = element.getAttribute('data-sticky-container') || this.options.stickyContainer;
    element.sticky.stickyContainer = this.options.stickyContainer;

    element.sticky.container = this.getStickyContainer(element);
    element.sticky.container.rect = this.getRectangle(element.sticky.container);

    element.sticky.rect = this.getRectangle(element);

    // fix when element is image that has not yet loaded and width, height = 0
    if (element.tagName.toLowerCase() === 'img') {
      element.onload = () => (element.sticky.rect = this.getRectangle(element));
    }

    if (element.sticky.wrap) {
      this.wrapElement(element);
    }

    // activate rendered element
    this.activate(element);
  }

  /**
   * Wraps element into placeholder element
   * @function
   * @param {node} element - Element to be wrapped
   */
  wrapElement(element) {
    element.insertAdjacentHTML(
      'beforebegin',
      element.getAttribute('data-sticky-wrapWith') || this.options.wrapWith
    );
    element.previousSibling.appendChild(element);
  }

  /**
   * Function that activates element when specified conditions are met and then initalise events
   * @function
   * @param {node} element - Element to be activated
   */
  activate(element) {
    if (
      element.sticky.rect.top + element.sticky.rect.height <
        element.sticky.container.rect.top + element.sticky.container.rect.height &&
      element.sticky.stickyFor < this.vp.width &&
      !element.sticky.active
    ) {
      element.sticky.active = true;
    }

    if (this.elements.indexOf(element) < 0) {
      this.elements.push(element);
    }

    if (!element.sticky.resizeEvent) {
      this.initResizeEvents(element);
      element.sticky.resizeEvent = true;
    }

    if (!element.sticky.scrollEvent) {
      this.initScrollEvents(element);
      element.sticky.scrollEvent = true;
    }

    this.setPosition(element);
  }

  /**
   * Function which is adding onResizeEvents to window listener and assigns function to element as resizeListener
   * @function
   * @param {node} element - Element for which resize events are initialised
   */
  initResizeEvents(element) {
    element.sticky.resizeListener = () => this.onResizeEvents(element);
    window.addEventListener('resize', element.sticky.resizeListener);
  }

  /**
   * Removes element listener from resize event
   * @function
   * @param {node} element - Element from which listener is deleted
   */
  destroyResizeEvents(element) {
    window.removeEventListener('resize', element.sticky.resizeListener);
  }

  /**
   * Function which is fired when user resize window. It checks if element should be activated or deactivated and then run setPosition function
   * @function
   * @param {node} element - Element for which event function is fired
   */
  onResizeEvents(element) {
    this.vp = this.getViewportSize();

    element.sticky.rect = this.getRectangle(element);
    element.sticky.container.rect = this.getRectangle(element.sticky.container);

    if (
      element.sticky.rect.top + element.sticky.rect.height <
        element.sticky.container.rect.top + element.sticky.container.rect.height &&
      element.sticky.stickyFor < this.vp.width &&
      !element.sticky.active
    ) {
      element.sticky.active = true;
    } else if (
      element.sticky.rect.top + element.sticky.rect.height >=
        element.sticky.container.rect.top + element.sticky.container.rect.height ||
      (element.sticky.stickyFor >= this.vp.width && element.sticky.active)
    ) {
      element.sticky.active = false;
    }

    this.setPosition(element);
  }

  /**
   * Function which is adding onScrollEvents to window listener and assigns function to element as scrollListener
   * @function
   * @param {node} element - Element for which scroll events are initialised
   */
  initScrollEvents(element) {
    element.sticky.scrollListener = () => this.onScrollEvents(element);
    window.addEventListener('scroll', element.sticky.scrollListener);
  }

  /**
   * Removes element listener from scroll event
   * @function
   * @param {node} element - Element from which listener is deleted
   */
  destroyScrollEvents(element) {
    window.removeEventListener('scroll', element.sticky.scrollListener);
  }

  /**
   * Function which is fired when user scroll window. If element is active, function is invoking setPosition function
   * @function
   * @param {node} element - Element for which event function is fired
   */
  onScrollEvents(element) {
    if (element.sticky && element.sticky.active) {
      this.setPosition(element);
    }
  }

  /**
   * Main function for the library. Here are some condition calculations and css appending for sticky element when user scroll window
   * @function
   * @param {node} element - Element that will be positioned if it's active
   */
  setPosition(element) {
    this.css(element, { position: '', width: '', top: '', left: '' });

    if (this.vp.height < element.sticky.rect.height || !element.sticky.active) {
      return;
    }

    if (!element.sticky.rect.width) {
      element.sticky.rect = this.getRectangle(element);
    }

    if (element.sticky.wrap) {
      this.css(element.parentNode, {
        display: 'block',
        width: element.sticky.rect.width + 'px',
        height: element.sticky.rect.height + 'px',
      });
    }

    if (element.sticky.rect.top === 0 && element.sticky.container === this.body) {
      this.css(element, {
        position: 'fixed',
        top: element.sticky.rect.top + 'px',
        left: element.sticky.rect.left + 'px',
        width: element.sticky.rect.width + 'px',
      });
      if (element.sticky.stickyClass) {
        element.classList.add(element.sticky.stickyClass);
      }
    } else if (this.scrollTop > element.sticky.rect.top - element.sticky.marginTop) {
      this.css(element, {
        position: 'fixed',
        width: element.sticky.rect.width + 'px',
        left: element.sticky.rect.left + 'px',
      });

      if (
        this.scrollTop + element.sticky.rect.height + element.sticky.marginTop >
        element.sticky.container.rect.top +
          element.sticky.container.offsetHeight -
          element.sticky.marginBottom
      ) {
        if (element.sticky.stickyClass) {
          element.classList.remove(element.sticky.stickyClass);
        }

        this.css(element, {
          top:
            element.sticky.container.rect.top +
            element.sticky.container.offsetHeight -
            (this.scrollTop + element.sticky.rect.height + element.sticky.marginBottom) +
            'px',
        });
      } else {
        if (element.sticky.stickyClass) {
          element.classList.add(element.sticky.stickyClass);
        }

        this.css(element, { top: element.sticky.marginTop + 'px' });
      }
    } else {
      if (element.sticky.stickyClass) {
        element.classList.remove(element.sticky.stickyClass);
      }

      this.css(element, { position: '', width: '', top: '', left: '' });

      if (element.sticky.wrap) {
        this.css(element.parentNode, { display: '', width: '', height: '' });
      }
    }
  }

  /**
   * Function that updates element sticky rectangle (with sticky container), then activate or deactivate element, then update position if it's active
   * @function
   */
  update() {
    this.forEach(this.elements, (element) => {
      element.sticky.rect = this.getRectangle(element);
      element.sticky.container.rect = this.getRectangle(element.sticky.container);

      this.activate(element);
      this.setPosition(element);
    });
  }

  /**
   * Destroys sticky element, remove listeners
   * @function
   */
  destroy() {
    window.removeEventListener('load', this.updateScrollTopPosition);
    window.removeEventListener('scroll', this.updateScrollTopPosition);

    this.forEach(this.elements, (element) => {
      this.destroyResizeEvents(element);
      this.destroyScrollEvents(element);
      delete element.sticky;
    });
  }

  /**
   * Function that returns container element in which sticky element is stuck (if is not specified, then it's stuck to body)
   * @function
   * @param {node} element - Element which sticky container are looked for
   * @return {node} element - Sticky container
   */
  getStickyContainer(element) {
    let container = element.parentNode;

    while (
      !container.hasAttribute('data-sticky-container') &&
      !container.parentNode.querySelector(element.sticky.stickyContainer) &&
      container !== this.body
    ) {
      container = container.parentNode;
    }

    return container;
  }

  /**
   * Function that returns element rectangle & position (width, height, top, left)
   * @function
   * @param {node} element - Element which position & rectangle are returned
   * @return {object}
   */
  getRectangle(element) {
    this.css(element, { position: '', width: '', top: '', left: '' });

    const width = Math.max(element.offsetWidth, element.clientWidth, element.scrollWidth);
    const height = Math.max(element.offsetHeight, element.clientHeight, element.scrollHeight);

    let top = 0;
    let left = 0;

    do {
      top += element.offsetTop || 0;
      left += element.offsetLeft || 0;
      element = element.offsetParent;
    } while (element);

    return { top, left, width, height };
  }

  /**
   * Function that returns viewport dimensions
   * @function
   * @return {object}
   */
  getViewportSize() {
    return {
      width: Math.max(document.documentElement.clientWidth, window.innerWidth || 0),
      height: Math.max(document.documentElement.clientHeight, window.innerHeight || 0),
    };
  }

  /**
   * Function that updates window scroll position
   * @function
   * @return {number}
   */
  updateScrollTopPosition() {
    this.scrollTop = (window.pageYOffset || document.scrollTop) - (document.clientTop || 0) || 0;
  }

  /**
   * Helper function for loops
   * @helper
   * @param {array}
   * @param {function} callback - Callback function (no need for explanation)
   */
  forEach(array, callback) {
    for (let i = 0, len = array.length; i < len; i++) {
      callback(array[i]);
    }
  }

  /**
   * Helper function to add/remove css properties for specified element.
   * @helper
   * @param {node} element - DOM element
   * @param {object} properties - CSS properties that will be added/removed from specified element
   */
  css(element, properties) {
    for (let property in properties) {
      if (properties.hasOwnProperty(property)) {
        element.style[property] = properties[property];
      }
    }
  }
}

$(function () {
  $(document).on(
    'click',
    '.survey-screenout-modal .screenout-close-btn, .survey-screenout-modal .screenout-btn',
    function () {
      const $modal = $('.survey-screenout-modal');
      $modal.modal('close');
      $modal.remove();
    }
  );
});

$(document).on('submit', '.formLookupUserForUnbanning', function (e) {
  e.preventDefault();

  const gainid = Number($('.unbanFreecashUserId').val());

  if (Number.isNaN(gainid)) {
    return;
  }

  socket.emit('lookupUserForUnbanning', { gainid }, function (res) {
    $('.userInfoHtml').html(res.userInfoHtml);
    $('.banHistoryHtml').html(res.userBanHistoryHtml);
  });
});

$(document).on('submit', '#frmUnbanUser', function (e) {
  e.preventDefault();

  const gainid = Number($('.unbanFreecashUserId').val());

  if (Number.isNaN(gainid)) {
    return;
  }

  socket.emit('modBan', {
    gainid,
    reason: $('.unbanReason').val(),
    type: 'unban',
  });

  // Reload the page after timeout
  // Because socket doesn't provide callback
  setTimeout(() => {
    $('.formLookupUserForUnbanning').trigger('submit');
  }, 1000);
});

$(function () {
  socketFC.on('user:banned', closeIntercom);
  socketFC.on('user:unbanned', closeIntercom);
  socketFC.on('user:frozen', closeIntercom);
  socketFC.on('user:unfrozen', closeIntercom);
  socketFC.on('user:finalBanned', shutdownIntercom);
});

(function () {
  const MODAL_ID = 'welcomeModal';
  const LOCAL_STORAGE_KEY = 'welcomeModalClosed';
  const FIRST_STEP = 1;
  const LAST_STEP = 5;
  function WelcomeModal() {
    this.step = FIRST_STEP;
    this.open = () => {
      let elem = document.getElementById(MODAL_ID);
      let instance = M.Modal.init(elem, {
        onCloseEnd: () => {
          let video = document.getElementById('welcomeModalVideo');
          if (video) video.pause();
          if (gainid) {
            setLocalStorage(LOCAL_STORAGE_KEY, '1');
          }
          instance.destroy();
        },
      });
      instance.open();
    };
    this.close = () => {
      let elem = document.getElementById(MODAL_ID);
      M.Modal.getInstance(elem).close();
    };
    this.nextStep = () => {
      if (this.step < LAST_STEP) this.step++;
      this.renderContent();
    };
    this.prevStep = () => {
      if (this.step > FIRST_STEP) this.step--;
      this.renderContent();
    };
    this.goToStep = (step) => {
      if (step > LAST_STEP || step < FIRST_STEP) return;
      this.step = step;
      this.renderContent();
    };
    this.renderContent = () => {
      let content = getWelcomeModalContent(this.step);
      let $modal = $(`#${MODAL_ID}`);
      $modal.find('.modal-content').html(content);
      const selectedClass = 'welcomeModalStepCircle--selected';
      $modal.find(`.${selectedClass}`).removeClass(selectedClass);
      $modal.find(`.welcomeModalStepCircle[data-step='${this.step}']`).addClass(selectedClass);
    };
  }

  window.app.welcomeModal = new WelcomeModal();
})();

class Widget {
  constructor(options) {
    const { selector, closable, hasTooltip } = options;

    this.selector = selector;
    this.refreshEl();

    this.$closeButtonContainer = this.$el.find('.widget-close-button-container');
    this.closable = closable;
    this.localStorageKey = `widget-${selector}-closed`;
    this.hasTooltip = hasTooltip;
  }

  refreshEl() {
    this.$el = $(this.selector);
  }

  remove() {
    this.$el.remove();
  }

  show() {
    this.$el.css('display', 'flex');
  }

  hide() {
    this.$el.css('display', 'none');
  }

  close() {
    this.remove();
    setLocalStorage(this.localStorageKey, 'true');
  }

  isPermanentlyClosed() {
    return getLocalStorage(this.localStorageKey) === 'true';
  }

  initTooltip() {
    $(this.$el).tooltip({
      placement: 'bottom',
    });
  }

  init() {
    if (this.$el) {
      if (this.isPermanentlyClosed()) {
        this.remove();
      } else {
        this.show();
        if (this.closable) {
          this.$el.on('click', '.widget-close-button', (e) => {
            e.preventDefault();
            e.stopPropagation();
            this.close();
          });
          this.$closeButtonContainer.show();
        } else {
          this.$closeButtonContainer.hide();
        }

        if (this.hasTooltip) {
          this.initTooltip();
        }
      }
    }
  }
}

class ServerSideWidget extends Widget {
  constructor(options) {
    super(options);
    this.socketEvent = options.socketEvent;
    this.socketRefreshEvent = options.socketRefreshEvent;
  }

  load() {
    return new Promise((resolve) => {
      socket.emit(this.socketEvent, {}, (widgetHtml) => {
        resolve(widgetHtml);
      });
    });
  }

  listenForRefresh() {
    socket.on(this.socketRefreshEvent, (html) => {
      this.replaceWith(html);
    });
  }

  replaceWith(html) {
    if (this.$el) {
      this.$el.replaceWith(html);
      this.refreshEl();
      this.show();
    }
  }

  async init() {
    const html = await this.load();
    this.replaceWith(html);

    super.init();

    if (!this.$el) {
      // Remove this widget if the element is not found
      // Some widgets container are not rendered by the server based on some conditions.
      this.remove();
    }

    this.listenForRefresh();
  }
}

function openWithdrawFeedbackModal(text, extra = {}) {
  let {
    title,
    showReviewButton,
    reviewUrl,
    showSiteJabberPopup,
    useTrustPilotInvitation,
    orderId,
    cashoutMethod,
    minWithdrawableCoins,
    withdrawableNowCoins,
  } = extra;

  if (!title) {
    const isSuccess = text.includes('leave us a review');
    title = isSuccess ? 'Successful cashout!' : 'Something went wrong';
  }

  if (text.includes('You must verify your E-mail') && !window.app.user.email) {
    window.dispatchEvent(new CustomEvent('fc:open-ghost-account-cashout-modal'));
    return;
  }

  window.dispatchEvent(
    new CustomEvent('fc:show-after-withdraw-popup', {
      detail: {
        title,
        text,
        showReviewButton,
        reviewUrl,
        showSiteJabberPopup,
        useTrustPilotInvitation,
        orderId,
        cashoutMethod,
        minWithdrawableCoins,
        withdrawableNowCoins,

        isInReview: (title || '').toLowerCase().includes('in review'),
        isSuccessful: (title || '').toLowerCase().includes('successful'),
      },
    })
  );
}

socket.on('withdrawFeedback', function (text, type, extra) {
  try {
    if (extra && extra.verifyID) {
      window.dispatchEvent(new CustomEvent('fc:reactapp:show-id-verification-modal'));
    } else if (extra && extra.verifyKYC) {
      KycVerificationService.startVerification();
    } else {
      openWithdrawFeedbackModal(text, extra);
    }
  } catch (err) {
    console.error(err);
    openWithdrawFeedbackModal('Something went wrong. Please refresh the page and try again');
  }
});

const pageLoadTime = performance.now();
let pageLoadIso;
if (typeof window.performance.timeOrigin === 'number' && !isNaN(window.performance.timeOrigin)) {
  pageLoadIso = new Date(window.performance.timeOrigin).toISOString();
} else {
  pageLoadIso = new Date().toISOString();
}

const AmplitudeService = {
  async trackAmplitudeEvent(eventName, eventProperties) {
    const elapsed = (performance.now() - pageLoadTime) / 1000;
    const eventPropsWithTime = {
      ...(eventProperties || {}),
      'Seconds Since Loaded': Number(elapsed.toFixed(3)),
      'Page Loaded At': pageLoadIso,
    };

    const time = Date.now();
    let insertId = undefined;

    if (typeof window?.FC?.amplitude?.generateInsertId === 'function') {
      insertId = window.FC.amplitude.generateInsertId({
        eventName,
      });
    }

    try {
      const response = await fetch('/acts-legacy', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify({
          eventName,
          insertId,
          time,
          eventProperties: eventPropsWithTime,
        }),
      });

      if (!response.ok) {
        throw new Error('Failed to track event');
      }

      return response.json();
    } catch (error) {
      console.error('Error sending tracking request:', error);
      if (window?.FC?.amplitude?.storeFailedEvent) {
        window.FC.amplitude.storeFailedEvent({
          name: eventName,
          properties: eventProperties,
          time,
          insertId,
        });
      }

      return null;
    }
  },
  sendUserProps({ level }) {
    if (level) {
      window.amplitude?.setUserProperties?.({
        level: level,
      });
    }
  },
  async bonusCodeEvent(codeStats) {
    const { name, group, subgroup, dateadded } = codeStats;
    await this.trackAmplitudeEvent('BonusCode', { name, group, subgroup, dateadded });
  },
  async signUpEvent({ platform, utm }) {
    this.sendUserProps({ utm });
    const eventProps = { platform };
    await this.trackAmplitudeEvent('SignUp', eventProps);
  },
  async signUpInitatedEvent({ source, method }) {
    const eventProps = { Source: source, 'Authentication method': method };
    await this.trackAmplitudeEvent('Sign Up Initiated', eventProps);
  },

  async signupButtonClickedEvent({ source, method, device }) {
    const eventProps = { Source: source, 'Authentication method': method, device };
    await this.trackAmplitudeEvent('Signup Button Clicked', eventProps);
  },
  async pageViewEvent({
    route,
    state = {},
    previousState = {},
    isInitialLoad = false,
    previousRoute = null,
  }) {
    if (!window.app.shouldTrackEvents) return;
    const eventName = AmplitudeService.getEventNameFromRoute(route);
    if (!eventName) return;

    // Prevent tracking navigation from rewards to rewards page
    // Happens when you go from Quests to Bonuses, and the other way around
    if (
      previousRoute &&
      previousRoute.startsWith('/rewards') &&
      route &&
      route.startsWith('/rewards')
    ) {
      return;
    }

    if (previousState.type === 'modal') return;
    const source = state.source ? state.source : isInitialLoad ? 'direct' : undefined;

    const o = {
      'Page route': route,
      'Page title': state.title,
      Source: source,
      'Previous route': previousRoute,
    };
    if (window.app.utils.isAndroidApp()) {
      window.freecashMessagePort?.then((port) => {
        port?.postMessage(
          JSON.stringify({
            messageType: 'EVENT',
            gainId: window?.app?.userId,
            email: window?.app?.user?.email,
            eventName: `CT ${eventName}`,
            data: o,
          })
        );
      });
    } else {
      window.clevertap?.event?.push(`CT ${eventName}`, o);
    }
    await this.trackAmplitudeEvent(eventName, o);
  },
  async mobileMenuClickedEvent() {
    await this.trackAmplitudeEvent('Mobile Menu Clicked');
  },
  getPlatform() {
    let platform = AnalyticsService.getPlatform();
    if (platform) return platform;
    let deviceWidth = Math.max(window.screen.width, window.outerWidth);

    if (deviceWidth <= 800) return 'mobile';
    return;
  },
  getEventNameFromRoute(url) {
    if (!url) return;

    // It's important to remove query parameters from the URL, otherwise
    // the checks below will fail when the URL contains query parameters.
    const route = url.split('?')[0];

    if (!route) return;

    const isTaboolaLp =
      document.querySelectorAll('#react-taboola-home-page, #react-taboola-home-page-v2').length > 0;
    if (route === '/' && isTaboolaLp) return 'Taboola Landing Page Visited';
    if (route === '/') {
      return window.app.userId ? 'Home Page Visited' : 'Landing Page Visited';
    }
    if (route === '/earn') return 'Earn Page Visited';
    if (route === '/cashout') return 'Cashout Page Visited';
    if (route === '/cashback') return 'Cashback Page Visited';
    if (route === '/leaderboard') return 'Leaderboard Page Visited';
    if (route === '/rewards') return 'Rewards Page Visited';
    if (route === '/affiliates') return 'Affiliates Page Visited';
    if (route === '/myprofile') return 'My Profile Page Visited';
    if (route === '/partners') return 'Partners Page Visited';
    if (route === '/surveys') return 'Surveys Page Visited';
    if (route.startsWith('/offers')) return 'Offers Page Visited';
    if (route.startsWith('/cashout')) return 'Withdrawal Option Visited';
    if (route.startsWith('/external-offer')) return 'External Offer Page Visited';
  },
};

const googleUtmSources = ['google', 'youtube'];

if (window.gainid) {
  dataLayer.push({
    user: {
      email: window.email,
      user_id: window.gainid,
    },
  });
}

const tvSquaredSignupEvent = () => {
  if (!window.cookiehub?.hasConsented('marketing') || window.countryHeader !== 'DE') return;

  window._tvq = window._tvq || [];

  const _tvq = window._tvq;

  const session = { user: window.gainid };
  const actionname = 'signupformcompletion_v2';
  const action = {
    rev: '0',
    prod: 'NEW',
    id: window.gainid,
    promo: window.gainid,
  };

  const u =
    'https:' == document.location.protocol
      ? 'https://collector-45913.tvsquared.com/'
      : 'http://collector-45913.tvsquared.com/';

  _tvq.push(['setSiteId', 'TV-5445098163-1']);
  _tvq.push(['setTrackerUrl', u + 'tv2track.php']);
  _tvq.push([
    function () {
      this.setCustomVariable(5, 'session', JSON2.stringify(session), 'visit');
    },
  ]);
  _tvq.push([
    function () {
      this.setCustomVariable(5, actionname, JSON2.stringify(action), 'page');
    },
  ]);
  _tvq.push(['trackPageView']);
};

const AnalyticsService = {
  async signupConversion() {
    if (window.gainid) {
      if (window.countryHeader === 'DE') {
        fetch(
          `https://freecash.com/fc-api/health?purpose=tvsquare-log-trigger&user-id=${window.gainid}`
        );
        tvSquaredSignupEvent();
      }

      dataLayer.push({ event: 'signup' });
      dataLayer3.push({ event: 'signup' });

      if (googleUtmSources.includes(app.utm.source)) {
        dataLayer.push({ event: 'googleSignUp' });
      }
    }

    const platform = AnalyticsService.getPlatform();
    AmplitudeService.signUpEvent({ platform, utm: app.utm });
  },
  getPlatform() {
    if (app.utils.isAppOrWebApp()) return app.appSource;
  },
  pageView(props) {
    AmplitudeService.pageViewEvent(props);
  },
  bonusCodeUsed(codeStats) {
    AmplitudeService.bonusCodeEvent(codeStats);
  },
  signupInitated({ source, method, device }) {
    AmplitudeService.signUpInitatedEvent({ source, method, device });
  },

  signupButtonClicked({ source, method, device }) {
    AmplitudeService.signupButtonClickedEvent({ source, method, device });
  },
  mobileMenuClickedEvent() {
    AmplitudeService.mobileMenuClickedEvent();
  },
  onInitialLoad() {
    window.addEventListener('pageChanged', (e) => {
      this.pageView({
        state: e.detail.state || {},
        previousState: e.detail.previousState || {},
        previousRoute: e.detail.previousUrl,
        route: e.detail.url,
        isInitialLoad: false,
      });
    });

    this.pageView({
      state: { title: document.title },
      previousState: {},
      route: window.location.pathname,
      isInitialLoad: true,
    });

    if (!window.gainid) {
      window.addEventListener('signupInitiated', (e) => {
        this.signupInitated({
          source: e.detail.source,
          method: e.detail.method,
          device: e.detail.device,
        });
      });
    }
    if (!window.gainid) {
      window.addEventListener('signupButtonClicked', (e) => {
        this.signupButtonClicked({
          source: e.detail.source,
          method: e.detail.method,
          device: e.detail.device,
        });
      });
    }
  },
};

window.KycVerificationService = {
  startVerification() {
    if (window.ReactApp && window.ReactApp.openBiometricVerificationModal) {
      window.ReactApp.openBiometricVerificationModal();
    }
  },
};

class Currency {
  static mode = {
    coins: 'coins',
    currency: 'currency',
  };

  static getMode() {
    return getLocalStorage('showCurrency') === 'true'
      ? Currency.mode.currency
      : Currency.mode.coins;
  }

  static getOtherMode() {
    return Currency.getMode() === Currency.mode.currency
      ? Currency.mode.coins
      : Currency.mode.currency;
  }

  static getFiatCurrency() {
    try {
      return Alpine.store('fcMain').fiatCurrency;
    } catch (err) {
      return 'USD';
    }
  }

  static getFiatExchangeRate() {
    try {
      return Alpine.store('fcMain').fiatExchangeRate;
    } catch (err) {
      return 1;
    }
  }

  static getFiatCurrencySymbol() {
    try {
      return Alpine.store('fcMain').getFiatCurrencySymbol();
    } catch (err) {
      return '$';
    }
  }

  static shouldShowSymbolAsSuffix() {
    try {
      return Alpine.store('fcMain').shouldShowSymbolAsSuffix();
    } catch (err) {
      return false;
    }
  }

  static getModeValue(mode, value, addCurrencyPrefix, addCurrencySuffix, addCoinsSuffix) {
    const coinRate = 1000 * (1 / this.getFiatExchangeRate());
    const symbol = this.getFiatCurrencySymbol();

    let modeValue =
      mode === Currency.mode.currency
        ? `${addCurrencyPrefix ? symbol : ''}${getCommasFixed2(
            (value > 1000 ? Math.floor(value / 10) * 10 : value) / coinRate
          )}`
        : getCommas(value);

    if (mode === Currency.mode.currency && addCurrencySuffix) {
      modeValue += ` ${symbol}`;
    } else if (mode === Currency.mode.coins && addCoinsSuffix) {
      modeValue += ' coins';
    }

    return modeValue;
  }

  /*
    When displaying in USD, the last digit of coins is not significant.
    This function rounds it down to the nearest 10

    For example:
      499 -> 490
      500 -> 500
      501 -> 500
      519 -> 510
  */
  static removeInsignificantDigits(number) {
    return Math.floor(number / 10) * 10;
  }

  static getValue(coins, addCurrencyPrefix = true, addCurrencySuffix = false, addCoinsSuffix) {
    let value = parseInt(coins, 10) || 0;
    value = Currency.getMode() === 'currency' ? Currency.removeInsignificantDigits(value) : value;

    if (this.shouldShowSymbolAsSuffix()) {
      addCurrencyPrefix = false;
      addCurrencySuffix = true;
    } else {
      addCurrencyPrefix = true;
      addCurrencySuffix = false;
    }

    return Currency.getModeValue(
      Currency.getMode(),
      value,
      addCurrencyPrefix,
      addCurrencySuffix,
      addCoinsSuffix
    );
  }

  static getOtherValue(coins, addUSDPrefix) {
    const value = parseInt(coins, 10) || 0;
    return Currency.getModeValue(Currency.getOtherMode(), value, addUSDPrefix);
  }

  static getIcon() {
    const mode = Currency.getMode();
    if (mode === Currency.mode.currency) return null;
    return `/public/img/icons/coins.svg`;
  }

  static setMode(newMode) {
    setLocalStorage('showCurrency', newMode === Currency.mode.currency);
    window.dispatchEvent(new CustomEvent('currencyModeChanged', { detail: newMode }));

    this.onCurrencyModeChanged();
  }

  static toggle() {
    const mode = Currency.getMode();
    const newMode = mode === Currency.mode.currency ? Currency.mode.coins : Currency.mode.currency;

    setLocalStorage('showCurrency', newMode === Currency.mode.currency);
    window.dispatchEvent(new CustomEvent('currencyModeChanged', { detail: newMode }));

    this.onCurrencyModeChanged();
  }

  static onCurrencyModeChanged() {
    const mode = Currency.getMode();
    $('.currency-input').each(function () {
      let value = $(this).val();

      if (value && value.trim() !== '') {
        let value = Number($(this).val());

        if (!Number.isNaN(value)) {
          $(this).val(Currency.convertFromOldMode(mode, value)).change();
        }
      }
    });

    if (window.ReactApp && window.ReactApp.onCurrencySwitch) {
      window.ReactApp.onCurrencySwitch(mode === Currency.mode.currency);
    }

    Currency.updateCurrencyValues();
  }

  static updateCurrencyValues() {
    // Change currency for all coins values throughout the page
    $('.currency-value').each(function () {
      let coins = $(this).attr('data-coins-value');

      if (coins && coins.replace) {
        coins = coins.replace(/,/g, '');
      }

      $(this).text(
        Currency.getValue(
          coins,
          $(this).data('show-usd-prefix'),
          $(this).data('show-currency-suffix'),
          $(this).data('show-coins-suffix')
        )
      );
    });

    $('.streak-rewards-currency-value').each(function () {
      let coins = $(this).attr('data-coins-value');

      if (coins && coins.replace) {
        coins = coins.replace(/,/g, '');
      }

      const mode = Currency.getMode();

      const [min, max] = coins.split('-');
      if (min && max) {
        if (mode === Currency.mode.currency) {
          $(this).text(`Up to ${Currency.getValue(max, true)}`);
        } else {
          $(this).text(`${Currency.getValue(min)} - ${Currency.getValue(max)} coins`);
        }
      } else {
        $(this).text(
          `${Currency.getValue(coins)} ${mode === Currency.mode.coins ? 'coins' : 'dollars'}`
        );
      }
    });

    $('.currency-placeholder').each(function () {
      const mode = Currency.getMode();
      $(this).attr(
        'placeholder',
        $(this).data(mode === Currency.mode.currency ? 'currency-placeholder' : 'coins-placeholder')
      );
    });

    $('.currency-dynamic-text').each(function () {
      $(this).text(Currency.select($(this).data('coins-text'), $(this).data('currency-text')));
    });

    $('.currency-icon').attr('src', Currency.getIcon());
  }

  static getCoinValue(value) {
    const coinRate = 1000 * this.getFiatExchangeRate();

    if (Currency.getMode() === Currency.mode.currency) {
      return Number(value) * coinRate;
    }

    return value;
  }

  static select(coinValue, currencyValue) {
    return Currency.getMode() === Currency.mode.currency ? currencyValue : coinValue;
  }

  static convertFromOldMode(newMode, value) {
    const coinRate = 1000 * this.getFiatExchangeRate();

    // Eg if newMode is coins and old mode is currency, we need to convert the value to coins
    if (newMode !== Currency.mode.currency) {
      // Convert from currency to coins
      return value * coinRate;
    }

    // Convert from coins to currency
    return value / coinRate;
  }
}

function GetRequest(URL, query) {
  const urlSearchParams = new URLSearchParams();
  for (const key in query) {
    urlSearchParams.append(key, query[key]);
  }
  const url = URL + (query ? '?' + urlSearchParams.toString() : '');
  return RequestBlueprint(url, undefined, 'GET');
}

/**
 * Basic POST request with ajax. Endpoint will be current URL (e.g. freecash.com/URL)
 * @param URL The route in the API (e.g. /auth/login)
 * @param data
 * @returns {Promise<any>}
 */
function PostRequest(URL, data, headers) {
  return RequestBlueprint(URL, data, 'POST', headers);
}

function PatchRequest(URL, data, headers) {
  return RequestBlueprint(URL, data, 'PATCH', headers);
}

function DeleteRequest(URL, data, headers) {
  return RequestBlueprint(URL, data, 'DELETE', headers);
}

function RequestBlueprint(URL, data, type, headers) {
  return new Promise((resolve, reject) => {
    $.ajax({
      type,
      url: '/' + URL,
      data: data ? JSON.stringify(data) : undefined,
      contentType: 'application/json',
      dataType: 'json',
      headers: headers,
      success: (result) => {
        resolve(result);
      },
      error: (error) => {
        reject(error);
      },
    });
  });
}